const keelungBus = [{
    "RouteUID": "KEE1011",
    "RouteID": "1011",
    "RouteName": {
        "Zh_tw": "101 和平島-經中正路",
        "En": "101 Heping Island - Via Zhongzheng Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1011",
    "SubRouteID": "1011",
    "SubRouteName": {
        "Zh_tw": "101 和平島-經中正路",
        "En": "101 Heping Island - Via Zhongzheng Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2",
        "StopID": "2",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.155283,
            "PositionLon": 121.7696
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE17",
        "StopID": "17",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.142485,
            "PositionLon": 121.760703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1011",
    "RouteID": "1011",
    "RouteName": {
        "Zh_tw": "101 和平島-經中正路",
        "En": "101 Heping Island - Via Zhongzheng Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1011",
    "SubRouteID": "1011",
    "SubRouteName": {
        "Zh_tw": "101 和平島-經中正路",
        "En": "101 Heping Island - Via Zhongzheng Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE40",
        "StopID": "40",
        "StopName": {
            "Zh_tw": "正榮街口",
            "En": "Zhengrong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.143035,
            "PositionLon": 121.761113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3477",
        "StopID": "3477",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144501,
            "PositionLon": 121.761641
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3478",
        "StopID": "3478",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14589,
            "PositionLon": 121.761692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE43",
        "StopID": "43",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.149321,
            "PositionLon": 121.763788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE44",
        "StopID": "44",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15062,
            "PositionLon": 121.765798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE45",
        "StopID": "45",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151033,
            "PositionLon": 121.766816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE46",
        "StopID": "46",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.152483,
            "PositionLon": 121.768616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3521",
        "StopID": "3521",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)(返)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9",
        "StopID": "9",
        "StopName": {
            "Zh_tw": "和平島(返)",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE15",
        "StopID": "15",
        "StopName": {
            "Zh_tw": "協同造船廠(返)",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3524",
        "StopID": "3524",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.156185,
            "PositionLon": 121.770581
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1013",
    "RouteID": "1013",
    "RouteName": {
        "Zh_tw": "101 和平島-經祥豐街",
        "En": "101 Heping Island - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1013",
    "SubRouteID": "1013",
    "SubRouteName": {
        "Zh_tw": "101 和平島-經祥豐街",
        "En": "101 Heping Island - Via Xiangfeng St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2",
        "StopID": "2",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.155283,
            "PositionLon": 121.7696
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1013",
    "RouteID": "1013",
    "RouteName": {
        "Zh_tw": "101 和平島-經祥豐街",
        "En": "101 Heping Island - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1013",
    "SubRouteID": "1013",
    "SubRouteName": {
        "Zh_tw": "101 和平島-經祥豐街",
        "En": "101 Heping Island - Via Xiangfeng St."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3521",
        "StopID": "3521",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)(返)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9",
        "StopID": "9",
        "StopName": {
            "Zh_tw": "和平島(返)",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE15",
        "StopID": "15",
        "StopName": {
            "Zh_tw": "協同造船廠(返)",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3524",
        "StopID": "3524",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.156185,
            "PositionLon": 121.770581
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1021",
    "RouteID": "1021",
    "RouteName": {
        "Zh_tw": "102 和平島-經祥豐街(經仁五路)",
        "En": "102 Heping Island - Via Xiangfeng St.(Ren 5th Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1021",
    "SubRouteID": "1021",
    "SubRouteName": {
        "Zh_tw": "102 和平島-經祥豐街(經仁五路)",
        "En": "102 Heping Island - Via Xiangfeng St.(Ren 5th Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2",
        "StopID": "2",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.155283,
            "PositionLon": 121.7696
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1021",
    "RouteID": "1021",
    "RouteName": {
        "Zh_tw": "102 和平島-經祥豐街(經仁五路)",
        "En": "102 Heping Island - Via Xiangfeng St.(Ren 5th Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1021",
    "SubRouteID": "1021",
    "SubRouteName": {
        "Zh_tw": "102 和平島-經祥豐街(經仁五路)",
        "En": "102 Heping Island - Via Xiangfeng St.(Ren 5th Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3521",
        "StopID": "3521",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)(返)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9",
        "StopID": "9",
        "StopName": {
            "Zh_tw": "和平島(返)",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE15",
        "StopID": "15",
        "StopName": {
            "Zh_tw": "協同造船廠(返)",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3524",
        "StopID": "3524",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.156185,
            "PositionLon": 121.770581
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1031",
    "RouteID": "1031",
    "RouteName": {
        "Zh_tw": "103 八斗子-經中正路(經海科館)",
        "En": "103 Badouzi - Via Zhongzheng Rd.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1031",
    "SubRouteID": "1031",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經中正路(經海科館)",
        "En": "103 Badouzi - Via Zhongzheng Rd.(National Museum of Marine Science & Technology)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9925",
        "StopID": "9925",
        "StopName": {
            "Zh_tw": "基隆漁會(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9926",
        "StopID": "9926",
        "StopName": {
            "Zh_tw": "八斗子(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9927",
        "StopID": "9927",
        "StopName": {
            "Zh_tw": "海科館(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9928",
        "StopID": "9928",
        "StopName": {
            "Zh_tw": "望海巷(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE17",
        "StopID": "17",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.142485,
            "PositionLon": 121.760703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1031",
    "RouteID": "1031",
    "RouteName": {
        "Zh_tw": "103 八斗子-經中正路(經海科館)",
        "En": "103 Badouzi - Via Zhongzheng Rd.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1031",
    "SubRouteID": "1031",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經中正路(經海科館)",
        "En": "103 Badouzi - Via Zhongzheng Rd.(National Museum of Marine Science & Technology)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE40",
        "StopID": "40",
        "StopName": {
            "Zh_tw": "正榮街口",
            "En": "Zhengrong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.143035,
            "PositionLon": 121.761113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3477",
        "StopID": "3477",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.144501,
            "PositionLon": 121.761641
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3478",
        "StopID": "3478",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14589,
            "PositionLon": 121.761692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE43",
        "StopID": "43",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.149321,
            "PositionLon": 121.763788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE44",
        "StopID": "44",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.15062,
            "PositionLon": 121.765798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE45",
        "StopID": "45",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.151033,
            "PositionLon": 121.766816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE46",
        "StopID": "46",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152483,
            "PositionLon": 121.768616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE103",
        "StopID": "103",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.151611,
            "PositionLon": 121.770686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE181",
        "StopID": "181",
        "StopName": {
            "Zh_tw": "八斗子(返)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE182",
        "StopID": "182",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)(返)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1032",
    "RouteID": "1032",
    "RouteName": {
        "Zh_tw": "103 八斗子-經祥豐街(經海科館)",
        "En": "103 Badouzi - Via Xiangfeng St.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1032",
    "SubRouteID": "1032",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經祥豐街(經海科館)",
        "En": "103 Badouzi - Via Xiangfeng St.(National Museum of Marine Science & Technology)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9925",
        "StopID": "9925",
        "StopName": {
            "Zh_tw": "基隆漁會(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9926",
        "StopID": "9926",
        "StopName": {
            "Zh_tw": "八斗子(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9927",
        "StopID": "9927",
        "StopName": {
            "Zh_tw": "海科館(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9928",
        "StopID": "9928",
        "StopName": {
            "Zh_tw": "望海巷(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1032",
    "RouteID": "1032",
    "RouteName": {
        "Zh_tw": "103 八斗子-經祥豐街(經海科館)",
        "En": "103 Badouzi - Via Xiangfeng St.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1032",
    "SubRouteID": "1032",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經祥豐街(經海科館)",
        "En": "103 Badouzi - Via Xiangfeng St.(National Museum of Marine Science & Technology)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE181",
        "StopID": "181",
        "StopName": {
            "Zh_tw": "八斗子(返)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE182",
        "StopID": "182",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)(返)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1033",
    "RouteID": "1033",
    "RouteName": {
        "Zh_tw": "103 八斗子-經仁一路(經海科館)",
        "En": "103 Badouzi - Via Ren 1st Rd.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1033",
    "SubRouteID": "1033",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經仁一路(經海科館)",
        "En": "103 Badouzi - Via Ren 1st Rd.(National Museum of Marine Science & Technology)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1033",
    "RouteID": "1033",
    "RouteName": {
        "Zh_tw": "103 八斗子-經仁一路(經海科館)",
        "En": "103 Badouzi - Via Ren 1st Rd.(National Museum of Marine Science & Technology)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1033",
    "SubRouteID": "1033",
    "SubRouteName": {
        "Zh_tw": "103 八斗子-經仁一路(經海科館)",
        "En": "103 Badouzi - Via Ren 1st Rd.(National Museum of Marine Science & Technology)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3490",
        "StopID": "3490",
        "StopName": {
            "Zh_tw": "電力公司",
            "En": "Taiwan Power Company of Keelung City"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129606,
            "PositionLon": 121.74556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3491",
        "StopID": "3491",
        "StopName": {
            "Zh_tw": "愛六路口",
            "En": "Ai 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.747583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE437",
        "StopID": "437",
        "StopName": {
            "Zh_tw": "劉銘傳路口",
            "En": "Liumingchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128033,
            "PositionLon": 121.751383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE438",
        "StopID": "438",
        "StopName": {
            "Zh_tw": "愛九路口",
            "En": "Ai 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12785,
            "PositionLon": 121.753133
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE439",
        "StopID": "439",
        "StopName": {
            "Zh_tw": "仁一路27號",
            "En": "No.27, Ren 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127983,
            "PositionLon": 121.755883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE440",
        "StopID": "440",
        "StopName": {
            "Zh_tw": "月眉路口",
            "En": "Yuemei Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.12795,
            "PositionLon": 121.75755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE460",
        "StopID": "460",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137713,
            "PositionLon": 121.78848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE461",
        "StopID": "461",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136563,
            "PositionLon": 121.794725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE182",
        "StopID": "182",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)(返)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE183",
        "StopID": "183",
        "StopName": {
            "Zh_tw": "望海巷(返)",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE187",
        "StopID": "187",
        "StopName": {
            "Zh_tw": "八斗子車站(返)",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE191",
        "StopID": "191",
        "StopName": {
            "Zh_tw": "望海巷(返站)",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE192",
        "StopID": "192",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)(返站)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE193",
        "StopID": "193",
        "StopName": {
            "Zh_tw": "八斗子(返站)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE174",
        "StopID": "174",
        "StopName": {
            "Zh_tw": "八斗子分站(返)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.143521,
            "PositionLon": 121.790768
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1041",
    "RouteID": "1041",
    "RouteName": {
        "Zh_tw": "104 新豐街-經中正路",
        "En": "104 Xinfeng St. - Via Zhongzheng Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1041",
    "SubRouteID": "1041",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經中正路",
        "En": "104 Xinfeng St. - Via Zhongzheng Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE237",
        "StopID": "237",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.135676,
            "PositionLon": 121.779916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE238",
        "StopID": "238",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134931,
            "PositionLon": 121.782438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE243",
        "StopID": "243",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE244",
        "StopID": "244",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE17",
        "StopID": "17",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.142485,
            "PositionLon": 121.760703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1041",
    "RouteID": "1041",
    "RouteName": {
        "Zh_tw": "104 新豐街-經中正路",
        "En": "104 Xinfeng St. - Via Zhongzheng Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1041",
    "SubRouteID": "1041",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經中正路",
        "En": "104 Xinfeng St. - Via Zhongzheng Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE40",
        "StopID": "40",
        "StopName": {
            "Zh_tw": "正榮街口",
            "En": "Zhengrong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.143035,
            "PositionLon": 121.761113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3477",
        "StopID": "3477",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144501,
            "PositionLon": 121.761641
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3478",
        "StopID": "3478",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14589,
            "PositionLon": 121.761692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE43",
        "StopID": "43",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.149321,
            "PositionLon": 121.763788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE44",
        "StopID": "44",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15062,
            "PositionLon": 121.765798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE45",
        "StopID": "45",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151033,
            "PositionLon": 121.766816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE46",
        "StopID": "46",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.152483,
            "PositionLon": 121.768616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE103",
        "StopID": "103",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151611,
            "PositionLon": 121.770686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE297",
        "StopID": "297",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE298",
        "StopID": "298",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE299",
        "StopID": "299",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1042",
    "RouteID": "1042",
    "RouteName": {
        "Zh_tw": "104 新豐街-經祥豐街",
        "En": "104 Xinfeng St. - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1042",
    "SubRouteID": "1042",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經祥豐街",
        "En": "104 Xinfeng St. - Via Xiangfeng St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE237",
        "StopID": "237",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.135676,
            "PositionLon": 121.779916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE238",
        "StopID": "238",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134931,
            "PositionLon": 121.782438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE243",
        "StopID": "243",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE244",
        "StopID": "244",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1042",
    "RouteID": "1042",
    "RouteName": {
        "Zh_tw": "104 新豐街-經祥豐街",
        "En": "104 Xinfeng St. - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1042",
    "SubRouteID": "1042",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經祥豐街",
        "En": "104 Xinfeng St. - Via Xiangfeng St."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE297",
        "StopID": "297",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE298",
        "StopID": "298",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE299",
        "StopID": "299",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1043",
    "RouteID": "1043",
    "RouteName": {
        "Zh_tw": "104 新豐街-經仁一路",
        "En": "104 Xinfeng St. - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1043",
    "SubRouteID": "1043",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經仁一路",
        "En": "104 Xinfeng St. - Via Ren 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE237",
        "StopID": "237",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.135676,
            "PositionLon": 121.779916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE238",
        "StopID": "238",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134931,
            "PositionLon": 121.782438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE243",
        "StopID": "243",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE244",
        "StopID": "244",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE297",
        "StopID": "297",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE298",
        "StopID": "298",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE299",
        "StopID": "299",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1043",
    "RouteID": "1043",
    "RouteName": {
        "Zh_tw": "104 新豐街-經仁一路",
        "En": "104 Xinfeng St. - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1043",
    "SubRouteID": "1043",
    "SubRouteName": {
        "Zh_tw": "104 新豐街-經仁一路",
        "En": "104 Xinfeng St. - Via Ren 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3490",
        "StopID": "3490",
        "StopName": {
            "Zh_tw": "電力公司",
            "En": "Taiwan Power Company of Keelung City"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129606,
            "PositionLon": 121.74556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3491",
        "StopID": "3491",
        "StopName": {
            "Zh_tw": "愛六路口",
            "En": "Ai 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.747583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE437",
        "StopID": "437",
        "StopName": {
            "Zh_tw": "劉銘傳路口",
            "En": "Liumingchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128033,
            "PositionLon": 121.751383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE438",
        "StopID": "438",
        "StopName": {
            "Zh_tw": "愛九路口",
            "En": "Ai 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12785,
            "PositionLon": 121.753133
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE439",
        "StopID": "439",
        "StopName": {
            "Zh_tw": "仁一路27號",
            "En": "No.27, Ren 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127983,
            "PositionLon": 121.755883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE440",
        "StopID": "440",
        "StopName": {
            "Zh_tw": "月眉路口",
            "En": "Yuemei Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.12795,
            "PositionLon": 121.75755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE251",
        "StopID": "251",
        "StopName": {
            "Zh_tw": "海中天社區(返)",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE252",
        "StopID": "252",
        "StopName": {
            "Zh_tw": "巴賽隆納社區(返)",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE253",
        "StopID": "253",
        "StopName": {
            "Zh_tw": "碧海擎天社區(返)",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE254",
        "StopID": "254",
        "StopName": {
            "Zh_tw": "普羅旺世社區(返)",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE255",
        "StopID": "255",
        "StopName": {
            "Zh_tw": "八斗高中(返)",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE256",
        "StopID": "256",
        "StopName": {
            "Zh_tw": "福泉寺(返)",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE257",
        "StopID": "257",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)返)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE258",
        "StopID": "258",
        "StopName": {
            "Zh_tw": "福泉寺(返)",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE259",
        "StopID": "259",
        "StopName": {
            "Zh_tw": "八斗高中(返)",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE260",
        "StopID": "260",
        "StopName": {
            "Zh_tw": "普羅旺世社區(返)",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE261",
        "StopID": "261",
        "StopName": {
            "Zh_tw": "碧海擎天社區(返)",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE262",
        "StopID": "262",
        "StopName": {
            "Zh_tw": "巴賽隆納社區(返)",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE263",
        "StopID": "263",
        "StopName": {
            "Zh_tw": "海中天社區(返)",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1051",
    "RouteID": "1051",
    "RouteName": {
        "Zh_tw": "105 三總基隆分院-基隆車站",
        "En": "105 Tri-Service General Hospital of Keelung - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1051",
    "SubRouteID": "1051",
    "SubRouteName": {
        "Zh_tw": "105 三總基隆分院-基隆車站",
        "En": "105 Tri-Service General Hospital of Keelung - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE388",
        "StopID": "388",
        "StopName": {
            "Zh_tw": "正榮街口",
            "En": "Zhengrong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.142988,
            "PositionLon": 121.761113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE389",
        "StopID": "389",
        "StopName": {
            "Zh_tw": "正榮街",
            "En": "Zhengrong St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.14632,
            "PositionLon": 121.762495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE390",
        "StopID": "390",
        "StopName": {
            "Zh_tw": "正濱國中",
            "En": "Zhengbin Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.145766,
            "PositionLon": 121.762833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE391",
        "StopID": "391",
        "StopName": {
            "Zh_tw": "三軍總醫院基隆分院",
            "En": "Tri-Service General Hospital of Keelung"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.144528,
            "PositionLon": 121.762738
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1051",
    "RouteID": "1051",
    "RouteName": {
        "Zh_tw": "105 三總基隆分院-基隆車站",
        "En": "105 Tri-Service General Hospital of Keelung - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1051",
    "SubRouteID": "1051",
    "SubRouteName": {
        "Zh_tw": "105 三總基隆分院-基隆車站",
        "En": "105 Tri-Service General Hospital of Keelung - Keelung Station"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE392",
        "StopID": "392",
        "StopName": {
            "Zh_tw": "建心新城",
            "En": "Jianxinxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.142248,
            "PositionLon": 121.763673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1071",
    "RouteID": "1071",
    "RouteName": {
        "Zh_tw": "107 八斗子-經信義國中",
        "En": "107 Badouzi - Via Xinyi Junior High School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1071",
    "SubRouteID": "1071",
    "SubRouteName": {
        "Zh_tw": "107 八斗子-經信義國中",
        "En": "107 Badouzi - Via Xinyi Junior High School"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE532",
        "StopID": "532",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.144336,
            "PositionLon": 121.795134
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3169",
        "StopID": "3169",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.142595,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3484",
        "StopID": "3484",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.140448,
            "PositionLon": 121.79424
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE410",
        "StopID": "410",
        "StopName": {
            "Zh_tw": "新豐街303巷",
            "En": "Ln. 303, Xinfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13527,
            "PositionLon": 121.787391
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1071",
    "RouteID": "1071",
    "RouteName": {
        "Zh_tw": "107 八斗子-經信義國中",
        "En": "107 Badouzi - Via Xinyi Junior High School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1071",
    "SubRouteID": "1071",
    "SubRouteName": {
        "Zh_tw": "107 八斗子-經信義國中",
        "En": "107 Badouzi - Via Xinyi Junior High School"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE870",
        "StopID": "870",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130123,
            "PositionLon": 121.74807
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE873",
        "StopID": "873",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129143,
            "PositionLon": 121.755621
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE458",
        "StopID": "458",
        "StopName": {
            "Zh_tw": "新豐街303巷",
            "En": "Ln. 303, Xinfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.135016,
            "PositionLon": 121.787766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE460",
        "StopID": "460",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137713,
            "PositionLon": 121.78848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE461",
        "StopID": "461",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136563,
            "PositionLon": 121.794725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3481",
        "StopID": "3481",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.142691,
            "PositionLon": 121.796581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1719",
        "StopID": "1719",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.142603,
            "PositionLon": 121.796604
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE477",
        "StopID": "477",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.144466,
            "PositionLon": 121.796083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1072",
    "RouteID": "1072",
    "RouteName": {
        "Zh_tw": "107 八斗子-基隆車站(經信義國中)",
        "En": "107 Badouzi - Keelung Station(Xinyi Junior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1072",
    "SubRouteID": "1072",
    "SubRouteName": {
        "Zh_tw": "107 八斗子-基隆車站(經信義國中)",
        "En": "107 Badouzi - Keelung Station(Xinyi Junior High School)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE532",
        "StopID": "532",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.144336,
            "PositionLon": 121.795134
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3169",
        "StopID": "3169",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.142595,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3484",
        "StopID": "3484",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.140448,
            "PositionLon": 121.79424
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE410",
        "StopID": "410",
        "StopName": {
            "Zh_tw": "新豐街303巷",
            "En": "Ln. 303, Xinfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13527,
            "PositionLon": 121.787391
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1073",
    "RouteID": "1073",
    "RouteName": {
        "Zh_tw": "107 調和街-基隆車站(經信義國中)",
        "En": "107 Diaohe St. - Keelung Station(Xinyi Junior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1073",
    "SubRouteID": "1073",
    "SubRouteName": {
        "Zh_tw": "107 調和街-基隆車站(經信義國中)",
        "En": "107 Diaohe St. - Keelung Station(Xinyi Junior High School)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1074",
    "RouteID": "1074",
    "RouteName": {
        "Zh_tw": "107 調和街-經信義國中",
        "En": "107 Diaohe St. - Via Xinyi Junior High School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1074",
    "SubRouteID": "1074",
    "SubRouteName": {
        "Zh_tw": "107 調和街-經信義國中",
        "En": "107 Diaohe St. - Via Xinyi Junior High School"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1074",
    "RouteID": "1074",
    "RouteName": {
        "Zh_tw": "107 調和街-經信義國中",
        "En": "107 Diaohe St. - Via Xinyi Junior High School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1074",
    "SubRouteID": "1074",
    "SubRouteName": {
        "Zh_tw": "107 調和街-經信義國中",
        "En": "107 Diaohe St. - Via Xinyi Junior High School"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE870",
        "StopID": "870",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130123,
            "PositionLon": 121.74807
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE873",
        "StopID": "873",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129143,
            "PositionLon": 121.755621
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE460",
        "StopID": "460",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.137713,
            "PositionLon": 121.78848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE461",
        "StopID": "461",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.136563,
            "PositionLon": 121.794725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1081",
    "RouteID": "1081",
    "RouteName": {
        "Zh_tw": "108 潮境公園-經祥豐街",
        "En": "108 Chaojing Park - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1081",
    "SubRouteID": "1081",
    "SubRouteName": {
        "Zh_tw": "108 潮境公園-經祥豐街",
        "En": "108 Chaojing Park - Via Xiangfeng St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE469",
        "StopID": "469",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.142303,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3481",
        "StopID": "3481",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.142691,
            "PositionLon": 121.796581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1719",
        "StopID": "1719",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.142603,
            "PositionLon": 121.796604
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1715",
        "StopID": "1715",
        "StopName": {
            "Zh_tw": "八斗街150號",
            "En": "No.150, Badou St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.144539,
            "PositionLon": 121.795994
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3483",
        "StopID": "3483",
        "StopName": {
            "Zh_tw": "油庫",
            "En": "Oil Depot"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.140258,
            "PositionLon": 121.793931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE477",
        "StopID": "477",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144466,
            "PositionLon": 121.796083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE174",
        "StopID": "174",
        "StopName": {
            "Zh_tw": "八斗子分站(返)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.143521,
            "PositionLon": 121.790768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1081",
    "RouteID": "1081",
    "RouteName": {
        "Zh_tw": "108 潮境公園-經祥豐街",
        "En": "108 Chaojing Park - Via Xiangfeng St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1081",
    "SubRouteID": "1081",
    "SubRouteName": {
        "Zh_tw": "108 潮境公園-經祥豐街",
        "En": "108 Chaojing Park - Via Xiangfeng St."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE532",
        "StopID": "532",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144336,
            "PositionLon": 121.795134
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3486",
        "StopID": "3486",
        "StopName": {
            "Zh_tw": "油庫",
            "En": "Oil Depot"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.142686,
            "PositionLon": 121.796595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3169",
        "StopID": "3169",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.142595,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3484",
        "StopID": "3484",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.140448,
            "PositionLon": 121.79424
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE534",
        "StopID": "534",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.14221,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1082",
    "RouteID": "1082",
    "RouteName": {
        "Zh_tw": "108 潮境公園-基隆車站",
        "En": "108 Chaojing Park - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1082",
    "SubRouteID": "1082",
    "SubRouteName": {
        "Zh_tw": "108 潮境公園-基隆車站",
        "En": "108 Chaojing Park - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE469",
        "StopID": "469",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.142303,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3481",
        "StopID": "3481",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.142691,
            "PositionLon": 121.796581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1719",
        "StopID": "1719",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.142603,
            "PositionLon": 121.796604
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1715",
        "StopID": "1715",
        "StopName": {
            "Zh_tw": "八斗街150號",
            "En": "No.150, Badou St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.144539,
            "PositionLon": 121.795994
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3483",
        "StopID": "3483",
        "StopName": {
            "Zh_tw": "油庫",
            "En": "Oil Depot"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.140258,
            "PositionLon": 121.793931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE477",
        "StopID": "477",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144466,
            "PositionLon": 121.796083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE174",
        "StopID": "174",
        "StopName": {
            "Zh_tw": "八斗子分站(返)",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.143521,
            "PositionLon": 121.790768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE17",
        "StopID": "17",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.142485,
            "PositionLon": 121.760703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1084",
    "RouteID": "1084",
    "RouteName": {
        "Zh_tw": "108 潮境公園-經仁一路",
        "En": "108 Chaojing Park - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1084",
    "SubRouteID": "1084",
    "SubRouteName": {
        "Zh_tw": "108 潮境公園-經仁一路",
        "En": "108 Chaojing Park - Via Ren 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE469",
        "StopID": "469",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.142303,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3481",
        "StopID": "3481",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.142691,
            "PositionLon": 121.796581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1719",
        "StopID": "1719",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.142603,
            "PositionLon": 121.796604
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1715",
        "StopID": "1715",
        "StopName": {
            "Zh_tw": "八斗街150號",
            "En": "No.150, Badou St."
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.144539,
            "PositionLon": 121.795994
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3483",
        "StopID": "3483",
        "StopName": {
            "Zh_tw": "油庫",
            "En": "Oil Depot"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.140258,
            "PositionLon": 121.793931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE477",
        "StopID": "477",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.144466,
            "PositionLon": 121.796083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1084",
    "RouteID": "1084",
    "RouteName": {
        "Zh_tw": "108 潮境公園-經仁一路",
        "En": "108 Chaojing Park - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1084",
    "SubRouteID": "1084",
    "SubRouteName": {
        "Zh_tw": "108 潮境公園-經仁一路",
        "En": "108 Chaojing Park - Via Ren 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3490",
        "StopID": "3490",
        "StopName": {
            "Zh_tw": "電力公司",
            "En": "Taiwan Power Company of Keelung City"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129606,
            "PositionLon": 121.74556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3491",
        "StopID": "3491",
        "StopName": {
            "Zh_tw": "愛六路口",
            "En": "Ai 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.747583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE437",
        "StopID": "437",
        "StopName": {
            "Zh_tw": "劉銘傳路口",
            "En": "Liumingchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128033,
            "PositionLon": 121.751383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE438",
        "StopID": "438",
        "StopName": {
            "Zh_tw": "愛九路口",
            "En": "Ai 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12785,
            "PositionLon": 121.753133
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE439",
        "StopID": "439",
        "StopName": {
            "Zh_tw": "仁一路27號",
            "En": "No.27, Ren 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127983,
            "PositionLon": 121.755883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE440",
        "StopID": "440",
        "StopName": {
            "Zh_tw": "月眉路口",
            "En": "Yuemei Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.12795,
            "PositionLon": 121.75755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE460",
        "StopID": "460",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137713,
            "PositionLon": 121.78848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE461",
        "StopID": "461",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136563,
            "PositionLon": 121.794725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE532",
        "StopID": "532",
        "StopName": {
            "Zh_tw": "福靈宮",
            "En": "Fuling Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.144336,
            "PositionLon": 121.795134
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3486",
        "StopID": "3486",
        "StopName": {
            "Zh_tw": "油庫",
            "En": "Oil Depot"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.142686,
            "PositionLon": 121.796595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3169",
        "StopID": "3169",
        "StopName": {
            "Zh_tw": "八斗街土地廟",
            "En": "Badou St. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.142595,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3484",
        "StopID": "3484",
        "StopName": {
            "Zh_tw": "八斗街口",
            "En": "Badou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.140448,
            "PositionLon": 121.79424
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE534",
        "StopID": "534",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.14221,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1091",
    "RouteID": "1091",
    "RouteName": {
        "Zh_tw": "109 天顯宮-基隆車站(經中正路)",
        "En": "109 Tianxian Temple - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1091",
    "SubRouteID": "1091",
    "SubRouteName": {
        "Zh_tw": "109 天顯宮-基隆車站(經中正路)",
        "En": "109 Tianxian Temple - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE388",
        "StopID": "388",
        "StopName": {
            "Zh_tw": "正榮街口",
            "En": "Zhengrong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.142988,
            "PositionLon": 121.761113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3477",
        "StopID": "3477",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.144501,
            "PositionLon": 121.761641
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3478",
        "StopID": "3478",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14589,
            "PositionLon": 121.761692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE43",
        "StopID": "43",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.149321,
            "PositionLon": 121.763788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE44",
        "StopID": "44",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.15062,
            "PositionLon": 121.765798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE45",
        "StopID": "45",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.151033,
            "PositionLon": 121.766816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE46",
        "StopID": "46",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152483,
            "PositionLon": 121.768616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE776",
        "StopID": "776",
        "StopName": {
            "Zh_tw": "天顯宮",
            "En": "TianxianTemple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1578,
            "PositionLon": 121.767761
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE1091",
    "RouteID": "1091",
    "RouteName": {
        "Zh_tw": "109 天顯宮-基隆車站(經中正路)",
        "En": "109 Tianxian Temple - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE1091",
    "SubRouteID": "1091",
    "SubRouteName": {
        "Zh_tw": "109 天顯宮-基隆車站(經中正路)",
        "En": "109 Tianxian Temple - Keelung Station"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1091",
        "StopID": "1091",
        "StopName": {
            "Zh_tw": "和平街",
            "En": "Heping St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.157614,
            "PositionLon": 121.76788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE17",
        "StopID": "17",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142485,
            "PositionLon": 121.760703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2011",
    "RouteID": "2011",
    "RouteName": {
        "Zh_tw": "201 深美國小-經仁一路",
        "En": "109 Shenmei Elementary School - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2011",
    "SubRouteID": "2011",
    "SubRouteName": {
        "Zh_tw": "201 深美國小-經仁一路",
        "En": "109 Shenmei Elementary School - Via Ren 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE237",
        "StopID": "237",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.135676,
            "PositionLon": 121.779916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE238",
        "StopID": "238",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134931,
            "PositionLon": 121.782438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2011",
    "RouteID": "2011",
    "RouteName": {
        "Zh_tw": "201 深美國小-經仁一路",
        "En": "109 Shenmei Elementary School - Via Ren 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2011",
    "SubRouteID": "2011",
    "SubRouteName": {
        "Zh_tw": "201 深美國小-經仁一路",
        "En": "109 Shenmei Elementary School - Via Ren 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3490",
        "StopID": "3490",
        "StopName": {
            "Zh_tw": "電力公司",
            "En": "Taiwan Power Company of Keelung City"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129606,
            "PositionLon": 121.74556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3491",
        "StopID": "3491",
        "StopName": {
            "Zh_tw": "愛六路口",
            "En": "Ai 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.747583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE437",
        "StopID": "437",
        "StopName": {
            "Zh_tw": "劉銘傳路口",
            "En": "Liumingchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128033,
            "PositionLon": 121.751383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE438",
        "StopID": "438",
        "StopName": {
            "Zh_tw": "愛九路口",
            "En": "Ai 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12785,
            "PositionLon": 121.753133
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE439",
        "StopID": "439",
        "StopName": {
            "Zh_tw": "仁一路27號",
            "En": "No.27, Ren 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127983,
            "PositionLon": 121.755883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE440",
        "StopID": "440",
        "StopName": {
            "Zh_tw": "月眉路口",
            "En": "Yuemei Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.12795,
            "PositionLon": 121.75755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2021",
    "RouteID": "2021",
    "RouteName": {
        "Zh_tw": "202 深美國小-經信二路",
        "En": "202 Shenmei Elementary School - Via Xin 2nd Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2021",
    "SubRouteID": "2021",
    "SubRouteName": {
        "Zh_tw": "202 深美國小-經信二路",
        "En": "202 Shenmei Elementary School - Via Xin 2nd Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE237",
        "StopID": "237",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.135676,
            "PositionLon": 121.779916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE238",
        "StopID": "238",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134931,
            "PositionLon": 121.782438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2021",
    "RouteID": "2021",
    "RouteName": {
        "Zh_tw": "202 深美國小-經信二路",
        "En": "202 Shenmei Elementary School - Via Xin 2nd Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2021",
    "SubRouteID": "2021",
    "SubRouteName": {
        "Zh_tw": "202 深美國小-經信二路",
        "En": "202 Shenmei Elementary School - Via Xin 2nd Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE870",
        "StopID": "870",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130123,
            "PositionLon": 121.74807
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE873",
        "StopID": "873",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129143,
            "PositionLon": 121.755621
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2031",
    "RouteID": "2031",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經美的世界(經八斗山莊)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2031",
    "SubRouteID": "2031",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經美的世界(經八斗山莊)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Badoushanzhuang Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2195",
        "StopID": "2195",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE897",
        "StopID": "897",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.131253,
            "PositionLon": 121.798873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE898",
        "StopID": "898",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129691,
            "PositionLon": 121.799563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE899",
        "StopID": "899",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128126,
            "PositionLon": 121.799204
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE970",
        "StopID": "970",
        "StopName": {
            "Zh_tw": "山美教會",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE901",
        "StopID": "901",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.125871,
            "PositionLon": 121.799448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE903",
        "StopID": "903",
        "StopName": {
            "Zh_tw": "調和街290巷115號",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.126266,
            "PositionLon": 121.797866
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE904",
        "StopID": "904",
        "StopName": {
            "Zh_tw": "八斗子山莊",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.126386,
            "PositionLon": 121.797566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE905",
        "StopID": "905",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.124495,
            "PositionLon": 121.798821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE906",
        "StopID": "906",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.120191,
            "PositionLon": 121.797106
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE914",
        "StopID": "914",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128871,
            "PositionLon": 121.779263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3495",
        "StopID": "3495",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130528,
            "PositionLon": 121.77719
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE919",
        "StopID": "919",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135629,
            "PositionLon": 121.770782
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE920",
        "StopID": "920",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.131871,
            "PositionLon": 121.770495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE921",
        "StopID": "921",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE922",
        "StopID": "922",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130421,
            "PositionLon": 121.767973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE923",
        "StopID": "923",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.12941,
            "PositionLon": 121.767513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2031",
    "RouteID": "2031",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經美的世界(經八斗山莊)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2031",
    "SubRouteID": "2031",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經美的世界(經八斗山莊)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Badoushanzhuang Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE948",
        "StopID": "948",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129605,
            "PositionLon": 121.767486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE949",
        "StopID": "949",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130446,
            "PositionLon": 121.767858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE950",
        "StopID": "950",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE951",
        "StopID": "951",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13184,
            "PositionLon": 121.769996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE952",
        "StopID": "952",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135719,
            "PositionLon": 121.770881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE955",
        "StopID": "955",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13331,
            "PositionLon": 121.776863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3499",
        "StopID": "3499",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.130678,
            "PositionLon": 121.77728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE957",
        "StopID": "957",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.12891,
            "PositionLon": 121.77893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE965",
        "StopID": "965",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.12095,
            "PositionLon": 121.79785
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE966",
        "StopID": "966",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.124386,
            "PositionLon": 121.798885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE971",
        "StopID": "971",
        "StopName": {
            "Zh_tw": "山美教會(返)",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE967",
        "StopID": "967",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場(返)",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126033,
            "PositionLon": 121.798783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE968",
        "StopID": "968",
        "StopName": {
            "Zh_tw": "調和街290巷115號(返)",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.797033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE969",
        "StopID": "969",
        "StopName": {
            "Zh_tw": "八斗子山莊(返)",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.12665,
            "PositionLon": 121.796616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE933",
        "StopID": "933",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.127879,
            "PositionLon": 121.799389
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE973",
        "StopID": "973",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.1302,
            "PositionLon": 121.7993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE974",
        "StopID": "974",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.137175,
            "PositionLon": 121.79639
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2196",
        "StopID": "2196",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2032",
    "RouteID": "2032",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(經八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2032",
    "SubRouteID": "2032",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(經八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2195",
        "StopID": "2195",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE897",
        "StopID": "897",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.131253,
            "PositionLon": 121.798873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE898",
        "StopID": "898",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129691,
            "PositionLon": 121.799563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE899",
        "StopID": "899",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128126,
            "PositionLon": 121.799204
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE970",
        "StopID": "970",
        "StopName": {
            "Zh_tw": "山美教會",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE901",
        "StopID": "901",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.125871,
            "PositionLon": 121.799448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE903",
        "StopID": "903",
        "StopName": {
            "Zh_tw": "調和街290巷115號",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.126266,
            "PositionLon": 121.797866
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE904",
        "StopID": "904",
        "StopName": {
            "Zh_tw": "八斗子山莊",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.126386,
            "PositionLon": 121.797566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE905",
        "StopID": "905",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.124495,
            "PositionLon": 121.798821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE906",
        "StopID": "906",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.120191,
            "PositionLon": 121.797106
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE914",
        "StopID": "914",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128871,
            "PositionLon": 121.779263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3013",
        "StopID": "3013",
        "StopName": {
            "Zh_tw": "東峰街口(孝德里里民會堂)",
            "En": "Dongfeng St. Intersection (Shiaude Villagers Meeting Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE919",
        "StopID": "919",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135629,
            "PositionLon": 121.770782
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE920",
        "StopID": "920",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.131871,
            "PositionLon": 121.770495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE921",
        "StopID": "921",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE922",
        "StopID": "922",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130421,
            "PositionLon": 121.767973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE923",
        "StopID": "923",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.12941,
            "PositionLon": 121.767513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2032",
    "RouteID": "2032",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(經八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2032",
    "SubRouteID": "2032",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(經八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE948",
        "StopID": "948",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129605,
            "PositionLon": 121.767486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE949",
        "StopID": "949",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130446,
            "PositionLon": 121.767858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE950",
        "StopID": "950",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE951",
        "StopID": "951",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13184,
            "PositionLon": 121.769996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE952",
        "StopID": "952",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135719,
            "PositionLon": 121.770881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE957",
        "StopID": "957",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.12891,
            "PositionLon": 121.77893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE965",
        "StopID": "965",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.12095,
            "PositionLon": 121.79785
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE966",
        "StopID": "966",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.124386,
            "PositionLon": 121.798885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE971",
        "StopID": "971",
        "StopName": {
            "Zh_tw": "山美教會(返)",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE967",
        "StopID": "967",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場(返)",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126033,
            "PositionLon": 121.798783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE968",
        "StopID": "968",
        "StopName": {
            "Zh_tw": "調和街290巷115號(返)",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.797033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE969",
        "StopID": "969",
        "StopName": {
            "Zh_tw": "八斗子山莊(返)",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.12665,
            "PositionLon": 121.796616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE933",
        "StopID": "933",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.127879,
            "PositionLon": 121.799389
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE973",
        "StopID": "973",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.1302,
            "PositionLon": 121.7993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE974",
        "StopID": "974",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.137175,
            "PositionLon": 121.79639
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2196",
        "StopID": "2196",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2033",
    "RouteID": "2033",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(去八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2033",
    "SubRouteID": "2033",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(去八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2195",
        "StopID": "2195",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE897",
        "StopID": "897",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.131253,
            "PositionLon": 121.798873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE898",
        "StopID": "898",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129691,
            "PositionLon": 121.799563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE899",
        "StopID": "899",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128126,
            "PositionLon": 121.799204
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE970",
        "StopID": "970",
        "StopName": {
            "Zh_tw": "山美教會",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE901",
        "StopID": "901",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.125871,
            "PositionLon": 121.799448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE903",
        "StopID": "903",
        "StopName": {
            "Zh_tw": "調和街290巷115號",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.126266,
            "PositionLon": 121.797866
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE904",
        "StopID": "904",
        "StopName": {
            "Zh_tw": "八斗子山莊",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.126386,
            "PositionLon": 121.797566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE905",
        "StopID": "905",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.124495,
            "PositionLon": 121.798821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE906",
        "StopID": "906",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.120191,
            "PositionLon": 121.797106
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE914",
        "StopID": "914",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128871,
            "PositionLon": 121.779263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3013",
        "StopID": "3013",
        "StopName": {
            "Zh_tw": "東峰街口(孝德里里民會堂)",
            "En": "Dongfeng St. Intersection (Shiaude Villagers Meeting Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE919",
        "StopID": "919",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135629,
            "PositionLon": 121.770782
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE920",
        "StopID": "920",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.131871,
            "PositionLon": 121.770495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE921",
        "StopID": "921",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE922",
        "StopID": "922",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130421,
            "PositionLon": 121.767973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE923",
        "StopID": "923",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.12941,
            "PositionLon": 121.767513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2033",
    "RouteID": "2033",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(去八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2033",
    "SubRouteID": "2033",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(去八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE948",
        "StopID": "948",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129605,
            "PositionLon": 121.767486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE949",
        "StopID": "949",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130446,
            "PositionLon": 121.767858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE950",
        "StopID": "950",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE951",
        "StopID": "951",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13184,
            "PositionLon": 121.769996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE952",
        "StopID": "952",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135719,
            "PositionLon": 121.770881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE957",
        "StopID": "957",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.12891,
            "PositionLon": 121.77893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE965",
        "StopID": "965",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.12095,
            "PositionLon": 121.79785
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE966",
        "StopID": "966",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.124386,
            "PositionLon": 121.798885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE933",
        "StopID": "933",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127879,
            "PositionLon": 121.799389
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE973",
        "StopID": "973",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.1302,
            "PositionLon": 121.7993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE974",
        "StopID": "974",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.137175,
            "PositionLon": 121.79639
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2196",
        "StopID": "2196",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2034",
    "RouteID": "2034",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(回八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2034",
    "SubRouteID": "2034",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(回八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2195",
        "StopID": "2195",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE897",
        "StopID": "897",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.131253,
            "PositionLon": 121.798873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE898",
        "StopID": "898",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129691,
            "PositionLon": 121.799563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE899",
        "StopID": "899",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128126,
            "PositionLon": 121.799204
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE905",
        "StopID": "905",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.124495,
            "PositionLon": 121.798821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE906",
        "StopID": "906",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.120191,
            "PositionLon": 121.797106
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE914",
        "StopID": "914",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128871,
            "PositionLon": 121.779263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3013",
        "StopID": "3013",
        "StopName": {
            "Zh_tw": "東峰街口(孝德里里民會堂)",
            "En": "Dongfeng St. Intersection (Shiaude Villagers Meeting Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE919",
        "StopID": "919",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.135629,
            "PositionLon": 121.770782
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE920",
        "StopID": "920",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.131871,
            "PositionLon": 121.770495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE921",
        "StopID": "921",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE922",
        "StopID": "922",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.130421,
            "PositionLon": 121.767973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE923",
        "StopID": "923",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.12941,
            "PositionLon": 121.767513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2034",
    "RouteID": "2034",
    "RouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(回八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2034",
    "SubRouteID": "2034",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-經富貴社區(回八斗山莊)",
        "En": "203 Shenaokeng - Via Fugui Community(Badoushanzhuang Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE948",
        "StopID": "948",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129605,
            "PositionLon": 121.767486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE949",
        "StopID": "949",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130446,
            "PositionLon": 121.767858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE950",
        "StopID": "950",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE951",
        "StopID": "951",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13184,
            "PositionLon": 121.769996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE952",
        "StopID": "952",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135719,
            "PositionLon": 121.770881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE957",
        "StopID": "957",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.12891,
            "PositionLon": 121.77893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE965",
        "StopID": "965",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.12095,
            "PositionLon": 121.79785
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE966",
        "StopID": "966",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.124386,
            "PositionLon": 121.798885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE971",
        "StopID": "971",
        "StopName": {
            "Zh_tw": "山美教會(返)",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE967",
        "StopID": "967",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場(返)",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126033,
            "PositionLon": 121.798783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE968",
        "StopID": "968",
        "StopName": {
            "Zh_tw": "調和街290巷115號(返)",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.797033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE969",
        "StopID": "969",
        "StopName": {
            "Zh_tw": "八斗子山莊(返)",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.12665,
            "PositionLon": 121.796616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE933",
        "StopID": "933",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.127879,
            "PositionLon": 121.799389
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE973",
        "StopID": "973",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.1302,
            "PositionLon": 121.7993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE974",
        "StopID": "974",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.137175,
            "PositionLon": 121.79639
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2196",
        "StopID": "2196",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2035",
    "RouteID": "2035",
    "RouteName": {
        "Zh_tw": "203 深澳坑-去經美的世界(回經富貴社區)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Fugui Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2035",
    "SubRouteID": "2035",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-去經美的世界(回經富貴社區)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Fugui Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE116",
        "StopID": "116",
        "StopName": {
            "Zh_tw": "八斗子分站",
            "En": "Badouzi Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.14192,
            "PositionLon": 121.79071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE115",
        "StopID": "115",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.14089,
            "PositionLon": 121.792312
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2195",
        "StopID": "2195",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE897",
        "StopID": "897",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.131253,
            "PositionLon": 121.798873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE898",
        "StopID": "898",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129691,
            "PositionLon": 121.799563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE899",
        "StopID": "899",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128126,
            "PositionLon": 121.799204
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE970",
        "StopID": "970",
        "StopName": {
            "Zh_tw": "山美教會",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE901",
        "StopID": "901",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.125871,
            "PositionLon": 121.799448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE903",
        "StopID": "903",
        "StopName": {
            "Zh_tw": "調和街290巷115號",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.126266,
            "PositionLon": 121.797866
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE904",
        "StopID": "904",
        "StopName": {
            "Zh_tw": "八斗子山莊",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.126386,
            "PositionLon": 121.797566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE905",
        "StopID": "905",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.124495,
            "PositionLon": 121.798821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE906",
        "StopID": "906",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.120191,
            "PositionLon": 121.797106
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE914",
        "StopID": "914",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128871,
            "PositionLon": 121.779263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3495",
        "StopID": "3495",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130528,
            "PositionLon": 121.77719
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE919",
        "StopID": "919",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135629,
            "PositionLon": 121.770782
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE920",
        "StopID": "920",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.131871,
            "PositionLon": 121.770495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE921",
        "StopID": "921",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE922",
        "StopID": "922",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130421,
            "PositionLon": 121.767973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE923",
        "StopID": "923",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.12941,
            "PositionLon": 121.767513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2035",
    "RouteID": "2035",
    "RouteName": {
        "Zh_tw": "203 深澳坑-去經美的世界(回經富貴社區)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Fugui Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2035",
    "SubRouteID": "2035",
    "SubRouteName": {
        "Zh_tw": "203 深澳坑-去經美的世界(回經富貴社區)",
        "En": "203 Shenaokeng - Via Meideshijie Community(Fugui Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE948",
        "StopID": "948",
        "StopName": {
            "Zh_tw": "信中後站",
            "En": "Sinyi Junior High School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129605,
            "PositionLon": 121.767486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE949",
        "StopID": "949",
        "StopName": {
            "Zh_tw": "基隆監獄",
            "En": "Keelung Jail"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130446,
            "PositionLon": 121.767858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE950",
        "StopID": "950",
        "StopName": {
            "Zh_tw": "環保局(信義大街)",
            "En": "Environment Protection Bureau (Shinyi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131134,
            "PositionLon": 121.769445
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE951",
        "StopID": "951",
        "StopName": {
            "Zh_tw": "翠峰山莊",
            "En": "Cuifengshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13184,
            "PositionLon": 121.769996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE952",
        "StopID": "952",
        "StopName": {
            "Zh_tw": "金鳳宮",
            "En": "Jinfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.135719,
            "PositionLon": 121.770881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE957",
        "StopID": "957",
        "StopName": {
            "Zh_tw": "圓窗口",
            "En": "Yuanchuangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.12891,
            "PositionLon": 121.77893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE965",
        "StopID": "965",
        "StopName": {
            "Zh_tw": "調和街口",
            "En": "Diaohe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.12095,
            "PositionLon": 121.79785
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE966",
        "StopID": "966",
        "StopName": {
            "Zh_tw": "大眾爺廟",
            "En": "Dazhongye Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.124386,
            "PositionLon": 121.798885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE971",
        "StopID": "971",
        "StopName": {
            "Zh_tw": "山美教會(返)",
            "En": "Shanmei Church"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.125998,
            "PositionLon": 121.799119
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE967",
        "StopID": "967",
        "StopName": {
            "Zh_tw": "八斗子山莊籃球場(返)",
            "En": "Badouzi Village Basketball Court"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126033,
            "PositionLon": 121.798783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE968",
        "StopID": "968",
        "StopName": {
            "Zh_tw": "調和街290巷115號(返)",
            "En": "No.115, Ln. 290, Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.797033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE969",
        "StopID": "969",
        "StopName": {
            "Zh_tw": "八斗子山莊(返)",
            "En": "Badouzi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.12665,
            "PositionLon": 121.796616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE933",
        "StopID": "933",
        "StopName": {
            "Zh_tw": "海科公園社區",
            "En": "The Ocean Park Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.127879,
            "PositionLon": 121.799389
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE973",
        "StopID": "973",
        "StopName": {
            "Zh_tw": "碧砂山水社區",
            "En": "Bishashanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.1302,
            "PositionLon": 121.7993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE974",
        "StopID": "974",
        "StopName": {
            "Zh_tw": "調和街(福德宮)",
            "En": "Diaohe St. (Fude Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.137175,
            "PositionLon": 121.79639
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2196",
        "StopID": "2196",
        "StopName": {
            "Zh_tw": "調和街觀海街口",
            "En": "Diaohe St. & Guanhai St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135649,
            "PositionLon": 121.796195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE170",
        "StopID": "170",
        "StopName": {
            "Zh_tw": "基隆漁會",
            "En": "Keelung District Fishmens` Association"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.140399,
            "PositionLon": 121.792411
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2041",
    "RouteID": "2041",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2041",
    "SubRouteID": "2041",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2041",
    "RouteID": "2041",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2041",
    "SubRouteID": "2041",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE955",
        "StopID": "955",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13331,
            "PositionLon": 121.776863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2042",
    "RouteID": "2042",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(總站發車)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2042",
    "SubRouteID": "2042",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(總站發車)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE955",
        "StopID": "955",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13331,
            "PositionLon": 121.776863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2043",
    "RouteID": "2043",
    "RouteName": {
        "Zh_tw": "204 教忠街-經富貴社區(經月眉路)",
        "En": "204 Jiaozhong St. - Via Fugui Community(Yuemei Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2043",
    "SubRouteID": "2043",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經富貴社區(經月眉路)",
        "En": "204 Jiaozhong St. - Via Fugui Community(Yuemei Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3495",
        "StopID": "3495",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.130528,
            "PositionLon": 121.77719
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE915",
        "StopID": "915",
        "StopName": {
            "Zh_tw": "東峰街口",
            "En": "Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1094",
        "StopID": "1094",
        "StopName": {
            "Zh_tw": "東光路培德路口",
            "En": "Peide Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.133426,
            "PositionLon": 121.773273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1438",
        "StopID": "1438",
        "StopName": {
            "Zh_tw": "東明路六合街口",
            "En": "Don Ming Rd. & Liuhe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.127538,
            "PositionLon": 121.758794
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1263",
        "StopID": "1263",
        "StopName": {
            "Zh_tw": "月眉路",
            "En": "Yuemei Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.12394,
            "PositionLon": 121.757976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2043",
    "RouteID": "2043",
    "RouteName": {
        "Zh_tw": "204 教忠街-經富貴社區(經月眉路)",
        "En": "204 Jiaozhong St. - Via Fugui Community(Yuemei Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2043",
    "SubRouteID": "2043",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經富貴社區(經月眉路)",
        "En": "204 Jiaozhong St. - Via Fugui Community(Yuemei Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1440",
        "StopID": "1440",
        "StopName": {
            "Zh_tw": "東明路六合街口(返)",
            "En": "Don Ming Rd. & Liuhe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127538,
            "PositionLon": 121.758794
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1266",
        "StopID": "1266",
        "StopName": {
            "Zh_tw": "月眉路(返)",
            "En": "Yuemei Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124809,
            "PositionLon": 121.758701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1130",
        "StopID": "1130",
        "StopName": {
            "Zh_tw": "東光路培德路口",
            "En": "Peide Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13326,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3499",
        "StopID": "3499",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.130678,
            "PositionLon": 121.77728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2044",
    "RouteID": "2044",
    "RouteName": {
        "Zh_tw": "204 教忠街-經富貴社區",
        "En": "204 Jiaozhong St. - Via Fugui Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2044",
    "SubRouteID": "2044",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經富貴社區",
        "En": "204 Jiaozhong St. - Via Fugui Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3495",
        "StopID": "3495",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.130528,
            "PositionLon": 121.77719
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE915",
        "StopID": "915",
        "StopName": {
            "Zh_tw": "東峰街口",
            "En": "Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1094",
        "StopID": "1094",
        "StopName": {
            "Zh_tw": "東光路培德路口",
            "En": "Peide Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133426,
            "PositionLon": 121.773273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2044",
    "RouteID": "2044",
    "RouteName": {
        "Zh_tw": "204 教忠街-經富貴社區",
        "En": "204 Jiaozhong St. - Via Fugui Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2044",
    "SubRouteID": "2044",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經富貴社區",
        "En": "204 Jiaozhong St. - Via Fugui Community"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1130",
        "StopID": "1130",
        "StopName": {
            "Zh_tw": "東光路培德路口",
            "En": "Peide Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13326,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1132",
        "StopID": "1132",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132873,
            "PositionLon": 121.773823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3503",
        "StopID": "3503",
        "StopName": {
            "Zh_tw": "東峰街52巷口",
            "En": "Ln. 52, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132248,
            "PositionLon": 121.774591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3504",
        "StopID": "3504",
        "StopName": {
            "Zh_tw": "東峰街100號",
            "En": "No.100, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3508",
        "StopID": "3508",
        "StopName": {
            "Zh_tw": "東峰街150號",
            "En": "No.150, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13138,
            "PositionLon": 121.775699
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3499",
        "StopID": "3499",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.130678,
            "PositionLon": 121.77728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2045",
    "RouteID": "2045",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經月眉路)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Yuemei Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2045",
    "SubRouteID": "2045",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經月眉路)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Yuemei Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1438",
        "StopID": "1438",
        "StopName": {
            "Zh_tw": "東明路六合街口",
            "En": "Don Ming Rd. & Liuhe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.127538,
            "PositionLon": 121.758794
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1263",
        "StopID": "1263",
        "StopName": {
            "Zh_tw": "月眉路",
            "En": "Yuemei Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.12394,
            "PositionLon": 121.757976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2045",
    "RouteID": "2045",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經月眉路)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Yuemei Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2045",
    "SubRouteID": "2045",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經月眉路)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Yuemei Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1440",
        "StopID": "1440",
        "StopName": {
            "Zh_tw": "東明路六合街口(返)",
            "En": "Don Ming Rd. & Liuhe St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127538,
            "PositionLon": 121.758794
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1266",
        "StopID": "1266",
        "StopName": {
            "Zh_tw": "月眉路(返)",
            "En": "Yuemei Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124809,
            "PositionLon": 121.758701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE955",
        "StopID": "955",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13331,
            "PositionLon": 121.776863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2046",
    "RouteID": "2046",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經教孝街)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Jiaohau St.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2046",
    "SubRouteID": "2046",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經教孝街)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Jiaohau St.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1220",
        "StopID": "1220",
        "StopName": {
            "Zh_tw": "教孝街",
            "En": "Jiaoxiao St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.137345,
            "PositionLon": 121.775016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2046",
    "RouteID": "2046",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經教孝街)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Jiaohau St.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2046",
    "SubRouteID": "2046",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經教孝街)",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Jiaohau St.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1222",
        "StopID": "1222",
        "StopName": {
            "Zh_tw": "教孝街",
            "En": "Jiaoxiao St."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.137367,
            "PositionLon": 121.774599
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2047",
    "RouteID": "2047",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經仁五路",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Ren 5th Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2047",
    "SubRouteID": "2047",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經仁五路",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Ren 5th Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2047",
    "RouteID": "2047",
    "RouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經仁五路",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Ren 5th Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2047",
    "SubRouteID": "2047",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-經美的世界(經仁五路",
        "En": "204 Jiaozhong St. - Via Meideshijie Community(Ren 5th Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1284",
        "StopID": "1284",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13455,
            "PositionLon": 121.76239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1285",
        "StopID": "1285",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13315,
            "PositionLon": 121.762931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5077",
        "StopID": "5077",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5073",
        "StopID": "5073",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1287",
        "StopID": "1287",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133933,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1289",
        "StopID": "1289",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1354,
            "PositionLon": 121.772016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3498",
        "StopID": "3498",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.137149,
            "PositionLon": 121.771469
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE954",
        "StopID": "954",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.136629,
            "PositionLon": 121.77362
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE955",
        "StopID": "955",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13331,
            "PositionLon": 121.776863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3497",
        "StopID": "3497",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.133305,
            "PositionLon": 121.777357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3505",
        "StopID": "3505",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.134425,
            "PositionLon": 121.77739
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE236",
        "StopID": "236",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.136411,
            "PositionLon": 121.778546
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5069",
        "StopID": "5069",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2048",
    "RouteID": "2048",
    "RouteName": {
        "Zh_tw": "204 教忠街-基隆車站(經富貴社區)",
        "En": "204 Jiaozhong St. - Keelung Station(Fugui Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2048",
    "SubRouteID": "2048",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-基隆車站(經富貴社區)",
        "En": "204 Jiaozhong St. - Keelung Station(Fugui Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3495",
        "StopID": "3495",
        "StopName": {
            "Zh_tw": "獅子園",
            "En": "Shiziyuan"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.130528,
            "PositionLon": 121.77719
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE915",
        "StopID": "915",
        "StopName": {
            "Zh_tw": "東峰街口",
            "En": "Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.130521,
            "PositionLon": 121.776881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3501",
        "StopID": "3501",
        "StopName": {
            "Zh_tw": "東峰街96巷口",
            "En": "Ln. 96, Dongfeng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.131423,
            "PositionLon": 121.775705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3502",
        "StopID": "3502",
        "StopName": {
            "Zh_tw": "東峰街51號",
            "En": "No.51, Dongfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.132261,
            "PositionLon": 121.774578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1093",
        "StopID": "1093",
        "StopName": {
            "Zh_tw": "富貴社區",
            "En": "Fuguei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132978,
            "PositionLon": 121.773618
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1094",
        "StopID": "1094",
        "StopName": {
            "Zh_tw": "東光路培德路口",
            "En": "Peide Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133426,
            "PositionLon": 121.773273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2049",
    "RouteID": "2049",
    "RouteName": {
        "Zh_tw": "204 教忠街-基隆車站(經美的世界)",
        "En": "204 Jiaozhong St. - Keelung Station(Meideshijie Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2049",
    "SubRouteID": "2049",
    "SubRouteName": {
        "Zh_tw": "204 教忠街-基隆車站(經美的世界)",
        "En": "204 Jiaozhong St. - Keelung Station(Meideshijie Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE374",
        "StopID": "374",
        "StopName": {
            "Zh_tw": "深美分站",
            "En": "Shenmei Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.135878,
            "PositionLon": 121.77806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5068",
        "StopID": "5068",
        "StopName": {
            "Zh_tw": "深美國小正門口",
            "En": "Shen-Mei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.1371,
            "PositionLon": 121.777309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1297",
        "StopID": "1297",
        "StopName": {
            "Zh_tw": "教忠街",
            "En": "Jiaozhong St."
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.135905,
            "PositionLon": 121.778432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3487",
        "StopID": "3487",
        "StopName": {
            "Zh_tw": "福源宮",
            "En": "Fuyuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.133636,
            "PositionLon": 121.777303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE916",
        "StopID": "916",
        "StopName": {
            "Zh_tw": "深澳坑路6巷口(協成煤礦)",
            "En": "Ln. 6, Shenaokeng Rd. Intersection (Xiecheng Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.133329,
            "PositionLon": 121.77713
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE917",
        "StopID": "917",
        "StopName": {
            "Zh_tw": "美的世界社區",
            "En": "Beautiful World Community"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.136539,
            "PositionLon": 121.773757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3496",
        "StopID": "3496",
        "StopName": {
            "Zh_tw": "大香港社區",
            "En": "Daxianggang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.136909,
            "PositionLon": 121.771072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5070",
        "StopID": "5070",
        "StopName": {
            "Zh_tw": "崇法街194號",
            "En": "No.194, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.133358,
            "PositionLon": 121.766054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5072",
        "StopID": "5072",
        "StopName": {
            "Zh_tw": "崇法街65號",
            "En": "No.65, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132108,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5076",
        "StopID": "5076",
        "StopName": {
            "Zh_tw": "信義花園社區",
            "En": "Xinyi Garden Community"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.132029,
            "PositionLon": 121.764303
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2051",
    "RouteID": "2051",
    "RouteName": {
        "Zh_tw": "205 信義國中-深美國小(經和平島)",
        "En": "205 Xinyi Junior High School - Shenmei Elementary School(Heping Island)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2051",
    "SubRouteID": "2051",
    "SubRouteName": {
        "Zh_tw": "205 信義國中-深美國小(經和平島)",
        "En": "205 Xinyi Junior High School - Shenmei Elementary School(Heping Island)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1349",
        "StopID": "1349",
        "StopName": {
            "Zh_tw": "豐稔街",
            "En": "Fengren St."
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.140083,
            "PositionLon": 121.76115
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2051",
    "RouteID": "2051",
    "RouteName": {
        "Zh_tw": "205 信義國中-深美國小(經和平島)",
        "En": "205 Xinyi Junior High School - Shenmei Elementary School(Heping Island)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2051",
    "SubRouteID": "2051",
    "SubRouteName": {
        "Zh_tw": "205 信義國中-深美國小(經和平島)",
        "En": "205 Xinyi Junior High School - Shenmei Elementary School(Heping Island)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE66",
        "StopID": "66",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.149715,
            "PositionLon": 121.771966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE68",
        "StopID": "68",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.146288,
            "PositionLon": 121.769893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE69",
        "StopID": "69",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.76791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE70",
        "StopID": "70",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.143129,
            "PositionLon": 121.76535
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE71",
        "StopID": "71",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.142445,
            "PositionLon": 121.76453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3476",
        "StopID": "3476",
        "StopName": {
            "Zh_tw": "正豐街",
            "En": "Zhengfeng St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140762,
            "PositionLon": 121.760126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1380",
        "StopID": "1380",
        "StopName": {
            "Zh_tw": "豐稔街",
            "En": "Fengren St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.139316,
            "PositionLon": 121.761383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE303",
        "StopID": "303",
        "StopName": {
            "Zh_tw": "深溪路口",
            "En": "Shenxi Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.135071,
            "PositionLon": 121.78222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE304",
        "StopID": "304",
        "StopName": {
            "Zh_tw": "深美街",
            "En": "Shenmei St."
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.1355,
            "PositionLon": 121.780183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE305",
        "StopID": "305",
        "StopName": {
            "Zh_tw": "深美國小(消防分隊)",
            "En": "Shen-Mei Elementary School ( Fire Units)"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.136638,
            "PositionLon": 121.778675
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2052",
    "RouteID": "2052",
    "RouteName": {
        "Zh_tw": "205 信義國中-和平島(經祥豐街)",
        "En": "205 Xinyi Junior High School - Heping Island(Xiangfeng St.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2052",
    "SubRouteID": "2052",
    "SubRouteName": {
        "Zh_tw": "205 信義國中-和平島(經祥豐街)",
        "En": "205 Xinyi Junior High School - Heping Island(Xiangfeng St.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE433",
        "StopID": "433",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1349",
        "StopID": "1349",
        "StopName": {
            "Zh_tw": "豐稔街",
            "En": "Fengren St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.140083,
            "PositionLon": 121.76115
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3524",
        "StopID": "3524",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.156185,
            "PositionLon": 121.770581
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2053",
    "RouteID": "2053",
    "RouteName": {
        "Zh_tw": "205 總站-和平島(經祥豐街)",
        "En": "205 Keelung Station - Heping Island(Xiangfeng St.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2053",
    "SubRouteID": "2053",
    "SubRouteName": {
        "Zh_tw": "205 總站-和平島(經祥豐街)",
        "En": "205 Keelung Station - Heping Island(Xiangfeng St.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE29",
        "StopID": "29",
        "StopName": {
            "Zh_tw": "忠一路孝一路口",
            "En": "Zhong 1st Rd. & Xiao 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.130586,
            "PositionLon": 121.741375
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3492",
        "StopID": "3492",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.127648,
            "PositionLon": 121.762035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE433",
        "StopID": "433",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1280",
        "StopID": "1280",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.12962,
            "PositionLon": 121.761291
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2191",
        "StopID": "2191",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1281",
        "StopID": "1281",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.131025,
            "PositionLon": 121.75968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1282",
        "StopID": "1282",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.132721,
            "PositionLon": 121.760241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1283",
        "StopID": "1283",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.133826,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1349",
        "StopID": "1349",
        "StopName": {
            "Zh_tw": "豐稔街",
            "En": "Fengren St."
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.140083,
            "PositionLon": 121.76115
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE102",
        "StopID": "102",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.151109,
            "PositionLon": 121.771843
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3521",
        "StopID": "3521",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)(返)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9",
        "StopID": "9",
        "StopName": {
            "Zh_tw": "和平島(返)",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3524",
        "StopID": "3524",
        "StopName": {
            "Zh_tw": "阿拉寶灣",
            "En": "Alabao Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.156185,
            "PositionLon": 121.770581
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE2061",
    "RouteID": "2061",
    "RouteName": {
        "Zh_tw": "206 崇法國宅-基隆車站",
        "En": "206 Chongfaguozhai - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE2061",
    "SubRouteID": "2061",
    "SubRouteName": {
        "Zh_tw": "206 崇法國宅-基隆車站",
        "En": "206 Chongfaguozhai - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1254",
        "StopID": "1254",
        "StopName": {
            "Zh_tw": "崇法國宅",
            "En": "Chongfa Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.134983,
            "PositionLon": 121.768316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1256",
        "StopID": "1256",
        "StopName": {
            "Zh_tw": "崇法街117號",
            "En": "No.117, Chongfa St."
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.131433,
            "PositionLon": 121.765616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1257",
        "StopID": "1257",
        "StopName": {
            "Zh_tw": "新桃花源社區",
            "En": "New Taohuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.133089,
            "PositionLon": 121.763069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1258",
        "StopID": "1258",
        "StopName": {
            "Zh_tw": "威鎮八方社區",
            "En": "Weizhenbafang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.13451,
            "PositionLon": 121.762481
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1259",
        "StopID": "1259",
        "StopName": {
            "Zh_tw": "市民活動中心",
            "En": "Citizen Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.13391,
            "PositionLon": 121.76014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1260",
        "StopID": "1260",
        "StopName": {
            "Zh_tw": "體育場",
            "En": "Municipal Stadium"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.132216,
            "PositionLon": 121.760383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1261",
        "StopID": "1261",
        "StopName": {
            "Zh_tw": "東信國小",
            "En": "Dongshin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.131073,
            "PositionLon": 121.759563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2192",
        "StopID": "2192",
        "StopName": {
            "Zh_tw": "正信路24之24號",
            "En": "No.24-24, Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.131122,
            "PositionLon": 121.761464
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1262",
        "StopID": "1262",
        "StopName": {
            "Zh_tw": "正信路",
            "En": "Zhengxin Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.130031,
            "PositionLon": 121.761318
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 85,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 86,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 87,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 88,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 89,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 90,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 91,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 92,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3011",
    "RouteID": "3011",
    "RouteName": {
        "Zh_tw": "301 太白莊-經中山一路",
        "En": "301 Taibai Village - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3011",
    "SubRouteID": "3011",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經中山一路",
        "En": "301 Taibai Village - Via Zhongshan 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1390",
        "StopID": "1390",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 93,
        "StopPosition": {
            "PositionLat": 25.15252,
            "PositionLon": 121.744485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3534",
        "StopID": "3534",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 94,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1392",
        "StopID": "1392",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 95,
        "StopPosition": {
            "PositionLat": 25.149643,
            "PositionLon": 121.744025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1393",
        "StopID": "1393",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 96,
        "StopPosition": {
            "PositionLat": 25.148793,
            "PositionLon": 121.745356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 97,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 98,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 99,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 100,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 101,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 102,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3528",
        "StopID": "3528",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 103,
        "StopPosition": {
            "PositionLat": 25.144432,
            "PositionLon": 121.73863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 104,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 105,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 106,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 107,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 108,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 109,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 110,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 111,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 112,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 113,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3011",
    "RouteID": "3011",
    "RouteName": {
        "Zh_tw": "301 太白莊-經中山一路",
        "En": "301 Taibai Village - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3011",
    "SubRouteID": "3011",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經中山一路",
        "En": "301 Taibai Village - Via Zhongshan 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3529",
        "StopID": "3529",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144706,
            "PositionLon": 121.739121
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3012",
    "RouteID": "3012",
    "RouteName": {
        "Zh_tw": "301 太白莊-經成功市場",
        "En": "301 Taibai Village - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3012",
    "SubRouteID": "3012",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經成功市場",
        "En": "301 Taibai Village - Via Chengong Market"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1390",
        "StopID": "1390",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.15252,
            "PositionLon": 121.744485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3534",
        "StopID": "3534",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1392",
        "StopID": "1392",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.149643,
            "PositionLon": 121.744025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1393",
        "StopID": "1393",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.148793,
            "PositionLon": 121.745356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3528",
        "StopID": "3528",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144432,
            "PositionLon": 121.73863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3012",
    "RouteID": "3012",
    "RouteName": {
        "Zh_tw": "301 太白莊-經成功市場",
        "En": "301 Taibai Village - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3012",
    "SubRouteID": "3012",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經成功市場",
        "En": "301 Taibai Village - Via Chengong Market"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3529",
        "StopID": "3529",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144706,
            "PositionLon": 121.739121
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3013",
    "RouteID": "3013",
    "RouteName": {
        "Zh_tw": "301 太白莊-經高遠新村",
        "En": "301 Taibai Village - Via Gaoyuanxincun Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3013",
    "SubRouteID": "3013",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經高遠新村",
        "En": "301 Taibai Village - Via Gaoyuanxincun Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1390",
        "StopID": "1390",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.15252,
            "PositionLon": 121.744485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3534",
        "StopID": "3534",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1392",
        "StopID": "1392",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.149643,
            "PositionLon": 121.744025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1393",
        "StopID": "1393",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.148793,
            "PositionLon": 121.745356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3528",
        "StopID": "3528",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144432,
            "PositionLon": 121.73863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3013",
    "RouteID": "3013",
    "RouteName": {
        "Zh_tw": "301 太白莊-經高遠新村",
        "En": "301 Taibai Village - Via Gaoyuanxincun Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3013",
    "SubRouteID": "3013",
    "SubRouteName": {
        "Zh_tw": "301 太白莊-經高遠新村",
        "En": "301 Taibai Village - Via Gaoyuanxincun Community"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3529",
        "StopID": "3529",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144706,
            "PositionLon": 121.739121
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1649",
        "StopID": "1649",
        "StopName": {
            "Zh_tw": "高遠新村",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.142058,
            "PositionLon": 121.745113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1628",
        "StopID": "1628",
        "StopName": {
            "Zh_tw": "中和國宅",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE788",
        "StopID": "788",
        "StopName": {
            "Zh_tw": "聖安宮",
            "En": "Shenan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.144034,
            "PositionLon": 121.747459
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1618",
        "StopID": "1618",
        "StopName": {
            "Zh_tw": "中和國宅",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1619",
        "StopID": "1619",
        "StopName": {
            "Zh_tw": "高遠新村",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142676,
            "PositionLon": 121.745638
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3021",
    "RouteID": "3021",
    "RouteName": {
        "Zh_tw": "302 中山高中-經西定路",
        "En": "302 Zhongshan Senior High School - Via Xiding Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3021",
    "SubRouteID": "3021",
    "SubRouteName": {
        "Zh_tw": "302 中山高中-經西定路",
        "En": "302 Zhongshan Senior High School - Via Xiding Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1390",
        "StopID": "1390",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.15252,
            "PositionLon": 121.744485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3534",
        "StopID": "3534",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1392",
        "StopID": "1392",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.149643,
            "PositionLon": 121.744025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1393",
        "StopID": "1393",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.148793,
            "PositionLon": 121.745356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3509",
        "StopID": "3509",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.145446,
            "PositionLon": 121.73879
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1445",
        "StopID": "1445",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.145506,
            "PositionLon": 121.738725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1446",
        "StopID": "1446",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147336,
            "PositionLon": 121.73829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1447",
        "StopID": "1447",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149406,
            "PositionLon": 121.737368
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1448",
        "StopID": "1448",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.152171,
            "PositionLon": 121.736561
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1449",
        "StopID": "1449",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.153761,
            "PositionLon": 121.734321
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1450",
        "StopID": "1450",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154331,
            "PositionLon": 121.732236
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1451",
        "StopID": "1451",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.15287,
            "PositionLon": 121.729868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1452",
        "StopID": "1452",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151448,
            "PositionLon": 121.728435
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1453",
        "StopID": "1453",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150286,
            "PositionLon": 121.72768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1454",
        "StopID": "1454",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149551,
            "PositionLon": 121.72686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1455",
        "StopID": "1455",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14831,
            "PositionLon": 121.72581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3510",
        "StopID": "3510",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.146443,
            "PositionLon": 121.72613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1457",
        "StopID": "1457",
        "StopName": {
            "Zh_tw": "復興路101號",
            "En": "No.101, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14477,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3021",
    "RouteID": "3021",
    "RouteName": {
        "Zh_tw": "302 中山高中-經西定路",
        "En": "302 Zhongshan Senior High School - Via Xiding Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3021",
    "SubRouteID": "3021",
    "SubRouteName": {
        "Zh_tw": "302 中山高中-經西定路",
        "En": "302 Zhongshan Senior High School - Via Xiding Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1480",
        "StopID": "1480",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144663,
            "PositionLon": 121.726258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1487",
        "StopID": "1487",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154206,
            "PositionLon": 121.732146
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1488",
        "StopID": "1488",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.153751,
            "PositionLon": 121.734181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1489",
        "StopID": "1489",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152236,
            "PositionLon": 121.73628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1490",
        "StopID": "1490",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150658,
            "PositionLon": 121.73623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1491",
        "StopID": "1491",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149215,
            "PositionLon": 121.737228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1492",
        "StopID": "1492",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147373,
            "PositionLon": 121.738161
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3516",
        "StopID": "3516",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.145471,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3022",
    "RouteID": "3022",
    "RouteName": {
        "Zh_tw": "302 中山高中-經成功市場",
        "En": "302 Zhongshan Senior High School - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3022",
    "SubRouteID": "3022",
    "SubRouteName": {
        "Zh_tw": "302 中山高中-經成功市場",
        "En": "302 Zhongshan Senior High School - Via Chengong Market"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1390",
        "StopID": "1390",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.15252,
            "PositionLon": 121.744485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3534",
        "StopID": "3534",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1392",
        "StopID": "1392",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.149643,
            "PositionLon": 121.744025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1393",
        "StopID": "1393",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.148793,
            "PositionLon": 121.745356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3509",
        "StopID": "3509",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.145446,
            "PositionLon": 121.73879
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1445",
        "StopID": "1445",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.145506,
            "PositionLon": 121.738725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1446",
        "StopID": "1446",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147336,
            "PositionLon": 121.73829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1447",
        "StopID": "1447",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149406,
            "PositionLon": 121.737368
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1448",
        "StopID": "1448",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.152171,
            "PositionLon": 121.736561
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1449",
        "StopID": "1449",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.153761,
            "PositionLon": 121.734321
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1450",
        "StopID": "1450",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154331,
            "PositionLon": 121.732236
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1451",
        "StopID": "1451",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.15287,
            "PositionLon": 121.729868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1452",
        "StopID": "1452",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.151448,
            "PositionLon": 121.728435
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1453",
        "StopID": "1453",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150286,
            "PositionLon": 121.72768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1454",
        "StopID": "1454",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149551,
            "PositionLon": 121.72686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1455",
        "StopID": "1455",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14831,
            "PositionLon": 121.72581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3510",
        "StopID": "3510",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.146443,
            "PositionLon": 121.72613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1457",
        "StopID": "1457",
        "StopName": {
            "Zh_tw": "復興路101號",
            "En": "No.101, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14477,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3022",
    "RouteID": "3022",
    "RouteName": {
        "Zh_tw": "302 中山高中-經成功市場",
        "En": "302 Zhongshan Senior High School - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3022",
    "SubRouteID": "3022",
    "SubRouteName": {
        "Zh_tw": "302 中山高中-經成功市場",
        "En": "302 Zhongshan Senior High School - Via Chengong Market"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1480",
        "StopID": "1480",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144663,
            "PositionLon": 121.726258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1487",
        "StopID": "1487",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154206,
            "PositionLon": 121.732146
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1488",
        "StopID": "1488",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.153751,
            "PositionLon": 121.734181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1489",
        "StopID": "1489",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152236,
            "PositionLon": 121.73628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1490",
        "StopID": "1490",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.150658,
            "PositionLon": 121.73623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1491",
        "StopID": "1491",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149215,
            "PositionLon": 121.737228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1492",
        "StopID": "1492",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147373,
            "PositionLon": 121.738161
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3516",
        "StopID": "3516",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.145471,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3031",
    "RouteID": "3031",
    "RouteName": {
        "Zh_tw": "303 大竿林-經西定路",
        "En": "303 Daganlin - Via Xiding Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3031",
    "SubRouteID": "3031",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-經西定路",
        "En": "303 Daganlin - Via Xiding Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1579",
        "StopID": "1579",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.154958,
            "PositionLon": 121.716556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1580",
        "StopID": "1580",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.153458,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1581",
        "StopID": "1581",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.152048,
            "PositionLon": 121.716953
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1582",
        "StopID": "1582",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.149869,
            "PositionLon": 121.717956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1583",
        "StopID": "1583",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.148911,
            "PositionLon": 121.719141
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1584",
        "StopID": "1584",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.147536,
            "PositionLon": 121.719756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3031",
    "RouteID": "3031",
    "RouteName": {
        "Zh_tw": "303 大竿林-經西定路",
        "En": "303 Daganlin - Via Xiding Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3031",
    "SubRouteID": "3031",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-經西定路",
        "En": "303 Daganlin - Via Xiding Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1586",
        "StopID": "1586",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144035,
            "PositionLon": 121.723225
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1610",
        "StopID": "1610",
        "StopName": {
            "Zh_tw": "大竿林(二)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144851,
            "PositionLon": 121.722278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1611",
        "StopID": "1611",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146715,
            "PositionLon": 121.72087
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1612",
        "StopID": "1612",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147541,
            "PositionLon": 121.720063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1613",
        "StopID": "1613",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.148826,
            "PositionLon": 121.719513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1614",
        "StopID": "1614",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14973,
            "PositionLon": 121.718132
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1615",
        "StopID": "1615",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.151856,
            "PositionLon": 121.717003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1616",
        "StopID": "1616",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.153446,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1617",
        "StopID": "1617",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154585,
            "PositionLon": 121.716825
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3032",
    "RouteID": "3032",
    "RouteName": {
        "Zh_tw": "303 大竿林-基隆車站",
        "En": "303 Daganlin - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3032",
    "SubRouteID": "3032",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-基隆車站",
        "En": "303 Daganlin - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1582",
        "StopID": "1582",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.149869,
            "PositionLon": 121.717956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1583",
        "StopID": "1583",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.148911,
            "PositionLon": 121.719141
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1584",
        "StopID": "1584",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.147536,
            "PositionLon": 121.719756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3033",
    "RouteID": "3033",
    "RouteName": {
        "Zh_tw": "303 大竿林-基隆車站",
        "En": "303 Daganlin - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3033",
    "SubRouteID": "3033",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-基隆車站",
        "En": "303 Daganlin - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1579",
        "StopID": "1579",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154958,
            "PositionLon": 121.716556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1580",
        "StopID": "1580",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.153458,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1581",
        "StopID": "1581",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.152048,
            "PositionLon": 121.716953
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1582",
        "StopID": "1582",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.149869,
            "PositionLon": 121.717956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1583",
        "StopID": "1583",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.148911,
            "PositionLon": 121.719141
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1584",
        "StopID": "1584",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.147536,
            "PositionLon": 121.719756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3034",
    "RouteID": "3034",
    "RouteName": {
        "Zh_tw": "303 基隆車站-回大竿林(經西定路)",
        "En": "303 Keelung Station - Via Daganlin"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3034",
    "SubRouteID": "3034",
    "SubRouteName": {
        "Zh_tw": "303 基隆車站-回大竿林(經西定路)",
        "En": "303 Keelung Station - Via Daganlin"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1586",
        "StopID": "1586",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.144035,
            "PositionLon": 121.723225
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1610",
        "StopID": "1610",
        "StopName": {
            "Zh_tw": "大竿林(二)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.144851,
            "PositionLon": 121.722278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1611",
        "StopID": "1611",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.146715,
            "PositionLon": 121.72087
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1612",
        "StopID": "1612",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.147541,
            "PositionLon": 121.720063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1613",
        "StopID": "1613",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.148826,
            "PositionLon": 121.719513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1614",
        "StopID": "1614",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.14973,
            "PositionLon": 121.718132
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1615",
        "StopID": "1615",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.151856,
            "PositionLon": 121.717003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1616",
        "StopID": "1616",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.153446,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1617",
        "StopID": "1617",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.154585,
            "PositionLon": 121.716825
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3035",
    "RouteID": "3035",
    "RouteName": {
        "Zh_tw": "303 大竿林-回經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3035",
    "SubRouteID": "3035",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-回經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1579",
        "StopID": "1579",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.154958,
            "PositionLon": 121.716556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1580",
        "StopID": "1580",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.153458,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1581",
        "StopID": "1581",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.152048,
            "PositionLon": 121.716953
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1582",
        "StopID": "1582",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.149869,
            "PositionLon": 121.717956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1583",
        "StopID": "1583",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.148911,
            "PositionLon": 121.719141
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1584",
        "StopID": "1584",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.147536,
            "PositionLon": 121.719756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3035",
    "RouteID": "3035",
    "RouteName": {
        "Zh_tw": "303 大竿林-回經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3035",
    "SubRouteID": "3035",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-回經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3509",
        "StopID": "3509",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.145446,
            "PositionLon": 121.73879
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1445",
        "StopID": "1445",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.145506,
            "PositionLon": 121.738725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1446",
        "StopID": "1446",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.147336,
            "PositionLon": 121.73829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1447",
        "StopID": "1447",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149406,
            "PositionLon": 121.737368
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1448",
        "StopID": "1448",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.152171,
            "PositionLon": 121.736561
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1449",
        "StopID": "1449",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.153761,
            "PositionLon": 121.734321
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1450",
        "StopID": "1450",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.154331,
            "PositionLon": 121.732236
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1451",
        "StopID": "1451",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.15287,
            "PositionLon": 121.729868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1452",
        "StopID": "1452",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.151448,
            "PositionLon": 121.728435
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1453",
        "StopID": "1453",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.150286,
            "PositionLon": 121.72768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1454",
        "StopID": "1454",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.149551,
            "PositionLon": 121.72686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1455",
        "StopID": "1455",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.14831,
            "PositionLon": 121.72581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3510",
        "StopID": "3510",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.146443,
            "PositionLon": 121.72613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3532",
        "StopID": "3532",
        "StopName": {
            "Zh_tw": "復興路101號",
            "En": "No.101, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.726162
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1586",
        "StopID": "1586",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.144035,
            "PositionLon": 121.723225
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1610",
        "StopID": "1610",
        "StopName": {
            "Zh_tw": "大竿林(二)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.144851,
            "PositionLon": 121.722278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1611",
        "StopID": "1611",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.146715,
            "PositionLon": 121.72087
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1612",
        "StopID": "1612",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.147541,
            "PositionLon": 121.720063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1613",
        "StopID": "1613",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.148826,
            "PositionLon": 121.719513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1614",
        "StopID": "1614",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.14973,
            "PositionLon": 121.718132
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1615",
        "StopID": "1615",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.151856,
            "PositionLon": 121.717003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1616",
        "StopID": "1616",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.153446,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1617",
        "StopID": "1617",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.154585,
            "PositionLon": 121.716825
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3036",
    "RouteID": "3036",
    "RouteName": {
        "Zh_tw": "303 大竿林-去經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3036",
    "SubRouteID": "3036",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-去經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1579",
        "StopID": "1579",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.154958,
            "PositionLon": 121.716556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1580",
        "StopID": "1580",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.153458,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1581",
        "StopID": "1581",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.152048,
            "PositionLon": 121.716953
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1582",
        "StopID": "1582",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.149869,
            "PositionLon": 121.717956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1583",
        "StopID": "1583",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.148911,
            "PositionLon": 121.719141
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1584",
        "StopID": "1584",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.147536,
            "PositionLon": 121.719756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3713",
        "StopID": "3713",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144758,
            "PositionLon": 121.726181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1487",
        "StopID": "1487",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.154206,
            "PositionLon": 121.732146
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1488",
        "StopID": "1488",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.153751,
            "PositionLon": 121.734181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1489",
        "StopID": "1489",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.152236,
            "PositionLon": 121.73628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1490",
        "StopID": "1490",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.150658,
            "PositionLon": 121.73623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1491",
        "StopID": "1491",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.149215,
            "PositionLon": 121.737228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1492",
        "StopID": "1492",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.147373,
            "PositionLon": 121.738161
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3516",
        "StopID": "3516",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.145471,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3036",
    "RouteID": "3036",
    "RouteName": {
        "Zh_tw": "303 大竿林-去經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3036",
    "SubRouteID": "3036",
    "SubRouteName": {
        "Zh_tw": "303 大竿林-去經中山一路",
        "En": "303 Daganlin - Via Zhongshan 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1586",
        "StopID": "1586",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144035,
            "PositionLon": 121.723225
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1610",
        "StopID": "1610",
        "StopName": {
            "Zh_tw": "大竿林(二)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144851,
            "PositionLon": 121.722278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1611",
        "StopID": "1611",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146715,
            "PositionLon": 121.72087
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1612",
        "StopID": "1612",
        "StopName": {
            "Zh_tw": "中和國小後站",
            "En": "Zhonghe Elementary School Rear Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147541,
            "PositionLon": 121.720063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1613",
        "StopID": "1613",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.148826,
            "PositionLon": 121.719513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1614",
        "StopID": "1614",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14973,
            "PositionLon": 121.718132
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1615",
        "StopID": "1615",
        "StopName": {
            "Zh_tw": "大慶大城(二)",
            "En": "Daqingdacheng(2)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.151856,
            "PositionLon": 121.717003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1616",
        "StopID": "1616",
        "StopName": {
            "Zh_tw": "中和路200巷",
            "En": "Ln. 200, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.153446,
            "PositionLon": 121.717438
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1617",
        "StopID": "1617",
        "StopName": {
            "Zh_tw": "富都新城",
            "En": "Fudouxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154585,
            "PositionLon": 121.716825
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3041",
    "RouteID": "3041",
    "RouteName": {
        "Zh_tw": "304 高遠新村-經仙洞國小",
        "En": "304 Gaoyuanxincun Community - Via Xiandong Elementary School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3041",
    "SubRouteID": "3041",
    "SubRouteName": {
        "Zh_tw": "304 高遠新村-經仙洞國小",
        "En": "304 Gaoyuanxincun Community - Via Xiandong Elementary School"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE777",
        "StopID": "777",
        "StopName": {
            "Zh_tw": "聖安宮",
            "En": "Shenan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.144034,
            "PositionLon": 121.747459
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1618",
        "StopID": "1618",
        "StopName": {
            "Zh_tw": "中和國宅",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1619",
        "StopID": "1619",
        "StopName": {
            "Zh_tw": "高遠新村",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.142676,
            "PositionLon": 121.745638
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1394",
        "StopID": "1394",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.146776,
            "PositionLon": 121.747211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1395",
        "StopID": "1395",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.145395,
            "PositionLon": 121.748108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1396",
        "StopID": "1396",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.144718,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1397",
        "StopID": "1397",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.141891,
            "PositionLon": 121.746828
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3528",
        "StopID": "3528",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144432,
            "PositionLon": 121.73863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3041",
    "RouteID": "3041",
    "RouteName": {
        "Zh_tw": "304 高遠新村-經仙洞國小",
        "En": "304 Gaoyuanxincun Community - Via Xiandong Elementary School"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3041",
    "SubRouteID": "3041",
    "SubRouteName": {
        "Zh_tw": "304 高遠新村-經仙洞國小",
        "En": "304 Gaoyuanxincun Community - Via Xiandong Elementary School"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3529",
        "StopID": "3529",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144706,
            "PositionLon": 121.739121
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3042",
    "RouteID": "3042",
    "RouteName": {
        "Zh_tw": "304 高遠新村-經中山一路",
        "En": "304 Gaoyuanxincun Community - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3042",
    "SubRouteID": "3042",
    "SubRouteName": {
        "Zh_tw": "304 高遠新村-經中山一路",
        "En": "304 Gaoyuanxincun Community - Via Zhongshan 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE777",
        "StopID": "777",
        "StopName": {
            "Zh_tw": "聖安宮",
            "En": "Shenan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.144034,
            "PositionLon": 121.747459
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1618",
        "StopID": "1618",
        "StopName": {
            "Zh_tw": "中和國宅",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1619",
        "StopID": "1619",
        "StopName": {
            "Zh_tw": "高遠新村",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.142676,
            "PositionLon": 121.745638
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1398",
        "StopID": "1398",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.140388,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1400",
        "StopID": "1400",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.742245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3528",
        "StopID": "3528",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.144432,
            "PositionLon": 121.73863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3042",
    "RouteID": "3042",
    "RouteName": {
        "Zh_tw": "304 高遠新村-經中山一路",
        "En": "304 Gaoyuanxincun Community - Via Zhongshan 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3042",
    "SubRouteID": "3042",
    "SubRouteName": {
        "Zh_tw": "304 高遠新村-經中山一路",
        "En": "304 Gaoyuanxincun Community - Via Zhongshan 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE377",
        "StopID": "377",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129453,
            "PositionLon": 121.74007
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3529",
        "StopID": "3529",
        "StopName": {
            "Zh_tw": "海三廠",
            "En": "Third Naval Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.144706,
            "PositionLon": 121.739121
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1649",
        "StopID": "1649",
        "StopName": {
            "Zh_tw": "高遠新村",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.142058,
            "PositionLon": 121.745113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1628",
        "StopID": "1628",
        "StopName": {
            "Zh_tw": "中和國宅",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE788",
        "StopID": "788",
        "StopName": {
            "Zh_tw": "聖安宮",
            "En": "Shenan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.144034,
            "PositionLon": 121.747459
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1638",
        "StopID": "1638",
        "StopName": {
            "Zh_tw": "中和國宅(返)",
            "En": "Zhonghe Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.144229,
            "PositionLon": 121.744851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1639",
        "StopID": "1639",
        "StopName": {
            "Zh_tw": "高遠新村(返)",
            "En": "Gaoyuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142676,
            "PositionLon": 121.745638
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3051",
    "RouteID": "3051",
    "RouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(經西定路)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Xiding Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3051",
    "SubRouteID": "3051",
    "SubRouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(經西定路)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Xiding Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1480",
        "StopID": "1480",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144663,
            "PositionLon": 121.726258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1487",
        "StopID": "1487",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154206,
            "PositionLon": 121.732146
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1750",
        "StopID": "1750",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.154726,
            "PositionLon": 121.732089
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1761",
        "StopID": "1761",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.122909,
            "PositionLon": 121.722869
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1720",
        "StopID": "1720",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.16035,
            "PositionLon": 121.732162
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3751",
        "StopID": "3751",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.162984,
            "PositionLon": 121.727065
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3752",
        "StopID": "3752",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.164247,
            "PositionLon": 121.723079
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3753",
        "StopID": "3753",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.164925,
            "PositionLon": 121.716491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3755",
        "StopID": "3755",
        "StopName": {
            "Zh_tw": "大武崙沙灘",
            "En": "Tapurun Sandbeach"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.164295,
            "PositionLon": 121.707986
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3051",
    "RouteID": "3051",
    "RouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(經西定路)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Xiding Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3051",
    "SubRouteID": "3051",
    "SubRouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(經西定路)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Xiding Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3756",
        "StopID": "3756",
        "StopName": {
            "Zh_tw": "大武崙沙灘停車場",
            "En": "Tapurun Sandbeach Parking Lot"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.168042,
            "PositionLon": 121.707404
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3757",
        "StopID": "3757",
        "StopName": {
            "Zh_tw": "湖海路二段142號",
            "En": "No.142, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.165669,
            "PositionLon": 121.706427
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3750",
        "StopID": "3750",
        "StopName": {
            "Zh_tw": "大武崙沙灘",
            "En": "Tapurun Sandbeach"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.164295,
            "PositionLon": 121.707819
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3758",
        "StopID": "3758",
        "StopName": {
            "Zh_tw": "湖海路二段71號",
            "En": "No.71, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.16378,
            "PositionLon": 121.71173
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3754",
        "StopID": "3754",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.16389,
            "PositionLon": 121.711666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3759",
        "StopID": "3759",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.16414,
            "PositionLon": 121.723353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3760",
        "StopID": "3760",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.162928,
            "PositionLon": 121.726877
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1722",
        "StopID": "1722",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.160209,
            "PositionLon": 121.732307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1723",
        "StopID": "1723",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.155809,
            "PositionLon": 121.730361
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1724",
        "StopID": "1724",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.154934,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1451",
        "StopID": "1451",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.15287,
            "PositionLon": 121.729868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1452",
        "StopID": "1452",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.151448,
            "PositionLon": 121.728435
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1453",
        "StopID": "1453",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.150286,
            "PositionLon": 121.72768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1454",
        "StopID": "1454",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149551,
            "PositionLon": 121.72686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1455",
        "StopID": "1455",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14831,
            "PositionLon": 121.72581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3510",
        "StopID": "3510",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.146443,
            "PositionLon": 121.72613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1457",
        "StopID": "1457",
        "StopName": {
            "Zh_tw": "復興路101號",
            "En": "No.101, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14477,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3052",
    "RouteID": "3052",
    "RouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(回太白莊)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Taibai Village)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3052",
    "SubRouteID": "3052",
    "SubRouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(回太白莊)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Taibai Village)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1480",
        "StopID": "1480",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144663,
            "PositionLon": 121.726258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1487",
        "StopID": "1487",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154206,
            "PositionLon": 121.732146
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1750",
        "StopID": "1750",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.154726,
            "PositionLon": 121.732089
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1761",
        "StopID": "1761",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.122909,
            "PositionLon": 121.722869
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1720",
        "StopID": "1720",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.16035,
            "PositionLon": 121.732162
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3751",
        "StopID": "3751",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.162984,
            "PositionLon": 121.727065
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3752",
        "StopID": "3752",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.164247,
            "PositionLon": 121.723079
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3753",
        "StopID": "3753",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.164925,
            "PositionLon": 121.716491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3755",
        "StopID": "3755",
        "StopName": {
            "Zh_tw": "大武崙沙灘",
            "En": "Tapurun Sandbeach"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.164295,
            "PositionLon": 121.707986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3756",
        "StopID": "3756",
        "StopName": {
            "Zh_tw": "大武崙沙灘停車場",
            "En": "Tapurun Sandbeach Parking Lot"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.168042,
            "PositionLon": 121.707404
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3757",
        "StopID": "3757",
        "StopName": {
            "Zh_tw": "湖海路二段142號",
            "En": "No.142, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.165669,
            "PositionLon": 121.706427
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3052",
    "RouteID": "3052",
    "RouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(回太白莊)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Taibai Village)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3052",
    "SubRouteID": "3052",
    "SubRouteName": {
        "Zh_tw": "305 濱海大道-大武崙沙灘(回太白莊)",
        "En": "305 Binhai Blvd - Waimusan Harbor(Taibai Village)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3750",
        "StopID": "3750",
        "StopName": {
            "Zh_tw": "大武崙沙灘",
            "En": "Tapurun Sandbeach"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.164295,
            "PositionLon": 121.707819
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3758",
        "StopID": "3758",
        "StopName": {
            "Zh_tw": "湖海路二段71號",
            "En": "No.71, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.16378,
            "PositionLon": 121.71173
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3754",
        "StopID": "3754",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.16389,
            "PositionLon": 121.711666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3759",
        "StopID": "3759",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.16414,
            "PositionLon": 121.723353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3760",
        "StopID": "3760",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.162928,
            "PositionLon": 121.726877
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1722",
        "StopID": "1722",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.160209,
            "PositionLon": 121.732307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1723",
        "StopID": "1723",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.155809,
            "PositionLon": 121.730361
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1724",
        "StopID": "1724",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.154934,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1488",
        "StopID": "1488",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.153751,
            "PositionLon": 121.734181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1489",
        "StopID": "1489",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.152236,
            "PositionLon": 121.73628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1490",
        "StopID": "1490",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.150658,
            "PositionLon": 121.73623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1491",
        "StopID": "1491",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149215,
            "PositionLon": 121.737228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1492",
        "StopID": "1492",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147373,
            "PositionLon": 121.738161
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3516",
        "StopID": "3516",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145471,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1422",
        "StopID": "1422",
        "StopName": {
            "Zh_tw": "十號碼頭",
            "En": "No. 10 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.143405,
            "PositionLon": 121.74222
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1424",
        "StopID": "1424",
        "StopName": {
            "Zh_tw": "十四號碼頭",
            "En": "No. 14 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.14024,
            "PositionLon": 121.74496
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1425",
        "StopID": "1425",
        "StopName": {
            "Zh_tw": "十六號碼頭",
            "En": "No. 16 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14189,
            "PositionLon": 121.746905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1426",
        "StopID": "1426",
        "StopName": {
            "Zh_tw": "十八號碼頭",
            "En": "No. 18 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.144511,
            "PositionLon": 121.749848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1427",
        "StopID": "1427",
        "StopName": {
            "Zh_tw": "仙洞巖",
            "En": "Fairy Grotto"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.145546,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1428",
        "StopID": "1428",
        "StopName": {
            "Zh_tw": "仙洞國小",
            "En": "Siandong Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.147073,
            "PositionLon": 121.747263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1429",
        "StopID": "1429",
        "StopName": {
            "Zh_tw": "基港里",
            "En": "Jigang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.1489,
            "PositionLon": 121.7452
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1430",
        "StopID": "1430",
        "StopName": {
            "Zh_tw": "太白里",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14948,
            "PositionLon": 121.744178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3517",
        "StopID": "3517",
        "StopName": {
            "Zh_tw": "光華隧道口",
            "En": "Guanghua Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.150598,
            "PositionLon": 121.743448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1432",
        "StopID": "1432",
        "StopName": {
            "Zh_tw": "太白莊",
            "En": "Taibai Village"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.152541,
            "PositionLon": 121.744755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3061",
    "RouteID": "3061",
    "RouteName": {
        "Zh_tw": "306 中平街-基隆車站(經西定路)",
        "En": "306 Zhongping St. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3061",
    "SubRouteID": "3061",
    "SubRouteName": {
        "Zh_tw": "306 中平街-基隆車站(經西定路)",
        "En": "306 Zhongping St. - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1659",
        "StopID": "1659",
        "StopName": {
            "Zh_tw": "西定橋",
            "En": "Xiding Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140926,
            "PositionLon": 121.727065
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1660",
        "StopID": "1660",
        "StopName": {
            "Zh_tw": "中和橋",
            "En": "Zhonghe Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.141558,
            "PositionLon": 121.72526
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3702",
        "StopID": "3702",
        "StopName": {
            "Zh_tw": "中和里活動中心",
            "En": "Activity Center of Zhonghe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14199,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1662",
        "StopID": "1662",
        "StopName": {
            "Zh_tw": "中和里",
            "En": "Zhonghe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.142473,
            "PositionLon": 121.722725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1663",
        "StopID": "1663",
        "StopName": {
            "Zh_tw": "中和路三巷",
            "En": "Ln. 3, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.141966,
            "PositionLon": 121.722433
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3061",
    "RouteID": "3061",
    "RouteName": {
        "Zh_tw": "306 中平街-基隆車站(經西定路)",
        "En": "306 Zhongping St. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3061",
    "SubRouteID": "3061",
    "SubRouteName": {
        "Zh_tw": "306 中平街-基隆車站(經西定路)",
        "En": "306 Zhongping St. - Keelung Station"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1665",
        "StopID": "1665",
        "StopName": {
            "Zh_tw": "中和里",
            "En": "Zhonghe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.142235,
            "PositionLon": 121.72256
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3703",
        "StopID": "3703",
        "StopName": {
            "Zh_tw": "中和里活動中心",
            "En": "Activity Center of Zhonghe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.141826,
            "PositionLon": 121.723506
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1667",
        "StopID": "1667",
        "StopName": {
            "Zh_tw": "中和橋",
            "En": "Zhonghe Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.141686,
            "PositionLon": 121.725068
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1668",
        "StopID": "1668",
        "StopName": {
            "Zh_tw": "西定橋",
            "En": "Xiding Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.141185,
            "PositionLon": 121.726271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3071",
    "RouteID": "3071",
    "RouteName": {
        "Zh_tw": "307 中和國小-基隆車站(經西定路)",
        "En": "307 Zhonghe Elementary School - Keelung Station(Xiding Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3071",
    "SubRouteID": "3071",
    "SubRouteName": {
        "Zh_tw": "307 中和國小-基隆車站(經西定路)",
        "En": "307 Zhonghe Elementary School - Keelung Station(Xiding Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1459",
        "StopID": "1459",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.141479,
            "PositionLon": 121.726982
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1458",
        "StopID": "1458",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.143288,
            "PositionLon": 121.726078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1586",
        "StopID": "1586",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144035,
            "PositionLon": 121.723225
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1610",
        "StopID": "1610",
        "StopName": {
            "Zh_tw": "大竿林(二)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.144851,
            "PositionLon": 121.722278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3705",
        "StopID": "3705",
        "StopName": {
            "Zh_tw": "喜市(中和路85巷16號)",
            "En": "Xi Market (No.16, Ln. 85, Zhonghe Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.146525,
            "PositionLon": 121.720856
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1611",
        "StopID": "1611",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.146715,
            "PositionLon": 121.72087
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3706",
        "StopID": "3706",
        "StopName": {
            "Zh_tw": "麗景山莊",
            "En": "Lijingshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.147296,
            "PositionLon": 121.720203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1613",
        "StopID": "1613",
        "StopName": {
            "Zh_tw": "代天宮",
            "En": "Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.148826,
            "PositionLon": 121.719513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1614",
        "StopID": "1614",
        "StopName": {
            "Zh_tw": "大慶大城社區",
            "En": "Daqingdacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14973,
            "PositionLon": 121.718132
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3707",
        "StopID": "3707",
        "StopName": {
            "Zh_tw": "中和路168巷7弄19號",
            "En": "No.19, Aly. 7, Ln. 168, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.150011,
            "PositionLon": 121.715993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3708",
        "StopID": "3708",
        "StopName": {
            "Zh_tw": "和慶里",
            "En": "Heqing Village"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.150645,
            "PositionLon": 121.714366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3709",
        "StopID": "3709",
        "StopName": {
            "Zh_tw": "中和路164巷5號",
            "En": "No.5, Ln. 164, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.149631,
            "PositionLon": 121.715135
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3710",
        "StopID": "3710",
        "StopName": {
            "Zh_tw": "中和路164巷20號",
            "En": "No.20, Ln. 164, Zhonghe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.148531,
            "PositionLon": 121.717618
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3071",
    "RouteID": "3071",
    "RouteName": {
        "Zh_tw": "307 中和國小-基隆車站(經西定路)",
        "En": "307 Zhonghe Elementary School - Keelung Station(Xiding Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3071",
    "SubRouteID": "3071",
    "SubRouteName": {
        "Zh_tw": "307 中和國小-基隆車站(經西定路)",
        "En": "307 Zhonghe Elementary School - Keelung Station(Xiding Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1700",
        "StopID": "1700",
        "StopName": {
            "Zh_tw": "麗景山莊",
            "En": "Lijingshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.147383,
            "PositionLon": 121.719633
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1585",
        "StopID": "1585",
        "StopName": {
            "Zh_tw": "中和國小",
            "En": "Zhonghe Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.146926,
            "PositionLon": 121.72069
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1578",
        "StopID": "1578",
        "StopName": {
            "Zh_tw": "大竿林(一)",
            "En": "Daganlin"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.144125,
            "PositionLon": 121.723513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2233",
        "StopID": "2233",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139548,
            "PositionLon": 121.729138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3512",
        "StopID": "3512",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.134131,
            "PositionLon": 121.734718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3081",
    "RouteID": "3081",
    "RouteName": {
        "Zh_tw": "308 基隆車站-外木山漁港",
        "En": "308 Keelung Station - Waimusan Harbor"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3081",
    "SubRouteID": "3081",
    "SubRouteName": {
        "Zh_tw": "308 基隆車站-外木山漁港",
        "En": "308 Keelung Station - Waimusan Harbor"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1474",
        "StopID": "1474",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135445,
            "PositionLon": 121.733746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1475",
        "StopID": "1475",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.137163,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1477",
        "StopID": "1477",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.140788,
            "PositionLon": 121.728063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1480",
        "StopID": "1480",
        "StopName": {
            "Zh_tw": "復興路138號",
            "En": "No.138, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144663,
            "PositionLon": 121.726258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3515",
        "StopID": "3515",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146513,
            "PositionLon": 121.726398
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1482",
        "StopID": "1482",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.148243,
            "PositionLon": 121.725848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1483",
        "StopID": "1483",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.726578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1484",
        "StopID": "1484",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.150138,
            "PositionLon": 121.727768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1485",
        "StopID": "1485",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.151736,
            "PositionLon": 121.728741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1486",
        "StopID": "1486",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.152821,
            "PositionLon": 121.729893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1750",
        "StopID": "1750",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154726,
            "PositionLon": 121.732089
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1761",
        "StopID": "1761",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.122909,
            "PositionLon": 121.722869
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1721",
        "StopID": "1721",
        "StopName": {
            "Zh_tw": "外木山漁港",
            "En": "Waimusan Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.159336,
            "PositionLon": 121.732863
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3083",
    "RouteID": "3083",
    "RouteName": {
        "Zh_tw": "308 外木山漁港-基隆車站(經德安路)",
        "En": "308 Waimusan Harbor - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3083",
    "SubRouteID": "3083",
    "SubRouteName": {
        "Zh_tw": "308 外木山漁港-基隆車站(經德安路)",
        "En": "308 Waimusan Harbor - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1721",
        "StopID": "1721",
        "StopName": {
            "Zh_tw": "外木山漁港",
            "En": "Waimusan Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.159336,
            "PositionLon": 121.732863
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1722",
        "StopID": "1722",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.160209,
            "PositionLon": 121.732307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1723",
        "StopID": "1723",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.155809,
            "PositionLon": 121.730361
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1724",
        "StopID": "1724",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.154934,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1451",
        "StopID": "1451",
        "StopName": {
            "Zh_tw": "中山區行政大樓",
            "En": "Administration Building of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.15287,
            "PositionLon": 121.729868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1452",
        "StopID": "1452",
        "StopName": {
            "Zh_tw": "復興公寓",
            "En": "Fuxinggongyu"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.151448,
            "PositionLon": 121.728435
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1453",
        "StopID": "1453",
        "StopName": {
            "Zh_tw": "經國學院",
            "En": "Ching Kuo Institute of Management and Health"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.150286,
            "PositionLon": 121.72768
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1454",
        "StopID": "1454",
        "StopName": {
            "Zh_tw": "復興路283巷",
            "En": "Ln. 283, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.149551,
            "PositionLon": 121.72686
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3712",
        "StopID": "3712",
        "StopName": {
            "Zh_tw": "德安路",
            "En": "Dean Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.148706,
            "PositionLon": 121.725951
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1455",
        "StopID": "1455",
        "StopName": {
            "Zh_tw": "德安路口孚基煤礦",
            "En": "Dean Rd. Intersection (Fuji Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.14831,
            "PositionLon": 121.72581
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3510",
        "StopID": "3510",
        "StopName": {
            "Zh_tw": "統一新城",
            "En": "Tongyixincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.146443,
            "PositionLon": 121.72613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3532",
        "StopID": "3532",
        "StopName": {
            "Zh_tw": "復興路101號",
            "En": "No.101, Fuxing Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.14481,
            "PositionLon": 121.726162
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1479",
        "StopID": "1479",
        "StopName": {
            "Zh_tw": "復興路中和路口",
            "En": "Fuxing Rd. & Zhonghe Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.14287,
            "PositionLon": 121.726206
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3514",
        "StopID": "3514",
        "StopName": {
            "Zh_tw": "復興郵局",
            "En": "Keelung Fuxing Rd. Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.14171,
            "PositionLon": 121.726885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1460",
        "StopID": "1460",
        "StopName": {
            "Zh_tw": "西康里",
            "En": "Xikang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.141319,
            "PositionLon": 121.726989
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1461",
        "StopID": "1461",
        "StopName": {
            "Zh_tw": "烏橋頭",
            "En": "Wuqiaotou"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.140578,
            "PositionLon": 121.727845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2287",
        "StopID": "2287",
        "StopName": {
            "Zh_tw": "花園新城",
            "En": "Huayuanxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.139221,
            "PositionLon": 121.729586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1463",
        "StopID": "1463",
        "StopName": {
            "Zh_tw": "西定市場",
            "En": "Xiding Market"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.137468,
            "PositionLon": 121.731596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1464",
        "StopID": "1464",
        "StopName": {
            "Zh_tw": "聖心高中",
            "En": "Sacred Heart High School"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135643,
            "PositionLon": 121.733158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3513",
        "StopID": "3513",
        "StopName": {
            "Zh_tw": "西定郵局(定國橋)",
            "En": "Xiding Post Office (Dingguo Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.134045,
            "PositionLon": 121.734936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1466",
        "StopID": "1466",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.133005,
            "PositionLon": 121.735103
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3101",
    "RouteID": "3101",
    "RouteName": {
        "Zh_tw": "310 濱海大道-大武崙沙灘",
        "En": "310 Binhai Blvd - Tapurun Beach"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3101",
    "SubRouteID": "3101",
    "SubRouteName": {
        "Zh_tw": "310 濱海大道-大武崙沙灘",
        "En": "310 Binhai Blvd - Tapurun Beach"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1414",
        "StopID": "1414",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.13024,
            "PositionLon": 121.736985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1415",
        "StopID": "1415",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.132485,
            "PositionLon": 121.738328
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1416",
        "StopID": "1416",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1417",
        "StopID": "1417",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.135861,
            "PositionLon": 121.740568
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1418",
        "StopID": "1418",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.137546,
            "PositionLon": 121.740838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1419",
        "StopID": "1419",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.140505,
            "PositionLon": 121.739455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1420",
        "StopID": "1420",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.142163,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3509",
        "StopID": "3509",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.145446,
            "PositionLon": 121.73879
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1445",
        "StopID": "1445",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.145506,
            "PositionLon": 121.738725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1446",
        "StopID": "1446",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.147336,
            "PositionLon": 121.73829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1447",
        "StopID": "1447",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.149406,
            "PositionLon": 121.737368
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1448",
        "StopID": "1448",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.152171,
            "PositionLon": 121.736561
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1449",
        "StopID": "1449",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.153761,
            "PositionLon": 121.734321
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1450",
        "StopID": "1450",
        "StopName": {
            "Zh_tw": "中山高中",
            "En": "Zhongshan Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.154331,
            "PositionLon": 121.732236
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1750",
        "StopID": "1750",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.154726,
            "PositionLon": 121.732089
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1761",
        "StopID": "1761",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.122909,
            "PositionLon": 121.722869
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1720",
        "StopID": "1720",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.16035,
            "PositionLon": 121.732162
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3751",
        "StopID": "3751",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.162984,
            "PositionLon": 121.727065
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3752",
        "StopID": "3752",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.164247,
            "PositionLon": 121.723079
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3753",
        "StopID": "3753",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.164925,
            "PositionLon": 121.716491
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE3101",
    "RouteID": "3101",
    "RouteName": {
        "Zh_tw": "310 濱海大道-大武崙沙灘",
        "En": "310 Binhai Blvd - Tapurun Beach"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE3101",
    "SubRouteID": "3101",
    "SubRouteName": {
        "Zh_tw": "310 濱海大道-大武崙沙灘",
        "En": "310 Binhai Blvd - Tapurun Beach"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3755",
        "StopID": "3755",
        "StopName": {
            "Zh_tw": "大武崙沙灘",
            "En": "Tapurun Sandbeach"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.164295,
            "PositionLon": 121.707986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3758",
        "StopID": "3758",
        "StopName": {
            "Zh_tw": "湖海路二段71號",
            "En": "No.71, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.16378,
            "PositionLon": 121.71173
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3754",
        "StopID": "3754",
        "StopName": {
            "Zh_tw": "湖海路2.5公里處",
            "En": "Huhai Rd. 2.5K"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.16389,
            "PositionLon": 121.711666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3759",
        "StopID": "3759",
        "StopName": {
            "Zh_tw": "湖海路一段16號",
            "En": "No.16, Sec. 1, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.16414,
            "PositionLon": 121.723353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3760",
        "StopID": "3760",
        "StopName": {
            "Zh_tw": "情人湖濱海大道紀念碑",
            "En": "Lovers Lake - Binhai Blvd. Memorial Monument"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.162928,
            "PositionLon": 121.726877
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1722",
        "StopID": "1722",
        "StopName": {
            "Zh_tw": "海興游泳池",
            "En": "Haixing Swimming Pool"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.160209,
            "PositionLon": 121.732307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1723",
        "StopID": "1723",
        "StopName": {
            "Zh_tw": "文明路土地廟",
            "En": "Wenming Rd. Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.155809,
            "PositionLon": 121.730361
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1724",
        "StopID": "1724",
        "StopName": {
            "Zh_tw": "文明路口",
            "En": "Wenming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.154934,
            "PositionLon": 121.732198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1488",
        "StopID": "1488",
        "StopName": {
            "Zh_tw": "協和里",
            "En": "Xiehe Village"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.153751,
            "PositionLon": 121.734181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1489",
        "StopID": "1489",
        "StopName": {
            "Zh_tw": "公誠二村",
            "En": "Gongchengercun"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.152236,
            "PositionLon": 121.73628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1490",
        "StopID": "1490",
        "StopName": {
            "Zh_tw": "台肥基隆一廠",
            "En": "Keelung Taifei Factory"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.150658,
            "PositionLon": 121.73623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1491",
        "StopID": "1491",
        "StopName": {
            "Zh_tw": "忠勇之家",
            "En": "Home of Loyalty & Brave"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149215,
            "PositionLon": 121.737228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1492",
        "StopID": "1492",
        "StopName": {
            "Zh_tw": "中華國小",
            "En": "Zhonghua Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.147373,
            "PositionLon": 121.738161
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3516",
        "StopID": "3516",
        "StopName": {
            "Zh_tw": "中華路口",
            "En": "Zhonghua Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.145471,
            "PositionLon": 121.738636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1402",
        "StopID": "1402",
        "StopName": {
            "Zh_tw": "健民街口",
            "En": "Jianmin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.14188,
            "PositionLon": 121.738675
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1403",
        "StopID": "1403",
        "StopName": {
            "Zh_tw": "八號碼頭",
            "En": "No. 8 Wharf"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.14044,
            "PositionLon": 121.739326
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1404",
        "StopID": "1404",
        "StopName": {
            "Zh_tw": "中山區衛生所",
            "En": "Health Center of Zhongshan District"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.137335,
            "PositionLon": 121.740901
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1405",
        "StopID": "1405",
        "StopName": {
            "Zh_tw": "碼頭工會",
            "En": "Longshoremen’s Association"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13562,
            "PositionLon": 121.740376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3535",
        "StopID": "3535",
        "StopName": {
            "Zh_tw": "民治里活動中心",
            "En": "Minzhi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.134543,
            "PositionLon": 121.739673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1406",
        "StopID": "1406",
        "StopName": {
            "Zh_tw": "中山橋(高砂橋)",
            "En": "Zhongshan Bridge (Gaosha Bridge)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134349,
            "PositionLon": 121.739547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1408",
        "StopID": "1408",
        "StopName": {
            "Zh_tw": "三十一號橋",
            "En": "No. 31 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.130173,
            "PositionLon": 121.736805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4021",
    "RouteID": "4021",
    "RouteName": {
        "Zh_tw": "402 堵南里-經七堵郵局",
        "En": "402 Dunan Village - Via Qidu Post Office"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4021",
    "SubRouteID": "4021",
    "SubRouteName": {
        "Zh_tw": "402 堵南里-經七堵郵局",
        "En": "402 Dunan Village - Via Qidu Post Office"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1770",
        "StopID": "1770",
        "StopName": {
            "Zh_tw": "堵南里",
            "En": "Dunan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.08227,
            "PositionLon": 121.68421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1776",
        "StopID": "1776",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.69504
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4502",
        "StopID": "4502",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.081841,
            "PositionLon": 121.695475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1783",
        "StopID": "1783",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.091459,
            "PositionLon": 121.700279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1784",
        "StopID": "1784",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.089898,
            "PositionLon": 121.701426
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1785",
        "StopID": "1785",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.087949,
            "PositionLon": 121.702491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1786",
        "StopID": "1786",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.083696,
            "PositionLon": 121.703973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1790",
        "StopID": "1790",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.093033,
            "PositionLon": 121.710616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4021",
    "RouteID": "4021",
    "RouteName": {
        "Zh_tw": "402 堵南里-經七堵郵局",
        "En": "402 Dunan Village - Via Qidu Post Office"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4021",
    "SubRouteID": "4021",
    "SubRouteName": {
        "Zh_tw": "402 堵南里-經七堵郵局",
        "En": "402 Dunan Village - Via Qidu Post Office"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1829",
        "StopID": "1829",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.710476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1830",
        "StopID": "1830",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.093056,
            "PositionLon": 121.710411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1834",
        "StopID": "1834",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.08387,
            "PositionLon": 121.704011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1835",
        "StopID": "1835",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.087989,
            "PositionLon": 121.702667
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1836",
        "StopID": "1836",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09001,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1837",
        "StopID": "1837",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09151,
            "PositionLon": 121.700439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1845",
        "StopID": "1845",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.086439,
            "PositionLon": 121.697929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4503",
        "StopID": "4503",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.081858,
            "PositionLon": 121.698238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4531",
        "StopID": "4531",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.0819,
            "PositionLon": 121.696588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1843",
        "StopID": "1843",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.081935,
            "PositionLon": 121.695628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4507",
        "StopID": "4507",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.082613,
            "PositionLon": 121.695128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1844",
        "StopID": "1844",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.081918,
            "PositionLon": 121.694273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3916",
        "StopID": "3916",
        "StopName": {
            "Zh_tw": "百七街口",
            "En": "Bai 7th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.086335,
            "PositionLon": 121.694476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1857",
        "StopID": "1857",
        "StopName": {
            "Zh_tw": "水漾會館",
            "En": "Shuiyang Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.086571,
            "PositionLon": 121.693591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1846",
        "StopID": "1846",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.0845,
            "PositionLon": 121.691966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1847",
        "StopID": "1847",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.084336,
            "PositionLon": 121.690853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1848",
        "StopID": "1848",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.082961,
            "PositionLon": 121.6886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1850",
        "StopID": "1850",
        "StopName": {
            "Zh_tw": "堵南里",
            "En": "Dunan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.082386,
            "PositionLon": 121.68517
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4031",
    "RouteID": "4031",
    "RouteName": {
        "Zh_tw": "403 東新街-經七堵郵局",
        "En": "403 Dongxin St. - Via Qidu Post Office"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4031",
    "SubRouteID": "4031",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經七堵郵局",
        "En": "403 Dongxin St. - Via Qidu Post Office"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1851",
        "StopID": "1851",
        "StopName": {
            "Zh_tw": "海灣公司",
            "En": "Crown Van Lines Co., Ltd."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.09495,
            "PositionLon": 121.720716
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1852",
        "StopID": "1852",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.71959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1853",
        "StopID": "1853",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.094694,
            "PositionLon": 121.716586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4031",
    "RouteID": "4031",
    "RouteName": {
        "Zh_tw": "403 東新街-經七堵郵局",
        "En": "403 Dongxin St. - Via Qidu Post Office"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4031",
    "SubRouteID": "4031",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經七堵郵局",
        "En": "403 Dongxin St. - Via Qidu Post Office"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1892",
        "StopID": "1892",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.093398,
            "PositionLon": 121.715455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1893",
        "StopID": "1893",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094997,
            "PositionLon": 121.717198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1894",
        "StopID": "1894",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094713,
            "PositionLon": 121.719346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1895",
        "StopID": "1895",
        "StopName": {
            "Zh_tw": "海灣公司",
            "En": "Crown Van Lines Co., Ltd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.0952,
            "PositionLon": 121.720916
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4032",
    "RouteID": "4032",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4032",
    "SubRouteID": "4032",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1896",
        "StopID": "1896",
        "StopName": {
            "Zh_tw": "福基煤礦",
            "En": "Fuji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.087066,
            "PositionLon": 121.723666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5108",
        "StopID": "5108",
        "StopName": {
            "Zh_tw": "東新街138號",
            "En": "No.138, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.08908,
            "PositionLon": 121.721923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5109",
        "StopID": "5109",
        "StopName": {
            "Zh_tw": "東新街127號",
            "En": "No.127, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.090606,
            "PositionLon": 121.720385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1852",
        "StopID": "1852",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.71959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1853",
        "StopID": "1853",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094694,
            "PositionLon": 121.716586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5104",
        "StopID": "5104",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5106",
        "StopID": "5106",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09777,
            "PositionLon": 121.716234
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4032",
    "RouteID": "4032",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4032",
    "SubRouteID": "4032",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1892",
        "StopID": "1892",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.093398,
            "PositionLon": 121.715455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1893",
        "StopID": "1893",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.094997,
            "PositionLon": 121.717198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1894",
        "StopID": "1894",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.094713,
            "PositionLon": 121.719346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1895",
        "StopID": "1895",
        "StopName": {
            "Zh_tw": "海灣公司",
            "En": "Crown Van Lines Co., Ltd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.0952,
            "PositionLon": 121.720916
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4033",
    "RouteID": "4033",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(福基煤礦)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Fuji Mine)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4033",
    "SubRouteID": "4033",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(福基煤礦)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Fuji Mine)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1896",
        "StopID": "1896",
        "StopName": {
            "Zh_tw": "福基煤礦",
            "En": "Fuji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.087066,
            "PositionLon": 121.723666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5108",
        "StopID": "5108",
        "StopName": {
            "Zh_tw": "東新街138號",
            "En": "No.138, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.08908,
            "PositionLon": 121.721923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5109",
        "StopID": "5109",
        "StopName": {
            "Zh_tw": "東新街127號",
            "En": "No.127, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.090606,
            "PositionLon": 121.720385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1852",
        "StopID": "1852",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.71959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1853",
        "StopID": "1853",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094694,
            "PositionLon": 121.716586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4033",
    "RouteID": "4033",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(福基煤礦)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Fuji Mine)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4033",
    "SubRouteID": "4033",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(福基煤礦)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Fuji Mine)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1892",
        "StopID": "1892",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.093398,
            "PositionLon": 121.715455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1893",
        "StopID": "1893",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094997,
            "PositionLon": 121.717198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1894",
        "StopID": "1894",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094713,
            "PositionLon": 121.719346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1944",
        "StopID": "1944",
        "StopName": {
            "Zh_tw": "福基煤礦",
            "En": "Fuji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.087033,
            "PositionLon": 121.723833
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4034",
    "RouteID": "4034",
    "RouteName": {
        "Zh_tw": "403 東新街-基隆車站(經七堵郵局)",
        "En": "403 Dongxin St. - Keelung Station(Qidu Post Office)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4034",
    "SubRouteID": "4034",
    "SubRouteName": {
        "Zh_tw": "403 東新街-基隆車站(經七堵郵局)",
        "En": "403 Dongxin St. - Keelung Station(Qidu Post Office)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1896",
        "StopID": "1896",
        "StopName": {
            "Zh_tw": "福基煤礦",
            "En": "Fuji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.087066,
            "PositionLon": 121.723666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1897",
        "StopID": "1897",
        "StopName": {
            "Zh_tw": "北極宮",
            "En": "Beiji Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.088366,
            "PositionLon": 121.722916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5108",
        "StopID": "5108",
        "StopName": {
            "Zh_tw": "東新街138號",
            "En": "No.138, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.08908,
            "PositionLon": 121.721923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5109",
        "StopID": "5109",
        "StopName": {
            "Zh_tw": "東新街127號",
            "En": "No.127, Dongxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.090606,
            "PositionLon": 121.720385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1852",
        "StopID": "1852",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.71959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1853",
        "StopID": "1853",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.094694,
            "PositionLon": 121.716586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4035",
    "RouteID": "4035",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4035",
    "SubRouteID": "4035",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1851",
        "StopID": "1851",
        "StopName": {
            "Zh_tw": "海灣公司",
            "En": "Crown Van Lines Co., Ltd."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.09495,
            "PositionLon": 121.720716
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1852",
        "StopID": "1852",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.71959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1853",
        "StopID": "1853",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.094694,
            "PositionLon": 121.716586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5104",
        "StopID": "5104",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5106",
        "StopID": "5106",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.09777,
            "PositionLon": 121.716234
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4035",
    "RouteID": "4035",
    "RouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4035",
    "SubRouteID": "4035",
    "SubRouteName": {
        "Zh_tw": "403 東新街-經光明路(海灣公司)",
        "En": "403 Dongxin St. - Via Guangming Rd.(Crownvan Co. LTD)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1892",
        "StopID": "1892",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.093398,
            "PositionLon": 121.715455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1893",
        "StopID": "1893",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.094997,
            "PositionLon": 121.717198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1894",
        "StopID": "1894",
        "StopName": {
            "Zh_tw": "東新街口",
            "En": "Dongxin St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.094713,
            "PositionLon": 121.719346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1895",
        "StopID": "1895",
        "StopName": {
            "Zh_tw": "海灣公司",
            "En": "Crown Van Lines Co., Ltd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.0952,
            "PositionLon": 121.720916
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4061",
    "RouteID": "4061",
    "RouteName": {
        "Zh_tw": "406 長安社區-經堵南里",
        "En": "406 Zhang Community - Via Dunan Village"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4061",
    "SubRouteID": "4061",
    "SubRouteName": {
        "Zh_tw": "406 長安社區-經堵南里",
        "En": "406 Zhang Community - Via Dunan Village"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1945",
        "StopID": "1945",
        "StopName": {
            "Zh_tw": "長安社區",
            "En": "Changan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.075008,
            "PositionLon": 121.695973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1465",
        "StopID": "1465",
        "StopName": {
            "Zh_tw": "長安里民會堂",
            "En": "Changan Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.134099,
            "PositionLon": 121.734756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1947",
        "StopID": "1947",
        "StopName": {
            "Zh_tw": "長安街口",
            "En": "Changan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.077516,
            "PositionLon": 121.6899
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1948",
        "StopID": "1948",
        "StopName": {
            "Zh_tw": "明德三路口(北五堵)",
            "En": "Mingde 3rd Rd. Intersection(N. Wudu)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.0768,
            "PositionLon": 121.688233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1770",
        "StopID": "1770",
        "StopName": {
            "Zh_tw": "堵南里",
            "En": "Dunan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.08227,
            "PositionLon": 121.68421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1776",
        "StopID": "1776",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.69504
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4502",
        "StopID": "4502",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.081841,
            "PositionLon": 121.695475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1783",
        "StopID": "1783",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.091459,
            "PositionLon": 121.700279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1784",
        "StopID": "1784",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.089898,
            "PositionLon": 121.701426
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1785",
        "StopID": "1785",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.087949,
            "PositionLon": 121.702491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1786",
        "StopID": "1786",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.083696,
            "PositionLon": 121.703973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1790",
        "StopID": "1790",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.093033,
            "PositionLon": 121.710616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4061",
    "RouteID": "4061",
    "RouteName": {
        "Zh_tw": "406 長安社區-經堵南里",
        "En": "406 Zhang Community - Via Dunan Village"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4061",
    "SubRouteID": "4061",
    "SubRouteName": {
        "Zh_tw": "406 長安社區-經堵南里",
        "En": "406 Zhang Community - Via Dunan Village"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1829",
        "StopID": "1829",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.710476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1830",
        "StopID": "1830",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.093056,
            "PositionLon": 121.710411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1834",
        "StopID": "1834",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.08387,
            "PositionLon": 121.704011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1835",
        "StopID": "1835",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.087989,
            "PositionLon": 121.702667
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1836",
        "StopID": "1836",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09001,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1837",
        "StopID": "1837",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.09151,
            "PositionLon": 121.700439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3918",
        "StopID": "3918",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.085499,
            "PositionLon": 121.698355
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4503",
        "StopID": "4503",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.081858,
            "PositionLon": 121.698238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4531",
        "StopID": "4531",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.0819,
            "PositionLon": 121.696588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1843",
        "StopID": "1843",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.081935,
            "PositionLon": 121.695628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4507",
        "StopID": "4507",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.082613,
            "PositionLon": 121.695128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1844",
        "StopID": "1844",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.081918,
            "PositionLon": 121.694273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3916",
        "StopID": "3916",
        "StopName": {
            "Zh_tw": "百七街口",
            "En": "Bai 7th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.086335,
            "PositionLon": 121.694476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1857",
        "StopID": "1857",
        "StopName": {
            "Zh_tw": "水漾會館",
            "En": "Shuiyang Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.086571,
            "PositionLon": 121.693591
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1846",
        "StopID": "1846",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.0845,
            "PositionLon": 121.691966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1847",
        "StopID": "1847",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.084336,
            "PositionLon": 121.690853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1848",
        "StopID": "1848",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.082961,
            "PositionLon": 121.6886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3764",
        "StopID": "3764",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.08239,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1850",
        "StopID": "1850",
        "StopName": {
            "Zh_tw": "堵南里",
            "En": "Dunan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.082386,
            "PositionLon": 121.68517
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2030",
        "StopID": "2030",
        "StopName": {
            "Zh_tw": "明德三路口(北五堵)",
            "En": "Mingde 3rd Rd. Intersection(N. Wudu)"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.0774,
            "PositionLon": 121.68895
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2031",
        "StopID": "2031",
        "StopName": {
            "Zh_tw": "長安街口",
            "En": "Changan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.077468,
            "PositionLon": 121.690111
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1473",
        "StopID": "1473",
        "StopName": {
            "Zh_tw": "長安里民會堂",
            "En": "Changan Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.133909,
            "PositionLon": 121.734993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2033",
        "StopID": "2033",
        "StopName": {
            "Zh_tw": "長安社區",
            "En": "Changan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.075166,
            "PositionLon": 121.69525
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4071",
    "RouteID": "4071",
    "RouteName": {
        "Zh_tw": "407 七堵-基隆車站(經長庚醫院)",
        "En": "407 Qidu - Keelung Station(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4071",
    "SubRouteID": "4071",
    "SubRouteName": {
        "Zh_tw": "407 七堵-基隆車站(經長庚醫院)",
        "En": "407 Qidu - Keelung Station(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4072",
    "RouteID": "4072",
    "RouteName": {
        "Zh_tw": "407 七堵-基隆車站(經南榮路)",
        "En": "407 Qidu - Keelung Station(Nanrong Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4072",
    "SubRouteID": "4072",
    "SubRouteName": {
        "Zh_tw": "407 七堵-基隆車站(經南榮路)",
        "En": "407 Qidu - Keelung Station(Nanrong Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4073",
    "RouteID": "4073",
    "RouteName": {
        "Zh_tw": "407 基隆車站-七堵(經南榮路)",
        "En": "407 Keelung Station - Qidu(Nanrong Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4073",
    "SubRouteID": "4073",
    "SubRouteName": {
        "Zh_tw": "407 基隆車站-七堵(經南榮路)",
        "En": "407 Keelung Station - Qidu(Nanrong Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4081",
    "RouteID": "4081",
    "RouteName": {
        "Zh_tw": "408 基隆車站-長安社區(經長庚醫院)",
        "En": "408 Keelung Station - Via Zhang Community(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4081",
    "SubRouteID": "4081",
    "SubRouteName": {
        "Zh_tw": "408 基隆車站-長安社區(經長庚醫院)",
        "En": "408 Keelung Station - Via Zhang Community(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5055",
        "StopID": "5055",
        "StopName": {
            "Zh_tw": "八德路",
            "En": "Bade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.112643,
            "PositionLon": 121.727563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4526",
        "StopID": "4526",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.110686,
            "PositionLon": 121.72683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1829",
        "StopID": "1829",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.710476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1830",
        "StopID": "1830",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.093056,
            "PositionLon": 121.710411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1834",
        "StopID": "1834",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.08387,
            "PositionLon": 121.704011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1835",
        "StopID": "1835",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 85,
        "StopPosition": {
            "PositionLat": 25.087989,
            "PositionLon": 121.702667
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1836",
        "StopID": "1836",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 86,
        "StopPosition": {
            "PositionLat": 25.09001,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1837",
        "StopID": "1837",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 87,
        "StopPosition": {
            "PositionLat": 25.09151,
            "PositionLon": 121.700439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 88,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3918",
        "StopID": "3918",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 89,
        "StopPosition": {
            "PositionLat": 25.085499,
            "PositionLon": 121.698355
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 90,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4503",
        "StopID": "4503",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 91,
        "StopPosition": {
            "PositionLat": 25.081858,
            "PositionLon": 121.698238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4531",
        "StopID": "4531",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 92,
        "StopPosition": {
            "PositionLat": 25.0819,
            "PositionLon": 121.696588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1843",
        "StopID": "1843",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 93,
        "StopPosition": {
            "PositionLat": 25.081935,
            "PositionLon": 121.695628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4507",
        "StopID": "4507",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 94,
        "StopPosition": {
            "PositionLat": 25.082613,
            "PositionLon": 121.695128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1473",
        "StopID": "1473",
        "StopName": {
            "Zh_tw": "長安里民會堂",
            "En": "Changan Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 95,
        "StopPosition": {
            "PositionLat": 25.133909,
            "PositionLon": 121.734993
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2033",
        "StopID": "2033",
        "StopName": {
            "Zh_tw": "長安社區",
            "En": "Changan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 96,
        "StopPosition": {
            "PositionLat": 25.075166,
            "PositionLon": 121.69525
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4082",
    "RouteID": "4082",
    "RouteName": {
        "Zh_tw": "408 長安社區-基隆車站(經長庚醫院)",
        "En": "408 Zhang Community - Keelung Station(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4082",
    "SubRouteID": "4082",
    "SubRouteName": {
        "Zh_tw": "408 長安社區-基隆車站(經長庚醫院)",
        "En": "408 Zhang Community - Keelung Station(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1945",
        "StopID": "1945",
        "StopName": {
            "Zh_tw": "長安社區",
            "En": "Changan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 97,
        "StopPosition": {
            "PositionLat": 25.075008,
            "PositionLon": 121.695973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1465",
        "StopID": "1465",
        "StopName": {
            "Zh_tw": "長安里民會堂",
            "En": "Changan Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 98,
        "StopPosition": {
            "PositionLat": 25.134099,
            "PositionLon": 121.734756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1947",
        "StopID": "1947",
        "StopName": {
            "Zh_tw": "長安街口",
            "En": "Changan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 99,
        "StopPosition": {
            "PositionLat": 25.077516,
            "PositionLon": 121.6899
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 100,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 101,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 102,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 103,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 104,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 105,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1783",
        "StopID": "1783",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 106,
        "StopPosition": {
            "PositionLat": 25.091459,
            "PositionLon": 121.700279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1784",
        "StopID": "1784",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 107,
        "StopPosition": {
            "PositionLat": 25.089898,
            "PositionLon": 121.701426
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1785",
        "StopID": "1785",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 108,
        "StopPosition": {
            "PositionLat": 25.087949,
            "PositionLon": 121.702491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1786",
        "StopID": "1786",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 109,
        "StopPosition": {
            "PositionLat": 25.083696,
            "PositionLon": 121.703973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 110,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 111,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 112,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1790",
        "StopID": "1790",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 113,
        "StopPosition": {
            "PositionLat": 25.093033,
            "PositionLon": 121.710616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 114,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 115,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 116,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 117,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 118,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 119,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4516",
        "StopID": "4516",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 120,
        "StopPosition": {
            "PositionLat": 25.110576,
            "PositionLon": 121.726791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4519",
        "StopID": "4519",
        "StopName": {
            "Zh_tw": "八德路",
            "En": "Bade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 121,
        "StopPosition": {
            "PositionLat": 25.112455,
            "PositionLon": 121.727448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 122,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 123,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 124,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 125,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 126,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 127,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 128,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 129,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 130,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 131,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 132,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 133,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 134,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4091",
    "RouteID": "4091",
    "RouteName": {
        "Zh_tw": "409 堵南里-長庚醫院(經七堵郵局)",
        "En": "409 Dunan Village - Changgung Memorial Hospital(Qidu Post Office)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4091",
    "SubRouteID": "4091",
    "SubRouteName": {
        "Zh_tw": "409 堵南里-長庚醫院(經七堵郵局)",
        "En": "409 Dunan Village - Changgung Memorial Hospital(Qidu Post Office)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1770",
        "StopID": "1770",
        "StopName": {
            "Zh_tw": "堵南里",
            "En": "Dunan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 135,
        "StopPosition": {
            "PositionLat": 25.08227,
            "PositionLon": 121.68421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 136,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 137,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 138,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 139,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 140,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1776",
        "StopID": "1776",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 141,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.69504
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4502",
        "StopID": "4502",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 142,
        "StopPosition": {
            "PositionLat": 25.081841,
            "PositionLon": 121.695475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 143,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 144,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 145,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 146,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 147,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 148,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1783",
        "StopID": "1783",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 149,
        "StopPosition": {
            "PositionLat": 25.091459,
            "PositionLon": 121.700279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1784",
        "StopID": "1784",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 150,
        "StopPosition": {
            "PositionLat": 25.089898,
            "PositionLon": 121.701426
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1785",
        "StopID": "1785",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 151,
        "StopPosition": {
            "PositionLat": 25.087949,
            "PositionLon": 121.702491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1786",
        "StopID": "1786",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 152,
        "StopPosition": {
            "PositionLat": 25.083696,
            "PositionLon": 121.703973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 153,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 154,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 155,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1790",
        "StopID": "1790",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 156,
        "StopPosition": {
            "PositionLat": 25.093033,
            "PositionLon": 121.710616
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 157,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 158,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 159,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 160,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 161,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 162,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 163,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 164,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 165,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 166,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 167,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 168,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 169,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 170,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 171,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4101",
    "RouteID": "4101",
    "RouteName": {
        "Zh_tw": "410 七堵車站-壯觀台北(經長庚醫院)",
        "En": "410 Qidu Station - Via Zhuangguantaipei Community"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4101",
    "SubRouteID": "4101",
    "SubRouteName": {
        "Zh_tw": "410 七堵車站-壯觀台北(經長庚醫院)",
        "En": "410 Qidu Station - Via Zhuangguantaipei Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 172,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 173,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 174,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 175,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2186",
        "StopID": "2186",
        "StopName": {
            "Zh_tw": "八德路17巷口",
            "En": "Ln. 17, Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 176,
        "StopPosition": {
            "PositionLat": 25.105811,
            "PositionLon": 121.724569
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4516",
        "StopID": "4516",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 177,
        "StopPosition": {
            "PositionLat": 25.110576,
            "PositionLon": 121.726791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4519",
        "StopID": "4519",
        "StopName": {
            "Zh_tw": "八德路",
            "En": "Bade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 178,
        "StopPosition": {
            "PositionLat": 25.112455,
            "PositionLon": 121.727448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 179,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 180,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 181,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 182,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2089",
        "StopID": "2089",
        "StopName": {
            "Zh_tw": "御花園社區",
            "En": "Yuhuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 183,
        "StopPosition": {
            "PositionLat": 25.122595,
            "PositionLon": 121.717014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2205",
        "StopID": "2205",
        "StopName": {
            "Zh_tw": "九如社區",
            "En": "Jiuru Community"
        },
        "StopBoarding": 0,
        "StopSequence": 184,
        "StopPosition": {
            "PositionLat": 25.12151,
            "PositionLon": 121.717658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2201",
        "StopID": "2201",
        "StopName": {
            "Zh_tw": "松竹梅社區",
            "En": "Songzhumei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 185,
        "StopPosition": {
            "PositionLat": 25.120915,
            "PositionLon": 121.714789
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4522",
        "StopID": "4522",
        "StopName": {
            "Zh_tw": "樂利2街62巷276號",
            "En": "No.276, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 186,
        "StopPosition": {
            "PositionLat": 25.121135,
            "PositionLon": 121.715685
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4523",
        "StopID": "4523",
        "StopName": {
            "Zh_tw": "樂利2街62巷212號",
            "En": "No.212, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 187,
        "StopPosition": {
            "PositionLat": 25.121651,
            "PositionLon": 121.716683
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE4102",
    "RouteID": "4102",
    "RouteName": {
        "Zh_tw": "410 壯觀台北-七堵車站(經長庚醫院)",
        "En": "410 Zhuangguantaipei Community - Qidu Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE4102",
    "SubRouteID": "4102",
    "SubRouteName": {
        "Zh_tw": "410 壯觀台北-七堵車站(經長庚醫院)",
        "En": "410 Zhuangguantaipei Community - Qidu Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2203",
        "StopID": "2203",
        "StopName": {
            "Zh_tw": "松竹梅社區",
            "En": "Songzhumei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 188,
        "StopPosition": {
            "PositionLat": 25.120915,
            "PositionLon": 121.714789
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4522",
        "StopID": "4522",
        "StopName": {
            "Zh_tw": "樂利2街62巷276號",
            "En": "No.276, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 189,
        "StopPosition": {
            "PositionLat": 25.121135,
            "PositionLon": 121.715685
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4523",
        "StopID": "4523",
        "StopName": {
            "Zh_tw": "樂利2街62巷212號",
            "En": "No.212, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 190,
        "StopPosition": {
            "PositionLat": 25.121651,
            "PositionLon": 121.716683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2090",
        "StopID": "2090",
        "StopName": {
            "Zh_tw": "莫內花園社區",
            "En": "Moneihuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 191,
        "StopPosition": {
            "PositionLat": 25.122471,
            "PositionLon": 121.717202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 192,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 193,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 194,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2168",
        "StopID": "2168",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 195,
        "StopPosition": {
            "PositionLat": 25.11482,
            "PositionLon": 121.727851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4525",
        "StopID": "4525",
        "StopName": {
            "Zh_tw": "八德路口",
            "En": "Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 196,
        "StopPosition": {
            "PositionLat": 25.112331,
            "PositionLon": 121.727385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4526",
        "StopID": "4526",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 197,
        "StopPosition": {
            "PositionLat": 25.110686,
            "PositionLon": 121.72683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2187",
        "StopID": "2187",
        "StopName": {
            "Zh_tw": "八德路17巷口",
            "En": "Ln. 17, Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 198,
        "StopPosition": {
            "PositionLat": 25.105813,
            "PositionLon": 121.724741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 199,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 200,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 201,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5011",
    "RouteID": "5011",
    "RouteName": {
        "Zh_tw": "501 國家新城-經長庚醫院(經麥金路)",
        "En": "501 Guojiaxincheng - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5011",
    "SubRouteID": "5011",
    "SubRouteName": {
        "Zh_tw": "501 國家新城-經長庚醫院(經麥金路)",
        "En": "501 Guojiaxincheng - Via Changgung Memorial Hospital"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5000",
        "StopID": "5000",
        "StopName": {
            "Zh_tw": "大潤發",
            "En": "RT-Mart"
        },
        "StopBoarding": 0,
        "StopSequence": 202,
        "StopPosition": {
            "PositionLat": 25.130657,
            "PositionLon": 121.723232
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3716",
        "StopID": "3716",
        "StopName": {
            "Zh_tw": "涵悅社區",
            "En": "Hanyue Community"
        },
        "StopBoarding": 0,
        "StopSequence": 203,
        "StopPosition": {
            "PositionLat": 25.130288,
            "PositionLon": 121.722356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 204,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5001",
        "StopID": "5001",
        "StopName": {
            "Zh_tw": "龍騰大地社區",
            "En": "Longtengdadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 205,
        "StopPosition": {
            "PositionLat": 25.128881,
            "PositionLon": 121.718873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2091",
        "StopID": "2091",
        "StopName": {
            "Zh_tw": "國家新城",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 206,
        "StopPosition": {
            "PositionLat": 25.12719,
            "PositionLon": 121.713753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5002",
        "StopID": "5002",
        "StopName": {
            "Zh_tw": "樂利三街32巷",
            "En": "Ln. 32, Leli 3rd St."
        },
        "StopBoarding": 0,
        "StopSequence": 207,
        "StopPosition": {
            "PositionLat": 25.126565,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2063",
        "StopID": "2063",
        "StopName": {
            "Zh_tw": "國家新城",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 208,
        "StopPosition": {
            "PositionLat": 25.127541,
            "PositionLon": 121.713715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2064",
        "StopID": "2064",
        "StopName": {
            "Zh_tw": "天驕社區",
            "En": "Tianjiao Community"
        },
        "StopBoarding": 0,
        "StopSequence": 209,
        "StopPosition": {
            "PositionLat": 25.128315,
            "PositionLon": 121.715211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 210,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 211,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 212,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 213,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 214,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 215,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 216,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 217,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 218,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 219,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 220,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 221,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5011",
    "RouteID": "5011",
    "RouteName": {
        "Zh_tw": "501 國家新城-經長庚醫院(經麥金路)",
        "En": "501 Guojiaxincheng - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5011",
    "SubRouteID": "5011",
    "SubRouteName": {
        "Zh_tw": "501 國家新城-經長庚醫院(經麥金路)",
        "En": "501 Guojiaxincheng - Via Changgung Memorial Hospital"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5012",
        "StopID": "5012",
        "StopName": {
            "Zh_tw": "龍騰大地社區(返)",
            "En": "Longtengdadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128868,
            "PositionLon": 121.718898
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2092",
        "StopID": "2092",
        "StopName": {
            "Zh_tw": "國家新城(返)",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.12719,
            "PositionLon": 121.713753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5013",
        "StopID": "5013",
        "StopName": {
            "Zh_tw": "樂利三街32巷(返)",
            "En": "Ln. 32, Leli 3rd St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.126388,
            "PositionLon": 121.712678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2062",
        "StopID": "2062",
        "StopName": {
            "Zh_tw": "國家新城(返)",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.127541,
            "PositionLon": 121.713715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2093",
        "StopID": "2093",
        "StopName": {
            "Zh_tw": "天驕社區(返)",
            "En": "Tianjiao Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128816,
            "PositionLon": 121.71615
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3717",
        "StopID": "3717",
        "StopName": {
            "Zh_tw": "涵悅社區",
            "En": "Hanyue Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.130288,
            "PositionLon": 121.722356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5014",
        "StopID": "5014",
        "StopName": {
            "Zh_tw": "大潤發",
            "En": "RT-Mart"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.130657,
            "PositionLon": 121.723232
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5021",
    "RouteID": "5021",
    "RouteName": {
        "Zh_tw": "502 建德國中-經成功市場(經安樂路)",
        "En": "502 Jiande Junior High School - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5021",
    "SubRouteID": "5021",
    "SubRouteName": {
        "Zh_tw": "502 建德國中-經成功市場(經安樂路)",
        "En": "502 Jiande Junior High School - Via Chengong Market"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2096",
        "StopID": "2096",
        "StopName": {
            "Zh_tw": "建德國小",
            "En": "Jiande Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.125128,
            "PositionLon": 121.722474
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5015",
        "StopID": "5015",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126243,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2097",
        "StopID": "2097",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126366,
            "PositionLon": 121.722033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2099",
        "StopID": "2099",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128629,
            "PositionLon": 121.723548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2100",
        "StopID": "2100",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127616,
            "PositionLon": 121.724883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2101",
        "StopID": "2101",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.724483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2102",
        "StopID": "2102",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.125383,
            "PositionLon": 121.72335
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5016",
        "StopID": "5016",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2103",
        "StopID": "2103",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12278,
            "PositionLon": 121.722854
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5021",
    "RouteID": "5021",
    "RouteName": {
        "Zh_tw": "502 建德國中-經成功市場(經安樂路)",
        "En": "502 Jiande Junior High School - Via Chengong Market"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5021",
    "SubRouteID": "5021",
    "SubRouteName": {
        "Zh_tw": "502 建德國中-經成功市場(經安樂路)",
        "En": "502 Jiande Junior High School - Via Chengong Market"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2127",
        "StopID": "2127",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.122835,
            "PositionLon": 121.722954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5060",
        "StopID": "5060",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2123",
        "StopID": "2123",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.125933,
            "PositionLon": 121.723716
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2124",
        "StopID": "2124",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.1268,
            "PositionLon": 121.724766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2125",
        "StopID": "2125",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.724666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2126",
        "StopID": "2126",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128419,
            "PositionLon": 121.722648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2128",
        "StopID": "2128",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.125916,
            "PositionLon": 121.72195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5017",
        "StopID": "5017",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.126213,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5031",
    "RouteID": "5031",
    "RouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經南榮路)",
        "En": "503 Yingge Village - Qidu(Nanrong Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5031",
    "SubRouteID": "5031",
    "SubRouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經南榮路)",
        "En": "503 Yingge Village - Qidu(Nanrong Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5031",
    "RouteID": "5031",
    "RouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經南榮路)",
        "En": "503 Yingge Village - Qidu(Nanrong Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5031",
    "SubRouteID": "5031",
    "SubRouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經南榮路)",
        "En": "503 Yingge Village - Qidu(Nanrong Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2160",
        "StopID": "2160",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134966,
            "PositionLon": 121.725233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5055",
        "StopID": "5055",
        "StopName": {
            "Zh_tw": "八德路",
            "En": "Bade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.112643,
            "PositionLon": 121.727563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4526",
        "StopID": "4526",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.110686,
            "PositionLon": 121.72683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2187",
        "StopID": "2187",
        "StopName": {
            "Zh_tw": "八德路17巷口",
            "En": "Ln. 17, Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.105813,
            "PositionLon": 121.724741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5032",
    "RouteID": "5032",
    "RouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經麥金路)",
        "En": "503 Yingge Village - Qidu(Maijin Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5032",
    "SubRouteID": "5032",
    "SubRouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經麥金路)",
        "En": "503 Yingge Village - Qidu(Maijin Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3977",
        "StopID": "3977",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098262,
            "PositionLon": 121.714067
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3951",
        "StopID": "3951",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09922,
            "PositionLon": 121.713697
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2185",
        "StopID": "2185",
        "StopName": {
            "Zh_tw": "大華新村",
            "En": "Dahuaxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.101966,
            "PositionLon": 121.715468
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2186",
        "StopID": "2186",
        "StopName": {
            "Zh_tw": "八德路17巷口",
            "En": "Ln. 17, Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.105811,
            "PositionLon": 121.724569
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4516",
        "StopID": "4516",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110576,
            "PositionLon": 121.726791
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4525",
        "StopID": "4525",
        "StopName": {
            "Zh_tw": "八德路口",
            "En": "Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.112331,
            "PositionLon": 121.727385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5032",
    "RouteID": "5032",
    "RouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經麥金路)",
        "En": "503 Yingge Village - Qidu(Maijin Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5032",
    "SubRouteID": "5032",
    "SubRouteName": {
        "Zh_tw": "503 鶯歌里-七堵(去經麥金路)",
        "En": "503 Yingge Village - Qidu(Maijin Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5033",
    "RouteID": "5033",
    "RouteName": {
        "Zh_tw": "503 基隆車站-鶯歌里",
        "En": "503 Keelung Station - Yingge Village"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5033",
    "SubRouteID": "5033",
    "SubRouteName": {
        "Zh_tw": "503 基隆車站-鶯歌里",
        "En": "503 Keelung Station - Yingge Village"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2200",
        "StopID": "2200",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.13512,
            "PositionLon": 121.725151
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5055",
        "StopID": "5055",
        "StopName": {
            "Zh_tw": "八德路",
            "En": "Bade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.112643,
            "PositionLon": 121.727563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4526",
        "StopID": "4526",
        "StopName": {
            "Zh_tw": "尚仁國小",
            "En": "Shangren Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.110686,
            "PositionLon": 121.72683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2187",
        "StopID": "2187",
        "StopName": {
            "Zh_tw": "八德路17巷口",
            "En": "Ln. 17, Bade Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.105813,
            "PositionLon": 121.724741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2188",
        "StopID": "2188",
        "StopName": {
            "Zh_tw": "大華新村",
            "En": "Dahuaxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.102134,
            "PositionLon": 121.715577
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3934",
        "StopID": "3934",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.099272,
            "PositionLon": 121.713646
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3978",
        "StopID": "3978",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.120533,
            "PositionLon": 121.743256
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5051",
    "RouteID": "5051",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路",
        "En": "505 Tapurun - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5051",
    "SubRouteID": "5051",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路",
        "En": "505 Tapurun - Via An 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5051",
    "RouteID": "5051",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路",
        "En": "505 Tapurun - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5051",
    "SubRouteID": "5051",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路",
        "En": "505 Tapurun - Via An 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2160",
        "StopID": "2160",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134966,
            "PositionLon": 121.725233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5030",
        "StopID": "5030",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.158376,
            "PositionLon": 121.693854
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5052",
    "RouteID": "5052",
    "RouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院",
        "En": "505 Tapurun - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5052",
    "SubRouteID": "5052",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院",
        "En": "505 Tapurun - Via Changgung Memorial Hospital"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5052",
    "RouteID": "5052",
    "RouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院",
        "En": "505 Tapurun - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5052",
    "SubRouteID": "5052",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院",
        "En": "505 Tapurun - Via Changgung Memorial Hospital"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5030",
        "StopID": "5030",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.158376,
            "PositionLon": 121.693854
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5053",
    "RouteID": "5053",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路(去經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5053",
    "SubRouteID": "5053",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路(去經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5053",
    "RouteID": "5053",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路(去經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5053",
    "SubRouteID": "5053",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路(去經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2160",
        "StopID": "2160",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134966,
            "PositionLon": 121.725233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5030",
        "StopID": "5030",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.158376,
            "PositionLon": 121.693854
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5054",
    "RouteID": "5054",
    "RouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院(回經台北大鎮)",
        "En": "505 Tapurun - Via Changgung Memorial Hospital(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5054",
    "SubRouteID": "5054",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院(回經台北大鎮)",
        "En": "505 Tapurun - Via Changgung Memorial Hospital(Taipeidazhen Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5054",
    "RouteID": "5054",
    "RouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院(回經台北大鎮)",
        "En": "505 Tapurun - Via Changgung Memorial Hospital(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5054",
    "SubRouteID": "5054",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經長庚醫院(回經台北大鎮)",
        "En": "505 Tapurun - Via Changgung Memorial Hospital(Taipeidazhen Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5030",
        "StopID": "5030",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.158376,
            "PositionLon": 121.693854
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5055",
    "RouteID": "5055",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路(回經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5055",
    "SubRouteID": "5055",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路(回經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5055",
    "RouteID": "5055",
    "RouteName": {
        "Zh_tw": "505 大武崙-經安一路(回經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5055",
    "SubRouteID": "5055",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-經安一路(回經台北大鎮)",
        "En": "505 Tapurun - Via An 1st Rd.(Taipeidazhen Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2160",
        "StopID": "2160",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.134966,
            "PositionLon": 121.725233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5030",
        "StopID": "5030",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.158376,
            "PositionLon": 121.693854
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5056",
    "RouteID": "5056",
    "RouteName": {
        "Zh_tw": "505 大武崙-基隆車站(經長庚醫院)",
        "En": "505 Tapurun - Keelung Station(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5056",
    "SubRouteID": "5056",
    "SubRouteName": {
        "Zh_tw": "505 大武崙-基隆車站(經長庚醫院)",
        "En": "505 Tapurun - Keelung Station(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5052",
        "StopID": "5052",
        "StopName": {
            "Zh_tw": "大武崙分站",
            "En": "Tapurun Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.155598,
            "PositionLon": 121.695308
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5091",
        "StopID": "5091",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5081",
    "RouteID": "5081",
    "RouteName": {
        "Zh_tw": "508 澳底漁港-經安一路",
        "En": "508 Aodi Harbor - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5081",
    "SubRouteID": "5081",
    "SubRouteName": {
        "Zh_tw": "508 澳底漁港-經安一路",
        "En": "508 Aodi Harbor - Via An 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2200",
        "StopID": "2200",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.13512,
            "PositionLon": 121.725151
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2379",
        "StopID": "2379",
        "StopName": {
            "Zh_tw": "內寮社區",
            "En": "Neiliao Community"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.158586,
            "PositionLon": 121.696613
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5035",
        "StopID": "5035",
        "StopName": {
            "Zh_tw": "武聖街144號",
            "En": "No. 144 Wusheng St."
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.159483,
            "PositionLon": 121.697266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3756",
        "StopID": "3756",
        "StopName": {
            "Zh_tw": "大武崙沙灘停車場",
            "En": "Tapurun Sandbeach Parking Lot"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.168042,
            "PositionLon": 121.707404
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5081",
    "RouteID": "5081",
    "RouteName": {
        "Zh_tw": "508 澳底漁港-經安一路",
        "En": "508 Aodi Harbor - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5081",
    "SubRouteID": "5081",
    "SubRouteName": {
        "Zh_tw": "508 澳底漁港-經安一路",
        "En": "508 Aodi Harbor - Via An 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3766",
        "StopID": "3766",
        "StopName": {
            "Zh_tw": "大武崙沙灘停車場(返)",
            "En": "Tapurun Sandbeach Parking Lot"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.168042,
            "PositionLon": 121.707404
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3757",
        "StopID": "3757",
        "StopName": {
            "Zh_tw": "湖海路二段142號",
            "En": "No.142, Sec. 2, Huhai Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.165669,
            "PositionLon": 121.706427
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5038",
        "StopID": "5038",
        "StopName": {
            "Zh_tw": "武聖街144號",
            "En": "No. 144 Wusheng St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.159593,
            "PositionLon": 121.697201
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2431",
        "StopID": "2431",
        "StopName": {
            "Zh_tw": "內寮社區",
            "En": "Neiliao Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.1585,
            "PositionLon": 121.696466
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5091",
    "RouteID": "5091",
    "RouteName": {
        "Zh_tw": "509 情人湖-經安一路",
        "En": "509 Valentine Lake - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5091",
    "SubRouteID": "5091",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經安一路",
        "En": "509 Valentine Lake - Via An 1st Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2200",
        "StopID": "2200",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13512,
            "PositionLon": 121.725151
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2453",
        "StopID": "2453",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14975,
            "PositionLon": 121.7082
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2242",
        "StopID": "2242",
        "StopName": {
            "Zh_tw": "情人湖",
            "En": "Lovers Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.157043,
            "PositionLon": 121.70588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2455",
        "StopID": "2455",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.148083,
            "PositionLon": 121.708433
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5034",
        "StopID": "5034",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14027,
            "PositionLon": 121.714088
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2142",
        "StopID": "2142",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2466",
        "StopID": "2466",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.142387,
            "PositionLon": 121.710232
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5042",
        "StopID": "5042",
        "StopName": {
            "Zh_tw": "武崙國小",
            "En": "Wulun Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.138846,
            "PositionLon": 121.705991
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5043",
        "StopID": "5043",
        "StopName": {
            "Zh_tw": "武崙國中",
            "En": "Wulun Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138113,
            "PositionLon": 121.705744
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5044",
        "StopID": "5044",
        "StopName": {
            "Zh_tw": "武嶺街305號",
            "En": "No. 305 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.137875,
            "PositionLon": 121.708316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5045",
        "StopID": "5045",
        "StopName": {
            "Zh_tw": "武嶺街161號",
            "En": "No. 161 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.139035,
            "PositionLon": 121.710472
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5091",
    "RouteID": "5091",
    "RouteName": {
        "Zh_tw": "509 情人湖-經安一路",
        "En": "509 Valentine Lake - Via An 1st Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5091",
    "SubRouteID": "5091",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經安一路",
        "En": "509 Valentine Lake - Via An 1st Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5092",
    "RouteID": "5092",
    "RouteName": {
        "Zh_tw": "509 情人湖-經安一路(經東都社區)",
        "En": "509 Valentine Lake - Via An 1st Rd.(Dondu Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5092",
    "SubRouteID": "5092",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經安一路(經東都社區)",
        "En": "509 Valentine Lake - Via An 1st Rd.(Dondu Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5023",
        "StopID": "5023",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.132064,
            "PositionLon": 121.733915
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2207",
        "StopID": "2207",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.1324,
            "PositionLon": 121.732666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2200",
        "StopID": "2200",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13512,
            "PositionLon": 121.725151
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2453",
        "StopID": "2453",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14975,
            "PositionLon": 121.7082
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2242",
        "StopID": "2242",
        "StopName": {
            "Zh_tw": "情人湖",
            "En": "Lovers Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.157043,
            "PositionLon": 121.70588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2455",
        "StopID": "2455",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.148083,
            "PositionLon": 121.708433
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5034",
        "StopID": "5034",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14027,
            "PositionLon": 121.714088
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2142",
        "StopID": "2142",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2466",
        "StopID": "2466",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.142387,
            "PositionLon": 121.710232
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5047",
        "StopID": "5047",
        "StopName": {
            "Zh_tw": "東都社區",
            "En": "Dongdou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.141678,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5042",
        "StopID": "5042",
        "StopName": {
            "Zh_tw": "武崙國小",
            "En": "Wulun Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.138846,
            "PositionLon": 121.705991
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5043",
        "StopID": "5043",
        "StopName": {
            "Zh_tw": "武崙國中",
            "En": "Wulun Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.138113,
            "PositionLon": 121.705744
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5044",
        "StopID": "5044",
        "StopName": {
            "Zh_tw": "武嶺街305號",
            "En": "No. 305 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.137875,
            "PositionLon": 121.708316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5045",
        "StopID": "5045",
        "StopName": {
            "Zh_tw": "武嶺街161號",
            "En": "No. 161 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.139035,
            "PositionLon": 121.710472
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5092",
    "RouteID": "5092",
    "RouteName": {
        "Zh_tw": "509 情人湖-經安一路(經東都社區)",
        "En": "509 Valentine Lake - Via An 1st Rd.(Dondu Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5092",
    "SubRouteID": "5092",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經安一路(經東都社區)",
        "En": "509 Valentine Lake - Via An 1st Rd.(Dondu Community)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE482",
        "StopID": "482",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2250",
        "StopID": "2250",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133845,
            "PositionLon": 121.727
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2202",
        "StopID": "2202",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.134283,
            "PositionLon": 121.72855
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5025",
        "StopID": "5025",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.133891,
            "PositionLon": 121.729548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2204",
        "StopID": "2204",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.132328,
            "PositionLon": 121.728358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE483",
        "StopID": "483",
        "StopName": {
            "Zh_tw": "崇德路口",
            "En": "Chongde Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132235,
            "PositionLon": 121.730003
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5024",
        "StopID": "5024",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.132693,
            "PositionLon": 121.731043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5093",
    "RouteID": "5093",
    "RouteName": {
        "Zh_tw": "509 情人湖-經麥金路",
        "En": "509 Valentine Lake - Via Maijin Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5093",
    "SubRouteID": "5093",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經麥金路",
        "En": "509 Valentine Lake - Via Maijin Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2244",
        "StopID": "2244",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.14028,
            "PositionLon": 121.714073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2451",
        "StopID": "2451",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.142318,
            "PositionLon": 121.710258
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2137",
        "StopID": "2137",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5032",
        "StopID": "5032",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.146919,
            "PositionLon": 121.708808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2453",
        "StopID": "2453",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14975,
            "PositionLon": 121.7082
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2242",
        "StopID": "2242",
        "StopName": {
            "Zh_tw": "情人湖",
            "En": "Lovers Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.157043,
            "PositionLon": 121.70588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2455",
        "StopID": "2455",
        "StopName": {
            "Zh_tw": "長庚醫院情人湖院區",
            "En": "Zhanggeng Hospital Lovers Lake Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.148083,
            "PositionLon": 121.708433
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5034",
        "StopID": "5034",
        "StopName": {
            "Zh_tw": "台北大鎮",
            "En": "Taibeidazhen"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14027,
            "PositionLon": 121.714088
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2142",
        "StopID": "2142",
        "StopName": {
            "Zh_tw": "國花社區",
            "En": "Guohua Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.144892,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2466",
        "StopID": "2466",
        "StopName": {
            "Zh_tw": "基金一路208巷口",
            "En": "Ln. 208, Jijin 1st Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.142387,
            "PositionLon": 121.710232
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5042",
        "StopID": "5042",
        "StopName": {
            "Zh_tw": "武崙國小",
            "En": "Wulun Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.138846,
            "PositionLon": 121.705991
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5043",
        "StopID": "5043",
        "StopName": {
            "Zh_tw": "武崙國中",
            "En": "Wulun Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.138113,
            "PositionLon": 121.705744
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5044",
        "StopID": "5044",
        "StopName": {
            "Zh_tw": "武嶺街305號",
            "En": "No. 305 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.137875,
            "PositionLon": 121.708316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5045",
        "StopID": "5045",
        "StopName": {
            "Zh_tw": "武嶺街161號",
            "En": "No. 161 Wuling St."
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.139035,
            "PositionLon": 121.710472
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5093",
    "RouteID": "5093",
    "RouteName": {
        "Zh_tw": "509 情人湖-經麥金路",
        "En": "509 Valentine Lake - Via Maijin Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5093",
    "SubRouteID": "5093",
    "SubRouteName": {
        "Zh_tw": "509 情人湖-經麥金路",
        "En": "509 Valentine Lake - Via Maijin Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5101",
    "RouteID": "5101",
    "RouteName": {
        "Zh_tw": "510 大武崙-經七堵郵局(經麥金路)",
        "En": "510 Tapurun - Via Qidu Post Office(Maijin Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5101",
    "SubRouteID": "5101",
    "SubRouteName": {
        "Zh_tw": "510 大武崙-經七堵郵局(經麥金路)",
        "En": "510 Tapurun - Via Qidu Post Office(Maijin Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2168",
        "StopID": "2168",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.11482,
            "PositionLon": 121.727851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1810",
        "StopID": "1810",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5101",
    "RouteID": "5101",
    "RouteName": {
        "Zh_tw": "510 大武崙-經七堵郵局(經麥金路)",
        "En": "510 Tapurun - Via Qidu Post Office(Maijin Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5101",
    "SubRouteID": "5101",
    "SubRouteName": {
        "Zh_tw": "510 大武崙-經七堵郵局(經麥金路)",
        "En": "510 Tapurun - Via Qidu Post Office(Maijin Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2044",
        "StopID": "2044",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.11169,
            "PositionLon": 121.734821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5052",
        "StopID": "5052",
        "StopName": {
            "Zh_tw": "大武崙分站",
            "En": "Tapurun Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.155598,
            "PositionLon": 121.695308
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5102",
    "RouteID": "5102",
    "RouteName": {
        "Zh_tw": "510 大武崙-七堵(經麥金路)",
        "En": "510 Tapurun - Qidu(Maijin Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5102",
    "SubRouteID": "5102",
    "SubRouteName": {
        "Zh_tw": "510 大武崙-七堵(經麥金路)",
        "En": "510 Tapurun - Qidu(Maijin Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2168",
        "StopID": "2168",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.11482,
            "PositionLon": 121.727851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5103",
    "RouteID": "5103",
    "RouteName": {
        "Zh_tw": "510 七堵-大武崙",
        "En": "510 Qidu - Tapurun"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5103",
    "SubRouteID": "5103",
    "SubRouteName": {
        "Zh_tw": "510 七堵-大武崙",
        "En": "510 Qidu - Tapurun"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2044",
        "StopID": "2044",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.11169,
            "PositionLon": 121.734821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2089",
        "StopID": "2089",
        "StopName": {
            "Zh_tw": "御花園社區",
            "En": "Yuhuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.122595,
            "PositionLon": 121.717014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2205",
        "StopID": "2205",
        "StopName": {
            "Zh_tw": "九如社區",
            "En": "Jiuru Community"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.12151,
            "PositionLon": 121.717658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2201",
        "StopID": "2201",
        "StopName": {
            "Zh_tw": "松竹梅社區",
            "En": "Songzhumei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.120915,
            "PositionLon": 121.714789
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4522",
        "StopID": "4522",
        "StopName": {
            "Zh_tw": "樂利2街62巷276號",
            "En": "No.276, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.121135,
            "PositionLon": 121.715685
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4523",
        "StopID": "4523",
        "StopName": {
            "Zh_tw": "樂利2街62巷212號",
            "En": "No.212, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.121651,
            "PositionLon": 121.716683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2090",
        "StopID": "2090",
        "StopName": {
            "Zh_tw": "莫內花園社區",
            "En": "Moneihuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.122471,
            "PositionLon": 121.717202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5052",
        "StopID": "5052",
        "StopName": {
            "Zh_tw": "大武崙分站",
            "En": "Tapurun Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.155598,
            "PositionLon": 121.695308
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5105",
    "RouteID": "5105",
    "RouteName": {
        "Zh_tw": "510 大武崙-七堵(經壯觀台北)",
        "En": "510 Tapurun - Qidu(Zhuangguantaipei Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5105",
    "SubRouteID": "5105",
    "SubRouteName": {
        "Zh_tw": "510 大武崙-七堵(經壯觀台北)",
        "En": "510 Tapurun - Qidu(Zhuangguantaipei Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5018",
        "StopID": "5018",
        "StopName": {
            "Zh_tw": "武隆街105巷",
            "En": "Ln. 105, Wulong St."
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.158371,
            "PositionLon": 121.693885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5051",
        "StopID": "5051",
        "StopName": {
            "Zh_tw": "隆聖國小",
            "En": "Longsheng Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.156362,
            "PositionLon": 121.695557
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2089",
        "StopID": "2089",
        "StopName": {
            "Zh_tw": "御花園社區",
            "En": "Yuhuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 85,
        "StopPosition": {
            "PositionLat": 25.122595,
            "PositionLon": 121.717014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2205",
        "StopID": "2205",
        "StopName": {
            "Zh_tw": "九如社區",
            "En": "Jiuru Community"
        },
        "StopBoarding": 0,
        "StopSequence": 86,
        "StopPosition": {
            "PositionLat": 25.12151,
            "PositionLon": 121.717658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2201",
        "StopID": "2201",
        "StopName": {
            "Zh_tw": "松竹梅社區",
            "En": "Songzhumei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 87,
        "StopPosition": {
            "PositionLat": 25.120915,
            "PositionLon": 121.714789
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4522",
        "StopID": "4522",
        "StopName": {
            "Zh_tw": "樂利2街62巷276號",
            "En": "No.276, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 88,
        "StopPosition": {
            "PositionLat": 25.121135,
            "PositionLon": 121.715685
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4523",
        "StopID": "4523",
        "StopName": {
            "Zh_tw": "樂利2街62巷212號",
            "En": "No.212, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 89,
        "StopPosition": {
            "PositionLat": 25.121651,
            "PositionLon": 121.716683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2090",
        "StopID": "2090",
        "StopName": {
            "Zh_tw": "莫內花園社區",
            "En": "Moneihuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 90,
        "StopPosition": {
            "PositionLat": 25.122471,
            "PositionLon": 121.717202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 91,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 92,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 93,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2168",
        "StopID": "2168",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 94,
        "StopPosition": {
            "PositionLat": 25.11482,
            "PositionLon": 121.727851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 95,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 96,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 97,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 98,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 99,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 100,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 101,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 102,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5106",
    "RouteID": "5106",
    "RouteName": {
        "Zh_tw": "510 七堵-大武崙(經壯觀台北)",
        "En": "510 Qidu - Tapurun(Zhuangguantaipei Community)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE5106",
    "SubRouteID": "5106",
    "SubRouteName": {
        "Zh_tw": "510 七堵-大武崙(經壯觀台北)",
        "En": "510 Qidu - Tapurun(Zhuangguantaipei Community)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 103,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 104,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 105,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 106,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 107,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 108,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 109,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 110,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 111,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2044",
        "StopID": "2044",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 112,
        "StopPosition": {
            "PositionLat": 25.11169,
            "PositionLon": 121.734821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 113,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 114,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 115,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 116,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2089",
        "StopID": "2089",
        "StopName": {
            "Zh_tw": "御花園社區",
            "En": "Yuhuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 117,
        "StopPosition": {
            "PositionLat": 25.122595,
            "PositionLon": 121.717014
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2205",
        "StopID": "2205",
        "StopName": {
            "Zh_tw": "九如社區",
            "En": "Jiuru Community"
        },
        "StopBoarding": 0,
        "StopSequence": 118,
        "StopPosition": {
            "PositionLat": 25.12151,
            "PositionLon": 121.717658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2201",
        "StopID": "2201",
        "StopName": {
            "Zh_tw": "松竹梅社區",
            "En": "Songzhumei Community"
        },
        "StopBoarding": 0,
        "StopSequence": 119,
        "StopPosition": {
            "PositionLat": 25.120915,
            "PositionLon": 121.714789
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4522",
        "StopID": "4522",
        "StopName": {
            "Zh_tw": "樂利2街62巷276號",
            "En": "No.276, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 120,
        "StopPosition": {
            "PositionLat": 25.121135,
            "PositionLon": 121.715685
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4523",
        "StopID": "4523",
        "StopName": {
            "Zh_tw": "樂利2街62巷212號",
            "En": "No.212, Ln. 62, Leli 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 121,
        "StopPosition": {
            "PositionLat": 25.121651,
            "PositionLon": 121.716683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2090",
        "StopID": "2090",
        "StopName": {
            "Zh_tw": "莫內花園社區",
            "En": "Moneihuayuan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 122,
        "StopPosition": {
            "PositionLat": 25.122471,
            "PositionLon": 121.717202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 123,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 124,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 125,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 126,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 127,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 128,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 129,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 130,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 131,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 132,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 133,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 134,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 135,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 136,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 137,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 138,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 139,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5052",
        "StopID": "5052",
        "StopName": {
            "Zh_tw": "大武崙分站",
            "En": "Tapurun Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 140,
        "StopPosition": {
            "PositionLat": 25.155598,
            "PositionLon": 121.695308
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5661",
    "RouteID": "5661",
    "RouteName": {
        "Zh_tw": "R66",
        "En": "R66"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5661",
    "SubRouteID": "5661",
    "SubRouteName": {
        "Zh_tw": "R66",
        "En": "R66"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 141,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 142,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 143,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 144,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 145,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE297",
        "StopID": "297",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 146,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE298",
        "StopID": "298",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 147,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE299",
        "StopID": "299",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 148,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 149,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 150,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 151,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 152,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 153,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 154,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 155,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 156,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 157,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 158,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 159,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 160,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 161,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 162,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 163,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 164,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 165,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 166,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 167,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 168,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 169,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5661",
    "RouteID": "5661",
    "RouteName": {
        "Zh_tw": "R66",
        "En": "R66"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5661",
    "SubRouteID": "5661",
    "SubRouteName": {
        "Zh_tw": "R66",
        "En": "R66"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE243",
        "StopID": "243",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE244",
        "StopID": "244",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5662",
    "RouteID": "5662",
    "RouteName": {
        "Zh_tw": "R66 繞行海大",
        "En": "R66 Via National Taiwan Ocean University"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5662",
    "SubRouteID": "5662",
    "SubRouteName": {
        "Zh_tw": "R66 繞行海大",
        "En": "R66 Via National Taiwan Ocean University"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3",
        "StopID": "3",
        "StopName": {
            "Zh_tw": "海大行政大樓",
            "En": "Administration Building of National Taiwan Ocean University"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.149849,
            "PositionLon": 121.775912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4",
        "StopID": "4",
        "StopName": {
            "Zh_tw": "海大祥豐校區",
            "En": "National Taiwan Ocean University (Xiangfeng Campus)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.150506,
            "PositionLon": 121.773651
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5",
        "StopID": "5",
        "StopName": {
            "Zh_tw": "海大行政大樓",
            "En": "Administration Building of National Taiwan Ocean University"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.149849,
            "PositionLon": 121.775912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE297",
        "StopID": "297",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.142173,
            "PositionLon": 121.789196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE298",
        "StopID": "298",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.138978,
            "PositionLon": 121.789593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE299",
        "StopID": "299",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.13828,
            "PositionLon": 121.788986
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE958",
        "StopID": "958",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127175,
            "PositionLon": 121.781528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE959",
        "StopID": "959",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.126928,
            "PositionLon": 121.783601
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE480",
        "StopID": "480",
        "StopName": {
            "Zh_tw": "民生社區",
            "En": "Minsheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.126274,
            "PositionLon": 121.785301
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE960",
        "StopID": "960",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.125183,
            "PositionLon": 121.786683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE961",
        "StopID": "961",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.124601,
            "PositionLon": 121.788811
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE962",
        "StopID": "962",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.123778,
            "PositionLon": 121.791128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE963",
        "StopID": "963",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.121759,
            "PositionLon": 121.793319
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE964",
        "StopID": "964",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.120646,
            "PositionLon": 121.795186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5662",
    "RouteID": "5662",
    "RouteName": {
        "Zh_tw": "R66 繞行海大",
        "En": "R66 Via National Taiwan Ocean University"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5662",
    "SubRouteID": "5662",
    "SubRouteName": {
        "Zh_tw": "R66 繞行海大",
        "En": "R66 Via National Taiwan Ocean University"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE907",
        "StopID": "907",
        "StopName": {
            "Zh_tw": "六坑口",
            "En": "Liukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.121031,
            "PositionLon": 121.795006
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE908",
        "StopID": "908",
        "StopName": {
            "Zh_tw": "深澳坑路280號口(金益煤礦)",
            "En": "No.280, Shenaokeng Rd. Intersection (Jinyi Coal Mine)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.121919,
            "PositionLon": 121.793548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE909",
        "StopID": "909",
        "StopName": {
            "Zh_tw": "五坑口",
            "En": "Wukengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.123836,
            "PositionLon": 121.791358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE910",
        "StopID": "910",
        "StopName": {
            "Zh_tw": "三坑口",
            "En": "Sankengkou"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.124771,
            "PositionLon": 121.788825
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE911",
        "StopID": "911",
        "StopName": {
            "Zh_tw": "華妍閣社區",
            "En": "Huayange Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.125861,
            "PositionLon": 121.785996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE912",
        "StopID": "912",
        "StopName": {
            "Zh_tw": "深澳國小",
            "En": "Shenao Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.126853,
            "PositionLon": 121.78478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE913",
        "StopID": "913",
        "StopName": {
            "Zh_tw": "萬源口",
            "En": "Wanyuankou"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.126953,
            "PositionLon": 121.782181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE242",
        "StopID": "242",
        "StopName": {
            "Zh_tw": "普羅旺世社區",
            "En": "Provence Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.13722,
            "PositionLon": 121.78836
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE243",
        "StopID": "243",
        "StopName": {
            "Zh_tw": "八斗高中",
            "En": "Badou Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.139282,
            "PositionLon": 121.78979
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE244",
        "StopID": "244",
        "StopName": {
            "Zh_tw": "福泉寺",
            "En": "Fuquan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.142,
            "PositionLon": 121.789555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6601",
        "StopID": "6601",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6602",
        "StopID": "6602",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6603",
        "StopID": "6603",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6604",
        "StopID": "6604",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6605",
        "StopID": "6605",
        "StopName": {
            "Zh_tw": "海大行政大樓",
            "En": "Administration Building of National Taiwan Ocean University"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.149849,
            "PositionLon": 121.775912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6606",
        "StopID": "6606",
        "StopName": {
            "Zh_tw": "海大祥豐校區",
            "En": "National Taiwan Ocean University (Xiangfeng Campus)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.150506,
            "PositionLon": 121.773651
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6607",
        "StopID": "6607",
        "StopName": {
            "Zh_tw": "海大行政大樓",
            "En": "Administration Building of National Taiwan Ocean University"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.149849,
            "PositionLon": 121.775912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6608",
        "StopID": "6608",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6609",
        "StopID": "6609",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6610",
        "StopID": "6610",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6611",
        "StopID": "6611",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5681",
    "RouteID": "5681",
    "RouteName": {
        "Zh_tw": "R81",
        "En": "R81"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5681",
    "SubRouteID": "5681",
    "SubRouteName": {
        "Zh_tw": "R81",
        "En": "R81"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2063",
        "StopID": "2063",
        "StopName": {
            "Zh_tw": "國家新城",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.127541,
            "PositionLon": 121.713715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2064",
        "StopID": "2064",
        "StopName": {
            "Zh_tw": "天驕社區",
            "En": "Tianjiao Community"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128315,
            "PositionLon": 121.715211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5681",
    "RouteID": "5681",
    "RouteName": {
        "Zh_tw": "R81",
        "En": "R81"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5681",
    "SubRouteID": "5681",
    "SubRouteName": {
        "Zh_tw": "R81",
        "En": "R81"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5001",
        "StopID": "5001",
        "StopName": {
            "Zh_tw": "龍騰大地社區",
            "En": "Longtengdadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.128881,
            "PositionLon": 121.718873
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2091",
        "StopID": "2091",
        "StopName": {
            "Zh_tw": "國家新城",
            "En": "Guojiaxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.12719,
            "PositionLon": 121.713753
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5685",
    "RouteID": "5685",
    "RouteName": {
        "Zh_tw": "R85",
        "En": "R85"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5685",
    "SubRouteID": "5685",
    "SubRouteName": {
        "Zh_tw": "R85",
        "En": "R85"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2235",
        "StopID": "2235",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.156616,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2237",
        "StopID": "2237",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.15187,
            "PositionLon": 121.697765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2133",
        "StopID": "2133",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.143834,
            "PositionLon": 121.702311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2240",
        "StopID": "2240",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.141878,
            "PositionLon": 121.704076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2241",
        "StopID": "2241",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.708366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2456",
        "StopID": "2456",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.142005,
            "PositionLon": 121.709643
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2243",
        "StopID": "2243",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2245",
        "StopID": "2245",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.139406,
            "PositionLon": 121.715916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5021",
        "StopID": "5021",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.13866,
            "PositionLon": 121.718245
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2247",
        "StopID": "2247",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.135871,
            "PositionLon": 121.720728
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5685",
    "RouteID": "5685",
    "RouteName": {
        "Zh_tw": "R85",
        "En": "R85"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5685",
    "SubRouteID": "5685",
    "SubRouteName": {
        "Zh_tw": "R85",
        "En": "R85"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2162",
        "StopID": "2162",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.132956,
            "PositionLon": 121.72032
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2273",
        "StopID": "2273",
        "StopName": {
            "Zh_tw": "石皮瀨",
            "En": "Shipilai"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13598,
            "PositionLon": 121.72078
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5026",
        "StopID": "5026",
        "StopName": {
            "Zh_tw": "興寮里",
            "En": "Xingliao Village"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.138704,
            "PositionLon": 121.718354
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2275",
        "StopID": "2275",
        "StopName": {
            "Zh_tw": "忠聯倉儲",
            "En": "Zhonglian Warehouse"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.139575,
            "PositionLon": 121.716005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2276",
        "StopID": "2276",
        "StopName": {
            "Zh_tw": "東方巴黎社區",
            "En": "Dongfangbali Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.140208,
            "PositionLon": 121.714251
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2277",
        "StopID": "2277",
        "StopName": {
            "Zh_tw": "武嶺街口",
            "En": "Wuling St.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.140271,
            "PositionLon": 121.712063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5027",
        "StopID": "5027",
        "StopName": {
            "Zh_tw": "情人湖路口",
            "En": "Lovers Lake Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2279",
        "StopID": "2279",
        "StopName": {
            "Zh_tw": "金山鐵店",
            "En": "Jinshan Iron Stores"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14185,
            "PositionLon": 121.707533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2280",
        "StopID": "2280",
        "StopName": {
            "Zh_tw": "大武崙",
            "En": "Tapurun"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14195,
            "PositionLon": 121.704178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2134",
        "StopID": "2134",
        "StopName": {
            "Zh_tw": "三層站",
            "En": "Sanceng Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.143939,
            "PositionLon": 121.70254
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2283",
        "StopID": "2283",
        "StopName": {
            "Zh_tw": "石山",
            "En": "Shishan"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.151925,
            "PositionLon": 121.697931
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2285",
        "StopID": "2285",
        "StopName": {
            "Zh_tw": "武聖街口",
            "En": "Wusheng St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.15662,
            "PositionLon": 121.696038
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5686",
    "RouteID": "5686",
    "RouteName": {
        "Zh_tw": "R86",
        "En": "R86"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5686",
    "SubRouteID": "5686",
    "SubRouteName": {
        "Zh_tw": "R86",
        "En": "R86"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2865",
        "StopID": "2865",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2811",
        "StopID": "2811",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.091833,
            "PositionLon": 121.754418
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2813",
        "StopID": "2813",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.092348,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2814",
        "StopID": "2814",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.095726,
            "PositionLon": 121.754853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2151",
        "StopID": "2151",
        "StopName": {
            "Zh_tw": "藝觀天廈",
            "En": "Yiguan Building Community"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.097205,
            "PositionLon": 121.75658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2153",
        "StopID": "2153",
        "StopName": {
            "Zh_tw": "芳堤名邸",
            "En": "Fangtimingdi"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098462,
            "PositionLon": 121.758216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5686",
    "RouteID": "5686",
    "RouteName": {
        "Zh_tw": "R86",
        "En": "R86"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5686",
    "SubRouteID": "5686",
    "SubRouteName": {
        "Zh_tw": "R86",
        "En": "R86"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2180",
        "StopID": "2180",
        "StopName": {
            "Zh_tw": "芳堤名邸",
            "En": "Fangtimingdi"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098462,
            "PositionLon": 121.758216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2152",
        "StopID": "2152",
        "StopName": {
            "Zh_tw": "藝觀天廈",
            "En": "Yiguan Building Community"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.097246,
            "PositionLon": 121.756382
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2861",
        "StopID": "2861",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.096023,
            "PositionLon": 121.754763
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2862",
        "StopID": "2862",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.092601,
            "PositionLon": 121.754431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2864",
        "StopID": "2864",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.091696,
            "PositionLon": 121.754366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2150",
        "StopID": "2150",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5821",
    "RouteID": "5821",
    "RouteName": {
        "Zh_tw": "R82 先行百福",
        "En": "R82 Via Baifu Community"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5821",
    "SubRouteID": "5821",
    "SubRouteName": {
        "Zh_tw": "R82 先行百福",
        "En": "R82 Via Baifu Community"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2096",
        "StopID": "2096",
        "StopName": {
            "Zh_tw": "建德國小",
            "En": "Jiande Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.125128,
            "PositionLon": 121.722474
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5015",
        "StopID": "5015",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126243,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2097",
        "StopID": "2097",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126366,
            "PositionLon": 121.722033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2099",
        "StopID": "2099",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128629,
            "PositionLon": 121.723548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2100",
        "StopID": "2100",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127616,
            "PositionLon": 121.724883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2101",
        "StopID": "2101",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.724483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2102",
        "StopID": "2102",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.125383,
            "PositionLon": 121.72335
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5016",
        "StopID": "5016",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2103",
        "StopID": "2103",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12278,
            "PositionLon": 121.722854
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8814",
        "StopID": "8814",
        "StopName": {
            "Zh_tw": "汙水處理廠",
            "En": "Keelung City Water Treatment Plant"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.082365,
            "PositionLon": 121.703656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3921",
        "StopID": "3921",
        "StopName": {
            "Zh_tw": "百福火車站",
            "En": "Baifu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.078498,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5821",
    "RouteID": "5821",
    "RouteName": {
        "Zh_tw": "R82 先行百福",
        "En": "R82 Via Baifu Community"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5821",
    "SubRouteID": "5821",
    "SubRouteName": {
        "Zh_tw": "R82 先行百福",
        "En": "R82 Via Baifu Community"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1783",
        "StopID": "1783",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.091459,
            "PositionLon": 121.700279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1784",
        "StopID": "1784",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.089898,
            "PositionLon": 121.701426
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1785",
        "StopID": "1785",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.087949,
            "PositionLon": 121.702491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1786",
        "StopID": "1786",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.083696,
            "PositionLon": 121.703973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2127",
        "StopID": "2127",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.122835,
            "PositionLon": 121.722954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5060",
        "StopID": "5060",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2123",
        "StopID": "2123",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.125933,
            "PositionLon": 121.723716
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2124",
        "StopID": "2124",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.1268,
            "PositionLon": 121.724766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2125",
        "StopID": "2125",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.724666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2126",
        "StopID": "2126",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128419,
            "PositionLon": 121.722648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2128",
        "StopID": "2128",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.125916,
            "PositionLon": 121.72195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5017",
        "StopID": "5017",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.126213,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2098",
        "StopID": "2098",
        "StopName": {
            "Zh_tw": "建德國小(回站)",
            "En": "Jiande Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.125128,
            "PositionLon": 121.722474
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5822",
    "RouteID": "5822",
    "RouteName": {
        "Zh_tw": "R82 先行六堵",
        "En": "R82 Via Liudu Industry Park"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5822",
    "SubRouteID": "5822",
    "SubRouteName": {
        "Zh_tw": "R82 先行六堵",
        "En": "R82 Via Liudu Industry Park"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2096",
        "StopID": "2096",
        "StopName": {
            "Zh_tw": "建德國小",
            "En": "Jiande Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.125128,
            "PositionLon": 121.722474
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5015",
        "StopID": "5015",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126243,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2097",
        "StopID": "2097",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126366,
            "PositionLon": 121.722033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2099",
        "StopID": "2099",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128629,
            "PositionLon": 121.723548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2100",
        "StopID": "2100",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127616,
            "PositionLon": 121.724883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2101",
        "StopID": "2101",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.126516,
            "PositionLon": 121.724483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2102",
        "StopID": "2102",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.125383,
            "PositionLon": 121.72335
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5016",
        "StopID": "5016",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2103",
        "StopID": "2103",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.12278,
            "PositionLon": 121.722854
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5097",
        "StopID": "5097",
        "StopName": {
            "Zh_tw": "七堵區行政大樓",
            "En": "Administration Building of Qidu District"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097923,
            "PositionLon": 121.716271
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5105",
        "StopID": "5105",
        "StopName": {
            "Zh_tw": "開元立體停車場",
            "En": "Kaiyuan Rd. Parking Garage"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.096298,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5099",
        "StopID": "5099",
        "StopName": {
            "Zh_tw": "七堵火車站",
            "En": "Qidu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094488,
            "PositionLon": 121.712729
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1834",
        "StopID": "1834",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.08387,
            "PositionLon": 121.704011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1835",
        "StopID": "1835",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.087989,
            "PositionLon": 121.702667
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1836",
        "StopID": "1836",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09001,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1837",
        "StopID": "1837",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.09151,
            "PositionLon": 121.700439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1845",
        "StopID": "1845",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.086439,
            "PositionLon": 121.697929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4503",
        "StopID": "4503",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.081858,
            "PositionLon": 121.698238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4531",
        "StopID": "4531",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.0819,
            "PositionLon": 121.696588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1843",
        "StopID": "1843",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.081935,
            "PositionLon": 121.695628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3913",
        "StopID": "3913",
        "StopName": {
            "Zh_tw": "百福火車站",
            "En": "Baifu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.077963,
            "PositionLon": 121.693388
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5822",
    "RouteID": "5822",
    "RouteName": {
        "Zh_tw": "R82 先行六堵",
        "En": "R82 Via Liudu Industry Park"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5822",
    "SubRouteID": "5822",
    "SubRouteName": {
        "Zh_tw": "R82 先行六堵",
        "En": "R82 Via Liudu Industry Park"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE8813",
        "StopID": "8813",
        "StopName": {
            "Zh_tw": "汙水處理廠",
            "En": "Keelung City Water Treatment Plant"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.082034,
            "PositionLon": 121.703138
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1787",
        "StopID": "1787",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.087298,
            "PositionLon": 121.70528
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1788",
        "StopID": "1788",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.088756,
            "PositionLon": 121.705228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1789",
        "StopID": "1789",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.090105,
            "PositionLon": 121.707071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1791",
        "StopID": "1791",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094081,
            "PositionLon": 121.710578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4518",
        "StopID": "4518",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.111763,
            "PositionLon": 121.734731
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2127",
        "StopID": "2127",
        "StopName": {
            "Zh_tw": "安和一街(土地公廟)",
            "En": "Anhe 1st St.(Tudi Gong Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.122835,
            "PositionLon": 121.722954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5060",
        "StopID": "5060",
        "StopName": {
            "Zh_tw": "安和一街口",
            "En": "Anhe 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.124286,
            "PositionLon": 121.72279
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2123",
        "StopID": "2123",
        "StopName": {
            "Zh_tw": "安和一街123巷",
            "En": "Ln. 123, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.125933,
            "PositionLon": 121.723716
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2124",
        "StopID": "2124",
        "StopName": {
            "Zh_tw": "安和一街131巷",
            "En": "Ln. 131, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.1268,
            "PositionLon": 121.724766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2125",
        "StopID": "2125",
        "StopName": {
            "Zh_tw": "安和一街137巷",
            "En": "Ln. 137, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.724666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2126",
        "StopID": "2126",
        "StopName": {
            "Zh_tw": "建德山莊",
            "En": "Jiandeshanzhuang"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128419,
            "PositionLon": 121.722648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2128",
        "StopID": "2128",
        "StopName": {
            "Zh_tw": "建德國中",
            "En": "Jiande Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.125916,
            "PositionLon": 121.72195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5017",
        "StopID": "5017",
        "StopName": {
            "Zh_tw": "安和一街271巷",
            "En": "Ln. 271, Anhe 1st St."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.126213,
            "PositionLon": 121.722073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2098",
        "StopID": "2098",
        "StopName": {
            "Zh_tw": "建德國小(回站)",
            "En": "Jiande Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.125128,
            "PositionLon": 121.722474
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5991",
    "RouteID": "5991",
    "RouteName": {
        "Zh_tw": "T99 龍宮東岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - East Line"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5991",
    "SubRouteID": "5991",
    "SubRouteName": {
        "Zh_tw": "T99 龍宮東岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - East Line"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE9906",
        "StopID": "9906",
        "StopName": {
            "Zh_tw": "港西街(臨停區)",
            "En": "Temporary Stop"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136799,
            "PositionLon": 121.742099
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9900",
        "StopID": "9900",
        "StopName": {
            "Zh_tw": "基隆火車站(旅遊服務中心)",
            "En": "Keelung Railway Station (Keelung City Tourist Service Center)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131938,
            "PositionLon": 121.739692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9901",
        "StopID": "9901",
        "StopName": {
            "Zh_tw": "廟口夜市(電力公司)",
            "En": "Maioko Night Market (Taiwan Power Company of Keelung City)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.129569,
            "PositionLon": 121.745547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9921",
        "StopID": "9921",
        "StopName": {
            "Zh_tw": "東明路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.12779,
            "PositionLon": 121.758878
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE306",
        "StopID": "306",
        "StopName": {
            "Zh_tw": "役政公園",
            "En": "Yizheng Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132989,
            "PositionLon": 121.757035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE309",
        "StopID": "309",
        "StopName": {
            "Zh_tw": "中正公園",
            "En": "Zhongzheng Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.133179,
            "PositionLon": 121.751774
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9922",
        "StopID": "9922",
        "StopName": {
            "Zh_tw": "中正路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.142866,
            "PositionLon": 121.761027
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9902",
        "StopID": "9902",
        "StopName": {
            "Zh_tw": "原住民文化會館",
            "En": "Keelung City Indigenous Cultural Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.153113,
            "PositionLon": 121.769634
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE186",
        "StopID": "186",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.135573,
            "PositionLon": 121.802606
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9929",
        "StopID": "9929",
        "StopName": {
            "Zh_tw": "建基煤礦",
            "En": "Jianji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129027,
            "PositionLon": 121.814706
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE311",
        "StopID": "311",
        "StopName": {
            "Zh_tw": "深澳漁港",
            "En": "Shenao Fish Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.130241,
            "PositionLon": 121.818321
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE312",
        "StopID": "312",
        "StopName": {
            "Zh_tw": "瑞芳火車站",
            "En": "Ruifang Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.108231,
            "PositionLon": 121.806995
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5991",
    "RouteID": "5991",
    "RouteName": {
        "Zh_tw": "T99 龍宮東岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - East Line"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5991",
    "SubRouteID": "5991",
    "SubRouteName": {
        "Zh_tw": "T99 龍宮東岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - East Line"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE313",
        "StopID": "313",
        "StopName": {
            "Zh_tw": "瑞芳火車站(區民廣場)",
            "En": "Ruifang Station (Ruifang Dist. Populace Plaza)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.107981,
            "PositionLon": 121.807696
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE314",
        "StopID": "314",
        "StopName": {
            "Zh_tw": "深澳漁港(返)",
            "En": "Shenao Fish Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.130241,
            "PositionLon": 121.818321
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9930",
        "StopID": "9930",
        "StopName": {
            "Zh_tw": "建基煤礦",
            "En": "Jianji Coal Mine"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128907,
            "PositionLon": 121.814856
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3522",
        "StopID": "3522",
        "StopName": {
            "Zh_tw": "和平島公園(返)",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.15603,
            "PositionLon": 121.76484
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9903",
        "StopID": "9903",
        "StopName": {
            "Zh_tw": "原住民文化會館(返)",
            "En": "Keelung City Indigenous Cultural Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.153113,
            "PositionLon": 121.769634
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9923",
        "StopID": "9923",
        "StopName": {
            "Zh_tw": "中正路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.142842,
            "PositionLon": 121.760936
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE308",
        "StopID": "308",
        "StopName": {
            "Zh_tw": "役政公園(返)",
            "En": "Yizheng Park"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132989,
            "PositionLon": 121.757035
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE315",
        "StopID": "315",
        "StopName": {
            "Zh_tw": "中正公園(返)",
            "En": "Zhongzheng Park"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133179,
            "PositionLon": 121.751774
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9904",
        "StopID": "9904",
        "StopName": {
            "Zh_tw": "廟口夜市(義二路口)",
            "En": "Maioko Night Market (Yi 2nd Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129569,
            "PositionLon": 121.745547
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9905",
        "StopID": "9905",
        "StopName": {
            "Zh_tw": "基隆火車站(海洋廣場)",
            "En": "Keelung Railway Station (Keelung Maritime Plaza)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.131296,
            "PositionLon": 121.740386
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9906",
        "StopID": "9906",
        "StopName": {
            "Zh_tw": "港西街(臨停區)",
            "En": "Temporary Stop"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.136799,
            "PositionLon": 121.742099
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5992",
    "RouteID": "5992",
    "RouteName": {
        "Zh_tw": "T99 龍宮西岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - West Line"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5992",
    "SubRouteID": "5992",
    "SubRouteName": {
        "Zh_tw": "T99 龍宮西岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - West Line"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE9906",
        "StopID": "9906",
        "StopName": {
            "Zh_tw": "港西街(臨停區)",
            "En": "Temporary Stop"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136799,
            "PositionLon": 121.742099
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9900",
        "StopID": "9900",
        "StopName": {
            "Zh_tw": "基隆火車站(旅遊服務中心)",
            "En": "Keelung Railway Station (Keelung City Tourist Service Center)"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131938,
            "PositionLon": 121.739692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9907",
        "StopID": "9907",
        "StopName": {
            "Zh_tw": "安一路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.13206,
            "PositionLon": 121.734047
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9908",
        "StopID": "9908",
        "StopName": {
            "Zh_tw": "基金一路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.139611,
            "PositionLon": 121.715876
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2242",
        "StopID": "2242",
        "StopName": {
            "Zh_tw": "情人湖",
            "En": "Lovers Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.157043,
            "PositionLon": 121.70588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2282",
        "StopID": "2282",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.149168,
            "PositionLon": 121.699903
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9909",
        "StopID": "9909",
        "StopName": {
            "Zh_tw": "北部濱海公路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.174811,
            "PositionLon": 121.705983
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9910",
        "StopID": "9910",
        "StopName": {
            "Zh_tw": "翡翠灣",
            "En": "Green Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.186822,
            "PositionLon": 121.683556
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9911",
        "StopID": "9911",
        "StopName": {
            "Zh_tw": "龜吼漁港",
            "En": "Guihou Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.195853,
            "PositionLon": 121.687772
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9912",
        "StopID": "9912",
        "StopName": {
            "Zh_tw": "野柳地質公園",
            "En": "Yehliu GeoPark"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.204804,
            "PositionLon": 121.690057
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE5992",
    "RouteID": "5992",
    "RouteName": {
        "Zh_tw": "T99 龍宮西岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - West Line"
    },
    "Operators": [{
        "OperatorID": "5600",
        "OperatorName": {
            "Zh_tw": "基隆客運",
            "En": "Keelung Bus Co., Ltd."
        },
        "OperatorCode": "KeelungBus",
        "OperatorNo": "1102"
    }],
    "SubRouteUID": "KEE5992",
    "SubRouteID": "5992",
    "SubRouteName": {
        "Zh_tw": "T99 龍宮西岸線",
        "En": "T99 Dragon Palace Treasure Hunt Route - West Line"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE9913",
        "StopID": "9913",
        "StopName": {
            "Zh_tw": "野柳風景區停車場",
            "En": "Yehliu Parking lot"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.205158,
            "PositionLon": 121.690004
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9914",
        "StopID": "9914",
        "StopName": {
            "Zh_tw": "野柳地質公園",
            "En": "Yehliu GeoPark"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.204804,
            "PositionLon": 121.690057
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9915",
        "StopID": "9915",
        "StopName": {
            "Zh_tw": "龜吼漁港",
            "En": "Guihou Harbor"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.196419,
            "PositionLon": 121.688107
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9916",
        "StopID": "9916",
        "StopName": {
            "Zh_tw": "翡翠灣",
            "En": "Green Bay"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.187054,
            "PositionLon": 121.683193
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE9917",
        "StopID": "9917",
        "StopName": {
            "Zh_tw": "北部濱海公路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.174574,
            "PositionLon": 121.705815
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE2238",
        "StopID": "2238",
        "StopName": {
            "Zh_tw": "大武崙工業區",
            "En": "Tapurun Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.14907,
            "PositionLon": 121.699916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9924",
        "StopID": "9924",
        "StopName": {
            "Zh_tw": "情人湖(返)",
            "En": "Lovers Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.141941,
            "PositionLon": 121.709669
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9918",
        "StopID": "9918",
        "StopName": {
            "Zh_tw": "基金一路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.139385,
            "PositionLon": 121.715878
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9919",
        "StopID": "9919",
        "StopName": {
            "Zh_tw": "安一路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.132086,
            "PositionLon": 121.733641
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9920",
        "StopID": "9920",
        "StopName": {
            "Zh_tw": "忠四路(不停靠)",
            "En": "Not Docked"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128025,
            "PositionLon": 121.739608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9905",
        "StopID": "9905",
        "StopName": {
            "Zh_tw": "基隆火車站(海洋廣場)",
            "En": "Keelung Railway Station (Keelung Maritime Plaza)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.131296,
            "PositionLon": 121.740386
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE9906",
        "StopID": "9906",
        "StopName": {
            "Zh_tw": "港西街(臨停區)",
            "En": "Temporary Stop"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.136799,
            "PositionLon": 121.742099
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6011",
    "RouteID": "6011",
    "RouteName": {
        "Zh_tw": "601 四腳亭-經源遠路",
        "En": "601 Sijiaoting - Via Yuanyuan Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6011",
    "SubRouteID": "6011",
    "SubRouteName": {
        "Zh_tw": "601 四腳亭-經源遠路",
        "En": "601 Sijiaoting - Via Yuanyuan Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2590",
        "StopID": "2590",
        "StopName": {
            "Zh_tw": "四腳亭分站",
            "En": "Sijiaoting Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.098562,
            "PositionLon": 121.763109
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE2595",
        "StopID": "2595",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.099075,
            "PositionLon": 121.76069
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE4000",
        "StopID": "4000",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099584,
            "PositionLon": 121.758578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2602",
        "StopID": "2602",
        "StopName": {
            "Zh_tw": "世界貨櫃",
            "En": "World Goods Container"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.099073,
            "PositionLon": 121.746995
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5087",
        "StopID": "5087",
        "StopName": {
            "Zh_tw": "源遠橋頭",
            "En": "Yuanyuan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.102433,
            "PositionLon": 121.741167
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2604",
        "StopID": "2604",
        "StopName": {
            "Zh_tw": "暖江橋頭",
            "En": "Nuanjiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.102596,
            "PositionLon": 121.740781
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6011",
    "RouteID": "6011",
    "RouteName": {
        "Zh_tw": "601 四腳亭-經源遠路",
        "En": "601 Sijiaoting - Via Yuanyuan Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6011",
    "SubRouteID": "6011",
    "SubRouteName": {
        "Zh_tw": "601 四腳亭-經源遠路",
        "En": "601 Sijiaoting - Via Yuanyuan Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2760",
        "StopID": "2760",
        "StopName": {
            "Zh_tw": "源遠路76-1號",
            "En": "No.76-1, Yuanyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.102726,
            "PositionLon": 121.739448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2629",
        "StopID": "2629",
        "StopName": {
            "Zh_tw": "暖江橋頭",
            "En": "Nuanjiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.102375,
            "PositionLon": 121.741151
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5094",
        "StopID": "5094",
        "StopName": {
            "Zh_tw": "源遠橋頭",
            "En": "Yuanyuan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.102561,
            "PositionLon": 121.740792
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2631",
        "StopID": "2631",
        "StopName": {
            "Zh_tw": "世界貨櫃",
            "En": "World Goods Container"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.0987,
            "PositionLon": 121.747316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3991",
        "StopID": "3991",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.099524,
            "PositionLon": 121.75833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2638",
        "StopID": "2638",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.098983,
            "PositionLon": 121.760908
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6021",
    "RouteID": "6021",
    "RouteName": {
        "Zh_tw": "602 暖暖-經過港路",
        "En": "602 Nuannuan - Via Guogang Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6021",
    "SubRouteID": "6021",
    "SubRouteName": {
        "Zh_tw": "602 暖暖-經過港路",
        "En": "602 Nuannuan - Via Guogang Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE404",
        "StopID": "404",
        "StopName": {
            "Zh_tw": "暖暖分站(調度站)",
            "En": "Nuannuan Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.103478,
            "PositionLon": 121.737231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2688",
        "StopID": "2688",
        "StopName": {
            "Zh_tw": "威德廟",
            "En": "Weide Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.103266,
            "PositionLon": 121.737054
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1858",
        "StopID": "1858",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.102386,
            "PositionLon": 121.739538
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1878",
        "StopID": "1878",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE978",
        "StopID": "978",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE987",
        "StopID": "987",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.100416,
            "PositionLon": 121.736808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1888",
        "StopID": "1888",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3983",
        "StopID": "3983",
        "StopName": {
            "Zh_tw": "媽祖廟(安德宮)",
            "En": "Mazu Temple (Ande Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.102113,
            "PositionLon": 121.738415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1867",
        "StopID": "1867",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.102365,
            "PositionLon": 121.73962
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6021",
    "RouteID": "6021",
    "RouteName": {
        "Zh_tw": "602 暖暖-經過港路",
        "En": "602 Nuannuan - Via Guogang Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6021",
    "SubRouteID": "6021",
    "SubRouteName": {
        "Zh_tw": "602 暖暖-經過港路",
        "En": "602 Nuannuan - Via Guogang Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2668",
        "StopID": "2668",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.108715,
            "PositionLon": 121.734565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2669",
        "StopID": "2669",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.107331,
            "PositionLon": 121.736011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2670",
        "StopID": "2670",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.105846,
            "PositionLon": 121.73692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2672",
        "StopID": "2672",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.104108,
            "PositionLon": 121.739558
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1868",
        "StopID": "1868",
        "StopName": {
            "Zh_tw": "暖暖火車站(返)",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.102365,
            "PositionLon": 121.73962
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1889",
        "StopID": "1889",
        "StopName": {
            "Zh_tw": "暖暖街16巷口(返)",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE979",
        "StopID": "979",
        "StopName": {
            "Zh_tw": "暖暖國小(返)",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1869",
        "StopID": "1869",
        "StopName": {
            "Zh_tw": "暖暖火車站(回)",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.102365,
            "PositionLon": 121.73962
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2691",
        "StopID": "2691",
        "StopName": {
            "Zh_tw": "威德廟",
            "En": "Weide Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.103266,
            "PositionLon": 121.737054
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6031",
    "RouteID": "6031",
    "RouteName": {
        "Zh_tw": "603 東勢坑-經東勢街(經暖暖國小)",
        "En": "603 Dongshi Tunnel - Via Dongshi St.(Nuannuan Elementary School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6031",
    "SubRouteID": "6031",
    "SubRouteName": {
        "Zh_tw": "603 東勢坑-經東勢街(經暖暖國小)",
        "En": "603 Dongshi Tunnel - Via Dongshi St.(Nuannuan Elementary School)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2748",
        "StopID": "2748",
        "StopName": {
            "Zh_tw": "東安宮",
            "En": "Dongan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.077163,
            "PositionLon": 121.755273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2749",
        "StopID": "2749",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.077218,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3911",
        "StopID": "3911",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.079326,
            "PositionLon": 121.753036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2750",
        "StopID": "2750",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.0796,
            "PositionLon": 121.75235
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2751",
        "StopID": "2751",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.081735,
            "PositionLon": 121.751128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2752",
        "StopID": "2752",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.749566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2754",
        "StopID": "2754",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.086356,
            "PositionLon": 121.747468
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2755",
        "StopID": "2755",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.086211,
            "PositionLon": 121.744766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2756",
        "StopID": "2756",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.087283,
            "PositionLon": 121.743483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2757",
        "StopID": "2757",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.088533,
            "PositionLon": 121.7427
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5086",
        "StopID": "5086",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.090603,
            "PositionLon": 121.740965
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE987",
        "StopID": "987",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.100416,
            "PositionLon": 121.736808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1888",
        "StopID": "1888",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3983",
        "StopID": "3983",
        "StopName": {
            "Zh_tw": "媽祖廟(安德宮)",
            "En": "Mazu Temple (Ande Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.102113,
            "PositionLon": 121.738415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1867",
        "StopID": "1867",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.102365,
            "PositionLon": 121.73962
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6031",
    "RouteID": "6031",
    "RouteName": {
        "Zh_tw": "603 東勢坑-經東勢街(經暖暖國小)",
        "En": "603 Dongshi Tunnel - Via Dongshi St.(Nuannuan Elementary School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6031",
    "SubRouteID": "6031",
    "SubRouteName": {
        "Zh_tw": "603 東勢坑-經東勢街(經暖暖國小)",
        "En": "603 Dongshi Tunnel - Via Dongshi St.(Nuannuan Elementary School)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1858",
        "StopID": "1858",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.102386,
            "PositionLon": 121.739538
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1878",
        "StopID": "1878",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE978",
        "StopID": "978",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2800",
        "StopID": "2800",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.090572,
            "PositionLon": 121.740878
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2801",
        "StopID": "2801",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.08785,
            "PositionLon": 121.743183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2802",
        "StopID": "2802",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.086816,
            "PositionLon": 121.743883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2803",
        "StopID": "2803",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.0857,
            "PositionLon": 121.7456
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2804",
        "StopID": "2804",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.086338,
            "PositionLon": 121.747238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2805",
        "StopID": "2805",
        "StopName": {
            "Zh_tw": "義興社區",
            "En": "Yixing Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.083591,
            "PositionLon": 121.748248
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2806",
        "StopID": "2806",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.08302,
            "PositionLon": 121.749413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2807",
        "StopID": "2807",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.081763,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2808",
        "StopID": "2808",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.079703,
            "PositionLon": 121.751871
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3910",
        "StopID": "3910",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.079268,
            "PositionLon": 121.75292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2809",
        "StopID": "2809",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.076998,
            "PositionLon": 121.754751
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6032",
    "RouteID": "6032",
    "RouteName": {
        "Zh_tw": "603 東勢坑",
        "En": "603 Dongshi Tunnel - Via Dongshi St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6032",
    "SubRouteID": "6032",
    "SubRouteName": {
        "Zh_tw": "603 東勢坑",
        "En": "603 Dongshi Tunnel - Via Dongshi St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2748",
        "StopID": "2748",
        "StopName": {
            "Zh_tw": "東安宮",
            "En": "Dongan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.077163,
            "PositionLon": 121.755273
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2749",
        "StopID": "2749",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.077218,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3911",
        "StopID": "3911",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.079326,
            "PositionLon": 121.753036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2750",
        "StopID": "2750",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.0796,
            "PositionLon": 121.75235
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2751",
        "StopID": "2751",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.081735,
            "PositionLon": 121.751128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2752",
        "StopID": "2752",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.749566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2754",
        "StopID": "2754",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.086356,
            "PositionLon": 121.747468
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2755",
        "StopID": "2755",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.086211,
            "PositionLon": 121.744766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2756",
        "StopID": "2756",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.087283,
            "PositionLon": 121.743483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2757",
        "StopID": "2757",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.088533,
            "PositionLon": 121.7427
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5086",
        "StopID": "5086",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.090603,
            "PositionLon": 121.740965
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE987",
        "StopID": "987",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.100416,
            "PositionLon": 121.736808
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1888",
        "StopID": "1888",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3983",
        "StopID": "3983",
        "StopName": {
            "Zh_tw": "媽祖廟(安德宮)",
            "En": "Mazu Temple (Ande Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.102113,
            "PositionLon": 121.738415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1867",
        "StopID": "1867",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.102365,
            "PositionLon": 121.73962
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6032",
    "RouteID": "6032",
    "RouteName": {
        "Zh_tw": "603 東勢坑",
        "En": "603 Dongshi Tunnel - Via Dongshi St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6032",
    "SubRouteID": "6032",
    "SubRouteName": {
        "Zh_tw": "603 東勢坑",
        "En": "603 Dongshi Tunnel - Via Dongshi St."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1858",
        "StopID": "1858",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.102386,
            "PositionLon": 121.739538
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1878",
        "StopID": "1878",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE978",
        "StopID": "978",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2800",
        "StopID": "2800",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.090572,
            "PositionLon": 121.740878
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2801",
        "StopID": "2801",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.08785,
            "PositionLon": 121.743183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2802",
        "StopID": "2802",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.086816,
            "PositionLon": 121.743883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2803",
        "StopID": "2803",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.0857,
            "PositionLon": 121.7456
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2804",
        "StopID": "2804",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.086338,
            "PositionLon": 121.747238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2805",
        "StopID": "2805",
        "StopName": {
            "Zh_tw": "義興社區",
            "En": "Yixing Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.083591,
            "PositionLon": 121.748248
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2806",
        "StopID": "2806",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.08302,
            "PositionLon": 121.749413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2807",
        "StopID": "2807",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.081763,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2808",
        "StopID": "2808",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.079703,
            "PositionLon": 121.751871
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3910",
        "StopID": "3910",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.079268,
            "PositionLon": 121.75292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2809",
        "StopID": "2809",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.076998,
            "PositionLon": 121.754751
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6051",
    "RouteID": "6051",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(經水源路)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Shuiyuan Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6051",
    "SubRouteID": "6051",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(經水源路)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Shuiyuan Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2865",
        "StopID": "2865",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2811",
        "StopID": "2811",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.091833,
            "PositionLon": 121.754418
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1859",
        "StopID": "1859",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2813",
        "StopID": "2813",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.092348,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2814",
        "StopID": "2814",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.095726,
            "PositionLon": 121.754853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2815",
        "StopID": "2815",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.0956,
            "PositionLon": 121.751705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6051",
    "RouteID": "6051",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(經水源路)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Shuiyuan Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6051",
    "SubRouteID": "6051",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(經水源路)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Shuiyuan Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2860",
        "StopID": "2860",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.095476,
            "PositionLon": 121.751628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2861",
        "StopID": "2861",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.096023,
            "PositionLon": 121.754763
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2862",
        "StopID": "2862",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.092601,
            "PositionLon": 121.754431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1860",
        "StopID": "1860",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2864",
        "StopID": "2864",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.091696,
            "PositionLon": 121.754366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2150",
        "StopID": "2150",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6052",
    "RouteID": "6052",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(去長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6052",
    "SubRouteID": "6052",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(去長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2865",
        "StopID": "2865",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2811",
        "StopID": "2811",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.091833,
            "PositionLon": 121.754418
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1859",
        "StopID": "1859",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2813",
        "StopID": "2813",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.092348,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2814",
        "StopID": "2814",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.095726,
            "PositionLon": 121.754853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2815",
        "StopID": "2815",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.0956,
            "PositionLon": 121.751705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2044",
        "StopID": "2044",
        "StopName": {
            "Zh_tw": "國安路口",
            "En": "Guoan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.11169,
            "PositionLon": 121.734821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2045",
        "StopID": "2045",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.114879,
            "PositionLon": 121.727829
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2046",
        "StopID": "2046",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.11683,
            "PositionLon": 121.72602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2575",
        "StopID": "2575",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.119983,
            "PositionLon": 121.7228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6052",
    "RouteID": "6052",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(去長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6052",
    "SubRouteID": "6052",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(去長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2860",
        "StopID": "2860",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.095476,
            "PositionLon": 121.751628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2861",
        "StopID": "2861",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.096023,
            "PositionLon": 121.754763
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2862",
        "StopID": "2862",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.092601,
            "PositionLon": 121.754431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1860",
        "StopID": "1860",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2864",
        "StopID": "2864",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.091696,
            "PositionLon": 121.754366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2150",
        "StopID": "2150",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6053",
    "RouteID": "6053",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(回程經長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6053",
    "SubRouteID": "6053",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(回程經長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2865",
        "StopID": "2865",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2811",
        "StopID": "2811",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.091833,
            "PositionLon": 121.754418
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1859",
        "StopID": "1859",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2813",
        "StopID": "2813",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.092348,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2814",
        "StopID": "2814",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.095726,
            "PositionLon": 121.754853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2815",
        "StopID": "2815",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.0956,
            "PositionLon": 121.751705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6053",
    "RouteID": "6053",
    "RouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(回程經長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6053",
    "SubRouteID": "6053",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷-經東碇路(回程經長庚醫院)",
        "En": "605 Longmen Valley - Via Dongding Rd.(Changgung Memorial Hospital)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2548",
        "StopID": "2548",
        "StopName": {
            "Zh_tw": "自強橋頭",
            "En": "Ziqiang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.11958,
            "PositionLon": 121.72302
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2167",
        "StopID": "2167",
        "StopName": {
            "Zh_tw": "富景天下社區",
            "En": "Fujingtianxia Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.11573,
            "PositionLon": 121.72657
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2168",
        "StopID": "2168",
        "StopName": {
            "Zh_tw": "鶯歌里(八德路口)",
            "En": "Yingge Village (Bade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.11482,
            "PositionLon": 121.727851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2860",
        "StopID": "2860",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.095476,
            "PositionLon": 121.751628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2861",
        "StopID": "2861",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.096023,
            "PositionLon": 121.754763
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2862",
        "StopID": "2862",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.092601,
            "PositionLon": 121.754431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1860",
        "StopID": "1860",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2864",
        "StopID": "2864",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.091696,
            "PositionLon": 121.754366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2150",
        "StopID": "2150",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6054",
    "RouteID": "6054",
    "RouteName": {
        "Zh_tw": "605 基隆車站-龍門谷",
        "En": "605 Keelung Station - Longmen Valley"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6054",
    "SubRouteID": "6054",
    "SubRouteName": {
        "Zh_tw": "605 基隆車站-龍門谷",
        "En": "605 Keelung Station - Longmen Valley"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3984",
        "StopID": "3984",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.098217,
            "PositionLon": 121.738661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2860",
        "StopID": "2860",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.095476,
            "PositionLon": 121.751628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2861",
        "StopID": "2861",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.096023,
            "PositionLon": 121.754763
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2862",
        "StopID": "2862",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.092601,
            "PositionLon": 121.754431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1860",
        "StopID": "1860",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2864",
        "StopID": "2864",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.091696,
            "PositionLon": 121.754366
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2150",
        "StopID": "2150",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6055",
    "RouteID": "6055",
    "RouteName": {
        "Zh_tw": "605 龍門谷",
        "En": "605 Longmen Valley - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6055",
    "SubRouteID": "6055",
    "SubRouteName": {
        "Zh_tw": "605 龍門谷",
        "En": "605 Longmen Valley - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2865",
        "StopID": "2865",
        "StopName": {
            "Zh_tw": "幸福華城",
            "En": "Xingfuhuacheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.090596,
            "PositionLon": 121.754533
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2811",
        "StopID": "2811",
        "StopName": {
            "Zh_tw": "龍門谷",
            "En": "Longmen Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.091833,
            "PositionLon": 121.754418
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1859",
        "StopID": "1859",
        "StopName": {
            "Zh_tw": "碇內街69號",
            "En": "No.69, Dingnei St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.092443,
            "PositionLon": 121.754512
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2813",
        "StopID": "2813",
        "StopName": {
            "Zh_tw": "碇內街口",
            "En": "Dingnei St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.092348,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2814",
        "StopID": "2814",
        "StopName": {
            "Zh_tw": "碇祥里",
            "En": "Dingxiang Village"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.095726,
            "PositionLon": 121.754853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2815",
        "StopID": "2815",
        "StopName": {
            "Zh_tw": "影劇新村",
            "En": "Yingjuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.0956,
            "PositionLon": 121.751705
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3990",
        "StopID": "3990",
        "StopName": {
            "Zh_tw": "環翠名盧",
            "En": "Huancuiminglu"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.098139,
            "PositionLon": 121.738508
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6061",
    "RouteID": "6061",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(經八堵車站)",
        "En": "606 Dingnei - Qidu(National Keelung Commercial & Industrial Vocational Senior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6061",
    "SubRouteID": "6061",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(經八堵車站)",
        "En": "606 Dingnei - Qidu(National Keelung Commercial & Industrial Vocational Senior High School)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2595",
        "StopID": "2595",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.099075,
            "PositionLon": 121.76069
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE4000",
        "StopID": "4000",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.099584,
            "PositionLon": 121.758578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1892",
        "StopID": "1892",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 85,
        "StopPosition": {
            "PositionLat": 25.093398,
            "PositionLon": 121.715455
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1893",
        "StopID": "1893",
        "StopName": {
            "Zh_tw": "基隆商工",
            "En": "Keelung Commercial & Industrial Vocational Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 86,
        "StopPosition": {
            "PositionLat": 25.094997,
            "PositionLon": 121.717198
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6061",
    "RouteID": "6061",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(經八堵車站)",
        "En": "606 Dingnei - Qidu(National Keelung Commercial & Industrial Vocational Senior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6061",
    "SubRouteID": "6061",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(經八堵車站)",
        "En": "606 Dingnei - Qidu(National Keelung Commercial & Industrial Vocational Senior High School)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1854",
        "StopID": "1854",
        "StopName": {
            "Zh_tw": "明德國中",
            "En": "Mingde Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.093908,
            "PositionLon": 121.71534
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3991",
        "StopID": "3991",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.099524,
            "PositionLon": 121.75833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2638",
        "StopID": "2638",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.098983,
            "PositionLon": 121.760908
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6062",
    "RouteID": "6062",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(去程經過港路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6062",
    "SubRouteID": "6062",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(去程經過港路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2595",
        "StopID": "2595",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.099075,
            "PositionLon": 121.76069
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE4000",
        "StopID": "4000",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.099584,
            "PositionLon": 121.758578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2760",
        "StopID": "2760",
        "StopName": {
            "Zh_tw": "源遠路76-1號",
            "En": "No.76-1, Yuanyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.102726,
            "PositionLon": 121.739448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6062",
    "RouteID": "6062",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(去程經過港路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6062",
    "SubRouteID": "6062",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(去程經過港路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2668",
        "StopID": "2668",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108715,
            "PositionLon": 121.734565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2669",
        "StopID": "2669",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.107331,
            "PositionLon": 121.736011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2670",
        "StopID": "2670",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.105846,
            "PositionLon": 121.73692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2672",
        "StopID": "2672",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.104108,
            "PositionLon": 121.739558
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1858",
        "StopID": "1858",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.102386,
            "PositionLon": 121.739538
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1878",
        "StopID": "1878",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE978",
        "StopID": "978",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3991",
        "StopID": "3991",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.099524,
            "PositionLon": 121.75833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2638",
        "StopID": "2638",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.098983,
            "PositionLon": 121.760908
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6063",
    "RouteID": "6063",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(經工建路)",
        "En": "606 Dingnei - Qidu(Gongjian Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6063",
    "SubRouteID": "6063",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(經工建路)",
        "En": "606 Dingnei - Qidu(Gongjian Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2595",
        "StopID": "2595",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.099075,
            "PositionLon": 121.76069
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE4000",
        "StopID": "4000",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.099584,
            "PositionLon": 121.758578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2606",
        "StopID": "2606",
        "StopName": {
            "Zh_tw": "礦工醫院",
            "En": "Miners Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.107374,
            "PositionLon": 121.733682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1829",
        "StopID": "1829",
        "StopName": {
            "Zh_tw": "陽明海運",
            "En": "Yangming Marine Transport Corporation"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.710476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1830",
        "StopID": "1830",
        "StopName": {
            "Zh_tw": "光明路口",
            "En": "Guangming Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.093056,
            "PositionLon": 121.710411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1831",
        "StopID": "1831",
        "StopName": {
            "Zh_tw": "草濫",
            "En": "Caolan"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.090223,
            "PositionLon": 121.707033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1832",
        "StopID": "1832",
        "StopName": {
            "Zh_tw": "幸福人生社區",
            "En": "Xingfurensheng Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.088913,
            "PositionLon": 121.705176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1833",
        "StopID": "1833",
        "StopName": {
            "Zh_tw": "六堵嶺",
            "En": "Liuduling"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.08723,
            "PositionLon": 121.705113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1834",
        "StopID": "1834",
        "StopName": {
            "Zh_tw": "六堵加油站",
            "En": "Liudu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.08387,
            "PositionLon": 121.704011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1835",
        "StopID": "1835",
        "StopName": {
            "Zh_tw": "六堵科技園區服務中心",
            "En": "Liudu Industry Park Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.087989,
            "PositionLon": 121.702667
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1836",
        "StopID": "1836",
        "StopName": {
            "Zh_tw": "六堵代天府",
            "En": "Liudu Daitian Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.09001,
            "PositionLon": 121.701478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1837",
        "StopID": "1837",
        "StopName": {
            "Zh_tw": "六堵科技園區",
            "En": "Liudu Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.09151,
            "PositionLon": 121.700439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3926",
        "StopID": "3926",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.094143,
            "PositionLon": 121.701413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3213",
        "StopID": "3213",
        "StopName": {
            "Zh_tw": "六堵水廠",
            "En": "Liudu Waterworks"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.094875,
            "PositionLon": 121.702745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6063",
    "RouteID": "6063",
    "RouteName": {
        "Zh_tw": "606 碇內-七堵(經工建路)",
        "En": "606 Dingnei - Qidu(Gongjian Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6063",
    "SubRouteID": "6063",
    "SubRouteName": {
        "Zh_tw": "606 碇內-七堵(經工建路)",
        "En": "606 Dingnei - Qidu(Gongjian Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3991",
        "StopID": "3991",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.099524,
            "PositionLon": 121.75833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2638",
        "StopID": "2638",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098983,
            "PositionLon": 121.760908
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6065",
    "RouteID": "6065",
    "RouteName": {
        "Zh_tw": "606 七堵-碇內(經八堵路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6065",
    "SubRouteID": "6065",
    "SubRouteName": {
        "Zh_tw": "606 七堵-碇內(經八堵路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2595",
        "StopID": "2595",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.099075,
            "PositionLon": 121.76069
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE4000",
        "StopID": "4000",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.099584,
            "PositionLon": 121.758578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2597",
        "StopID": "2597",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.099215,
            "PositionLon": 121.757016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2598",
        "StopID": "2598",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098841,
            "PositionLon": 121.755531
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2599",
        "StopID": "2599",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098616,
            "PositionLon": 121.753983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3999",
        "StopID": "3999",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.09837,
            "PositionLon": 121.751292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2601",
        "StopID": "2601",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.098161,
            "PositionLon": 121.74967
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2816",
        "StopID": "2816",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.095281,
            "PositionLon": 121.749196
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2817",
        "StopID": "2817",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.09477,
            "PositionLon": 121.743155
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1861",
        "StopID": "1861",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3986",
        "StopID": "3986",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.092876,
            "PositionLon": 121.737703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2648",
        "StopID": "2648",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.09269,
            "PositionLon": 121.736293
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2649",
        "StopID": "2649",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.094135,
            "PositionLon": 121.73536
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2650",
        "StopID": "2650",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09705,
            "PositionLon": 121.7344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2651",
        "StopID": "2651",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.097938,
            "PositionLon": 121.73486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3985",
        "StopID": "3985",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.098961,
            "PositionLon": 121.735476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2760",
        "StopID": "2760",
        "StopName": {
            "Zh_tw": "源遠路76-1號",
            "En": "No.76-1, Yuanyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.102726,
            "PositionLon": 121.739448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1821",
        "StopID": "1821",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.108196,
            "PositionLon": 121.72896
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1823",
        "StopID": "1823",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.104296,
            "PositionLon": 121.726195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1824",
        "StopID": "1824",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.099523,
            "PositionLon": 121.717913
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1825",
        "StopID": "1825",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.098316,
            "PositionLon": 121.715666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3955",
        "StopID": "3955",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.097855,
            "PositionLon": 121.714648
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6065",
    "RouteID": "6065",
    "RouteName": {
        "Zh_tw": "606 七堵-碇內(經八堵路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6065",
    "SubRouteID": "6065",
    "SubRouteName": {
        "Zh_tw": "606 七堵-碇內(經八堵路)",
        "En": "606 Dingnei - Qidu(Guogang Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3933",
        "StopID": "3933",
        "StopName": {
            "Zh_tw": "七堵國小",
            "En": "Qidu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.09799,
            "PositionLon": 121.714801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1795",
        "StopID": "1795",
        "StopName": {
            "Zh_tw": "三分局",
            "En": "Third Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098378,
            "PositionLon": 121.715941
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1796",
        "StopID": "1796",
        "StopName": {
            "Zh_tw": "大華橋",
            "En": "Dahua Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.098955,
            "PositionLon": 121.717183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1797",
        "StopID": "1797",
        "StopName": {
            "Zh_tw": "八堵加油站",
            "En": "Badu Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.103708,
            "PositionLon": 121.726411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1799",
        "StopID": "1799",
        "StopName": {
            "Zh_tw": "八堵火車站",
            "En": "Badu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.108018,
            "PositionLon": 121.728881
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2668",
        "StopID": "2668",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108715,
            "PositionLon": 121.734565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2669",
        "StopID": "2669",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.107331,
            "PositionLon": 121.736011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2670",
        "StopID": "2670",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.105846,
            "PositionLon": 121.73692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2672",
        "StopID": "2672",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.104108,
            "PositionLon": 121.739558
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1858",
        "StopID": "1858",
        "StopName": {
            "Zh_tw": "暖暖火車站",
            "En": "Nuannuan Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.102386,
            "PositionLon": 121.739538
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1878",
        "StopID": "1878",
        "StopName": {
            "Zh_tw": "暖暖街16巷口",
            "En": "Ln. 16, Nuannuan St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.101629,
            "PositionLon": 121.737974
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE978",
        "StopID": "978",
        "StopName": {
            "Zh_tw": "暖暖國小",
            "En": "Keelung Municipal Nuannuan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.100496,
            "PositionLon": 121.737784
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3964",
        "StopID": "3964",
        "StopName": {
            "Zh_tw": "暖暖郵局",
            "En": "Keelung Nuannuan Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.099202,
            "PositionLon": 121.735673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2677",
        "StopID": "2677",
        "StopName": {
            "Zh_tw": "正榮社區",
            "En": "Zhengrong Community"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.0981,
            "PositionLon": 121.734816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2678",
        "StopID": "2678",
        "StopName": {
            "Zh_tw": "水源地",
            "En": "Shuiyuandi"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.097088,
            "PositionLon": 121.734476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2679",
        "StopID": "2679",
        "StopName": {
            "Zh_tw": "教師研習中心",
            "En": "Teachers` In-Service Education Center"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.09408,
            "PositionLon": 121.735231
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2680",
        "StopID": "2680",
        "StopName": {
            "Zh_tw": "暖西國小",
            "En": "Nuanshi Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.092596,
            "PositionLon": 121.736038
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3963",
        "StopID": "3963",
        "StopName": {
            "Zh_tw": "寫意山水社區",
            "En": "Xieyishanshui Community"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.092843,
            "PositionLon": 121.737674
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2609",
        "StopID": "2609",
        "StopName": {
            "Zh_tw": "暖東苗圃",
            "En": "Nuandong Nursery Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09456,
            "PositionLon": 121.739374
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2858",
        "StopID": "2858",
        "StopName": {
            "Zh_tw": "暖暖運動公園",
            "En": "Nuannuan Sports Park"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.094685,
            "PositionLon": 121.743116
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2859",
        "StopID": "2859",
        "StopName": {
            "Zh_tw": "碇內國中",
            "En": "Dingnei Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.095293,
            "PositionLon": 121.74917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2632",
        "StopID": "2632",
        "StopName": {
            "Zh_tw": "十六坑",
            "En": "Shiliukeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.09824,
            "PositionLon": 121.74912
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3992",
        "StopID": "3992",
        "StopName": {
            "Zh_tw": "碇內(博愛仁家)",
            "En": "Dingnei (Senior Citizens Home of Compassion)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.098258,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2634",
        "StopID": "2634",
        "StopName": {
            "Zh_tw": "碇內國小",
            "En": "Dingnei Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.098438,
            "PositionLon": 121.753586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2635",
        "StopID": "2635",
        "StopName": {
            "Zh_tw": "東暖新村",
            "En": "Dongnuanxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.098798,
            "PositionLon": 121.755071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2636",
        "StopID": "2636",
        "StopName": {
            "Zh_tw": "康樂新村",
            "En": "Kanglexincun"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.099165,
            "PositionLon": 121.756978
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3991",
        "StopID": "3991",
        "StopName": {
            "Zh_tw": "寶祥吉祥",
            "En": "Baoxiangjixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.099524,
            "PositionLon": 121.75833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2638",
        "StopID": "2638",
        "StopName": {
            "Zh_tw": "四腳亭",
            "En": "Sijiaoting"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.098983,
            "PositionLon": 121.760908
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6071",
    "RouteID": "6071",
    "RouteName": {
        "Zh_tw": "607 羅傑摩爾-八南里(經過港路)",
        "En": "607 Luojiemoer - Banan Village(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6071",
    "SubRouteID": "6071",
    "SubRouteName": {
        "Zh_tw": "607 羅傑摩爾-八南里(經過港路)",
        "En": "607 Luojiemoer - Banan Village(Guogang Rd.)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3004",
        "StopID": "3004",
        "StopName": {
            "Zh_tw": "羅傑摩爾社區",
            "En": "Luojiemoer Community"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.106001,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3954",
        "StopID": "3954",
        "StopName": {
            "Zh_tw": "靈鳳宮",
            "En": "Lingfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.104747,
            "PositionLon": 121.742475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3008",
        "StopID": "3008",
        "StopName": {
            "Zh_tw": "過港路10巷31號",
            "En": "No.31, Ln. 10, Guogang Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.104553,
            "PositionLon": 121.741861
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3009",
        "StopID": "3009",
        "StopName": {
            "Zh_tw": "圓滿社區",
            "En": "Yuanman Community"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.10381,
            "PositionLon": 121.741016
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1800",
        "StopID": "1800",
        "StopName": {
            "Zh_tw": "八南里",
            "En": "Banan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.10862,
            "PositionLon": 121.731263
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6071",
    "RouteID": "6071",
    "RouteName": {
        "Zh_tw": "607 羅傑摩爾-八南里(經過港路)",
        "En": "607 Luojiemoer - Banan Village(Guogang Rd.)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6071",
    "SubRouteID": "6071",
    "SubRouteName": {
        "Zh_tw": "607 羅傑摩爾-八南里(經過港路)",
        "En": "607 Luojiemoer - Banan Village(Guogang Rd.)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2668",
        "StopID": "2668",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.108715,
            "PositionLon": 121.734565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2669",
        "StopID": "2669",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.107331,
            "PositionLon": 121.736011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2670",
        "StopID": "2670",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.105846,
            "PositionLon": 121.73692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2672",
        "StopID": "2672",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.104108,
            "PositionLon": 121.739558
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3002",
        "StopID": "3002",
        "StopName": {
            "Zh_tw": "圓滿社區",
            "En": "Yuanman Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.103731,
            "PositionLon": 121.741131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3003",
        "StopID": "3003",
        "StopName": {
            "Zh_tw": "過港路10巷31號",
            "En": "No.31, Ln. 10, Guogang Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10455,
            "PositionLon": 121.74175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3953",
        "StopID": "3953",
        "StopName": {
            "Zh_tw": "靈鳳宮",
            "En": "Lingfeng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.104715,
            "PositionLon": 121.742578
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3007",
        "StopID": "3007",
        "StopName": {
            "Zh_tw": "羅傑摩爾社區",
            "En": "Luojiemoer Community"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.105997,
            "PositionLon": 121.742942
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6081",
    "RouteID": "6081",
    "RouteName": {
        "Zh_tw": "608 南新街-基隆車站",
        "En": "608 Nanxin St. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6081",
    "SubRouteID": "6081",
    "SubRouteName": {
        "Zh_tw": "608 南新街-基隆車站",
        "En": "608 Nanxin St. - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3952",
        "StopID": "3952",
        "StopName": {
            "Zh_tw": "南新街",
            "En": "Nanxin St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.123888,
            "PositionLon": 121.744626
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6081",
    "RouteID": "6081",
    "RouteName": {
        "Zh_tw": "608 南新街-基隆車站",
        "En": "608 Nanxin St. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6081",
    "SubRouteID": "6081",
    "SubRouteName": {
        "Zh_tw": "608 南新街-基隆車站",
        "En": "608 Nanxin St. - Keelung Station"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6091",
    "RouteID": "6091",
    "RouteName": {
        "Zh_tw": "609 過港路-基隆車站",
        "En": "609 Guogang Rd. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6091",
    "SubRouteID": "6091",
    "SubRouteName": {
        "Zh_tw": "609 過港路-基隆車站",
        "En": "609 Guogang Rd. - Keelung Station"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2787",
        "StopID": "2787",
        "StopName": {
            "Zh_tw": "興隆街4號(臨時站)",
            "En": "No.4, Xinglong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.103409,
            "PositionLon": 121.746158
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2657",
        "StopID": "2657",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.10415,
            "PositionLon": 121.739583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE67",
        "StopID": "67",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.147873,
            "PositionLon": 121.77102
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2659",
        "StopID": "2659",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.105673,
            "PositionLon": 121.737163
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2660",
        "StopID": "2660",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.107536,
            "PositionLon": 121.735921
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2661",
        "StopID": "2661",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.108926,
            "PositionLon": 121.734488
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6091",
    "RouteID": "6091",
    "RouteName": {
        "Zh_tw": "609 過港路-基隆車站",
        "En": "609 Guogang Rd. - Keelung Station"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6091",
    "SubRouteID": "6091",
    "SubRouteName": {
        "Zh_tw": "609 過港路-基隆車站",
        "En": "609 Guogang Rd. - Keelung Station"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2668",
        "StopID": "2668",
        "StopName": {
            "Zh_tw": "指修宮",
            "En": "Zhixiu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.108715,
            "PositionLon": 121.734565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2669",
        "StopID": "2669",
        "StopName": {
            "Zh_tw": "中漁新村",
            "En": "Zhongyuxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.107331,
            "PositionLon": 121.736011
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2670",
        "StopID": "2670",
        "StopName": {
            "Zh_tw": "過港郵局",
            "En": "Keelung Guogang Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.105846,
            "PositionLon": 121.73692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2672",
        "StopID": "2672",
        "StopName": {
            "Zh_tw": "暖暖高中",
            "En": "Nuannuan High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.104108,
            "PositionLon": 121.739558
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2788",
        "StopID": "2788",
        "StopName": {
            "Zh_tw": "興隆街4號(臨時站)",
            "En": "No.4, Xinglong St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.103409,
            "PositionLon": 121.746158
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6101",
    "RouteID": "6101",
    "RouteName": {
        "Zh_tw": "610 基隆車站-十分寮",
        "En": "610 Keelung Station - Shifen Waterfall"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6101",
    "SubRouteID": "6101",
    "SubRouteName": {
        "Zh_tw": "610 基隆車站-十分寮",
        "En": "610 Keelung Station - Shifen Waterfall"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1812",
        "StopID": "1812",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.126693,
            "PositionLon": 121.741976
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3996",
        "StopID": "3996",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.123435,
            "PositionLon": 121.742929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1814",
        "StopID": "1814",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.119909,
            "PositionLon": 121.74324
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3979",
        "StopID": "3979",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.118391,
            "PositionLon": 121.743656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1816",
        "StopID": "1816",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.115418,
            "PositionLon": 121.742988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1817",
        "StopID": "1817",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.112833,
            "PositionLon": 121.739698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1818",
        "StopID": "1818",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.110883,
            "PositionLon": 121.735983
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1819",
        "StopID": "1819",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.110615,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2627",
        "StopID": "2627",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.1085,
            "PositionLon": 121.732043
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3998",
        "StopID": "3998",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.106153,
            "PositionLon": 121.734233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2628",
        "StopID": "2628",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.10335,
            "PositionLon": 121.735563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2854",
        "StopID": "2854",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.100421,
            "PositionLon": 121.736101
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE485",
        "StopID": "485",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.099569,
            "PositionLon": 121.736595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3988",
        "StopID": "3988",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.096268,
            "PositionLon": 121.738844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2645",
        "StopID": "2645",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094566,
            "PositionLon": 121.738683
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3987",
        "StopID": "3987",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.093239,
            "PositionLon": 121.738905
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2800",
        "StopID": "2800",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.090572,
            "PositionLon": 121.740878
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2801",
        "StopID": "2801",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.08785,
            "PositionLon": 121.743183
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2802",
        "StopID": "2802",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.086816,
            "PositionLon": 121.743883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2803",
        "StopID": "2803",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.0857,
            "PositionLon": 121.7456
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2804",
        "StopID": "2804",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.086338,
            "PositionLon": 121.747238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2805",
        "StopID": "2805",
        "StopName": {
            "Zh_tw": "義興社區",
            "En": "Yixing Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.083591,
            "PositionLon": 121.748248
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2806",
        "StopID": "2806",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.08302,
            "PositionLon": 121.749413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2807",
        "StopID": "2807",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.081763,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2808",
        "StopID": "2808",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.079703,
            "PositionLon": 121.751871
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3910",
        "StopID": "3910",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.079268,
            "PositionLon": 121.75292
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2809",
        "StopID": "2809",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.076998,
            "PositionLon": 121.754751
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6101",
        "StopID": "6101",
        "StopName": {
            "Zh_tw": "荖寮坑礦業園區",
            "En": "Laoliaokeng Mining Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.075603,
            "PositionLon": 121.75632
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6102",
        "StopID": "6102",
        "StopName": {
            "Zh_tw": "新平溪煤礦博物館",
            "En": "Xinpingxi Coal Mine Museum"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.052151,
            "PositionLon": 121.772954
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6103",
        "StopID": "6103",
        "StopName": {
            "Zh_tw": "十分寮橋",
            "En": "Shifenliao Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.042671,
            "PositionLon": 121.777507
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6104",
        "StopID": "6104",
        "StopName": {
            "Zh_tw": "十分寮(老街)",
            "En": "Shifenliao Old Street"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.044442,
            "PositionLon": 121.779403
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6105",
        "StopID": "6105",
        "StopName": {
            "Zh_tw": "十分遊客中心",
            "En": "Shifen Tourist Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.04721,
            "PositionLon": 121.782624
        },
        "LocationCityCode": "NWT"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE6101",
    "RouteID": "6101",
    "RouteName": {
        "Zh_tw": "610 基隆車站-十分寮",
        "En": "610 Keelung Station - Shifen Waterfall"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE6101",
    "SubRouteID": "6101",
    "SubRouteName": {
        "Zh_tw": "610 基隆車站-十分寮",
        "En": "610 Keelung Station - Shifen Waterfall"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE6106",
        "StopID": "6106",
        "StopName": {
            "Zh_tw": "十分遊客中心",
            "En": "Shifen Tourist Service Center"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.04721,
            "PositionLon": 121.782624
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6107",
        "StopID": "6107",
        "StopName": {
            "Zh_tw": "十分寮(老街)",
            "En": "Shifenliao Old Street"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.044442,
            "PositionLon": 121.779403
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6108",
        "StopID": "6108",
        "StopName": {
            "Zh_tw": "十分寮橋",
            "En": "Shifenliao Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.042671,
            "PositionLon": 121.777507
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6109",
        "StopID": "6109",
        "StopName": {
            "Zh_tw": "新平溪煤礦博物館",
            "En": "Xinpingxi Coal Mine Museum"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.052151,
            "PositionLon": 121.772954
        },
        "LocationCityCode": "NWT"
    }, {
        "StopUID": "KEE6110",
        "StopID": "6110",
        "StopName": {
            "Zh_tw": "荖寮坑礦業園區",
            "En": "Laoliaokeng Mining Industry Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.075603,
            "PositionLon": 121.75632
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2749",
        "StopID": "2749",
        "StopName": {
            "Zh_tw": "暖東峽谷",
            "En": "Nuandong Valley"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.077218,
            "PositionLon": 121.754495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3911",
        "StopID": "3911",
        "StopName": {
            "Zh_tw": "東勢街177號",
            "En": "No.177, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.079326,
            "PositionLon": 121.753036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2750",
        "StopID": "2750",
        "StopName": {
            "Zh_tw": "東勢坑二號橋",
            "En": "Dongshikeng NO.2 Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.0796,
            "PositionLon": 121.75235
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2751",
        "StopID": "2751",
        "StopName": {
            "Zh_tw": "東勢坑",
            "En": "Dongshikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.081735,
            "PositionLon": 121.751128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2752",
        "StopID": "2752",
        "StopName": {
            "Zh_tw": "二坑",
            "En": "Erkeng"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.749566
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2753",
        "StopID": "2753",
        "StopName": {
            "Zh_tw": "義興社區",
            "En": "Yixing Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.083495,
            "PositionLon": 121.748453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2754",
        "StopID": "2754",
        "StopName": {
            "Zh_tw": "後湖",
            "En": "Houhu"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.086356,
            "PositionLon": 121.747468
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2755",
        "StopID": "2755",
        "StopName": {
            "Zh_tw": "東勢街71之2號",
            "En": "No.2 of 71, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.086211,
            "PositionLon": 121.744766
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2756",
        "StopID": "2756",
        "StopName": {
            "Zh_tw": "一心站",
            "En": "Yixin Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.087283,
            "PositionLon": 121.743483
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2757",
        "StopID": "2757",
        "StopName": {
            "Zh_tw": "東勢街49號",
            "En": "No.49, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.088533,
            "PositionLon": 121.7427
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5086",
        "StopID": "5086",
        "StopName": {
            "Zh_tw": "東勢街41號",
            "En": "No.41, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.090603,
            "PositionLon": 121.740965
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3962",
        "StopID": "3962",
        "StopName": {
            "Zh_tw": "暖暖聖光堂",
            "En": "Nuan Holy Light Baptist Church"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.093272,
            "PositionLon": 121.738917
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2683",
        "StopID": "2683",
        "StopName": {
            "Zh_tw": "東興廟",
            "En": "Dongxing Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.094148,
            "PositionLon": 121.73911
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3961",
        "StopID": "3961",
        "StopName": {
            "Zh_tw": "碧嵐大地社區",
            "En": "Bilandadi Community"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.096252,
            "PositionLon": 121.738943
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE487",
        "StopID": "487",
        "StopName": {
            "Zh_tw": "東勢街1-1號",
            "En": "No.1-1, Dongshih St."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.098808,
            "PositionLon": 121.737722
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE486",
        "StopID": "486",
        "StopName": {
            "Zh_tw": "東勢街土地廟",
            "En": "Dongshih St. (Tudi Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.099537,
            "PositionLon": 121.736777
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2820",
        "StopID": "2820",
        "StopName": {
            "Zh_tw": "暖暖區公所",
            "En": "Keelung City Nuannuan District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.100108,
            "PositionLon": 121.736241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2605",
        "StopID": "2605",
        "StopName": {
            "Zh_tw": "水源路",
            "En": "Shuiyuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.10358,
            "PositionLon": 121.73564
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3993",
        "StopID": "3993",
        "StopName": {
            "Zh_tw": "水源路二巷口",
            "En": "Ln. 2, Shuiyuan Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.10615,
            "PositionLon": 121.73431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2607",
        "StopID": "2607",
        "StopName": {
            "Zh_tw": "八堵國小",
            "En": "Badu Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.108475,
            "PositionLon": 121.732275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1801",
        "StopID": "1801",
        "StopName": {
            "Zh_tw": "八堵橋",
            "En": "Badu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.110336,
            "PositionLon": 121.734053
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1802",
        "StopID": "1802",
        "StopName": {
            "Zh_tw": "海會寺",
            "En": "Haihui Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.110533,
            "PositionLon": 121.736523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1803",
        "StopID": "1803",
        "StopName": {
            "Zh_tw": "南榮公墓(英仁里)",
            "En": "Nanrong Cemetery"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.113053,
            "PositionLon": 121.740453
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1804",
        "StopID": "1804",
        "StopName": {
            "Zh_tw": "寶明寺",
            "En": "Baoming Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.115158,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3997",
        "StopID": "3997",
        "StopName": {
            "Zh_tw": "蓬萊隧道北口",
            "En": "Penglai Tunnel N. Exit"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.118627,
            "PositionLon": 121.74357
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1806",
        "StopID": "1806",
        "StopName": {
            "Zh_tw": "南榮國小",
            "En": "Nanrong Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.120889,
            "PositionLon": 121.743309
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3995",
        "StopID": "3995",
        "StopName": {
            "Zh_tw": "三坑",
            "En": "Sankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.123108,
            "PositionLon": 121.742954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1808",
        "StopID": "1808",
        "StopName": {
            "Zh_tw": "南榮路口",
            "En": "Nanrong Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.126478,
            "PositionLon": 121.742603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7011",
    "RouteID": "7011",
    "RouteName": {
        "Zh_tw": "701 七堵-瑪陵",
        "En": "701 Qidu - Maling"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7011",
    "SubRouteID": "7011",
    "SubRouteName": {
        "Zh_tw": "701 七堵-瑪陵",
        "En": "701 Qidu - Maling"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3977",
        "StopID": "3977",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098262,
            "PositionLon": 121.714067
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3951",
        "StopID": "3951",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09922,
            "PositionLon": 121.713697
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3042",
        "StopID": "3042",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.10139,
            "PositionLon": 121.712358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2663",
        "StopID": "2663",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.100837,
            "PositionLon": 121.710543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2612",
        "StopID": "2612",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3043",
        "StopID": "3043",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096205,
            "PositionLon": 121.705586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3044",
        "StopID": "3044",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.100953,
            "PositionLon": 121.698801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3045",
        "StopID": "3045",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.101625,
            "PositionLon": 121.695973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3046",
        "StopID": "3046",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.104831,
            "PositionLon": 121.69623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3047",
        "StopID": "3047",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.105075,
            "PositionLon": 121.69367
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3950",
        "StopID": "3950",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.105966,
            "PositionLon": 121.692338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3049",
        "StopID": "3049",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.109,
            "PositionLon": 121.691813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3949",
        "StopID": "3949",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.11094,
            "PositionLon": 121.688963
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2614",
        "StopID": "2614",
        "StopName": {
            "Zh_tw": "青嵐橋(金明昌鹿園)",
            "En": "Qinglan Bridge ( Jin Ming Chang Deer Garden )"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1115,
            "PositionLon": 121.687984
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3052",
        "StopID": "3052",
        "StopName": {
            "Zh_tw": "翠谷橋",
            "En": "Cuigu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11088,
            "PositionLon": 121.686745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2831",
        "StopID": "2831",
        "StopName": {
            "Zh_tw": "大華三路10號",
            "En": "No.10, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.112397,
            "PositionLon": 121.684411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3947",
        "StopID": "3947",
        "StopName": {
            "Zh_tw": "向揚工業",
            "En": "Xiangyang Industry"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.112131,
            "PositionLon": 121.68471
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3946",
        "StopID": "3946",
        "StopName": {
            "Zh_tw": "長潭(焦炭窯)",
            "En": "Zhang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.113411,
            "PositionLon": 121.682431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3945",
        "StopID": "3945",
        "StopName": {
            "Zh_tw": "茶花園",
            "En": "Camellia Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.117528,
            "PositionLon": 121.680665
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3057",
        "StopID": "3057",
        "StopName": {
            "Zh_tw": "鯉魚潭",
            "En": "Liyu Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.121175,
            "PositionLon": 121.681176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3058",
        "StopID": "3058",
        "StopName": {
            "Zh_tw": "仙洞湖",
            "En": "Xiandong Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.122871,
            "PositionLon": 121.679448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3059",
        "StopID": "3059",
        "StopName": {
            "Zh_tw": "福德宮(遊客服務中心)",
            "En": "Fude Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124965,
            "PositionLon": 121.679486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3944",
        "StopID": "3944",
        "StopName": {
            "Zh_tw": "武玄宮",
            "En": "Wuxuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.127131,
            "PositionLon": 121.678181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3061",
        "StopID": "3061",
        "StopName": {
            "Zh_tw": "瑪西里民活動中心",
            "En": "Maxi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128571,
            "PositionLon": 121.677541
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3943",
        "StopID": "3943",
        "StopName": {
            "Zh_tw": "大華三路95號",
            "En": "No.95, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.130193,
            "PositionLon": 121.675416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3063",
        "StopID": "3063",
        "StopName": {
            "Zh_tw": "瑪陵",
            "En": "Maling"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130835,
            "PositionLon": 121.673893
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7011",
    "RouteID": "7011",
    "RouteName": {
        "Zh_tw": "701 七堵-瑪陵",
        "En": "701 Qidu - Maling"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7011",
    "SubRouteID": "7011",
    "SubRouteName": {
        "Zh_tw": "701 七堵-瑪陵",
        "En": "701 Qidu - Maling"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3064",
        "StopID": "3064",
        "StopName": {
            "Zh_tw": "瑪陵",
            "En": "Maling"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.130825,
            "PositionLon": 121.674046
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3942",
        "StopID": "3942",
        "StopName": {
            "Zh_tw": "大華三路95號",
            "En": "No.95, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.13026,
            "PositionLon": 121.675403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3066",
        "StopID": "3066",
        "StopName": {
            "Zh_tw": "瑪西里民活動中心",
            "En": "Maxi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128665,
            "PositionLon": 121.677593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3941",
        "StopID": "3941",
        "StopName": {
            "Zh_tw": "武玄宮",
            "En": "Wuxuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.127191,
            "PositionLon": 121.678233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3068",
        "StopID": "3068",
        "StopName": {
            "Zh_tw": "福德宮(遊客服務中心)",
            "En": "Fude Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.124978,
            "PositionLon": 121.679436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3069",
        "StopID": "3069",
        "StopName": {
            "Zh_tw": "仙洞湖",
            "En": "Xiandong Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.124471,
            "PositionLon": 121.67959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3070",
        "StopID": "3070",
        "StopName": {
            "Zh_tw": "鯉魚潭",
            "En": "Liyu Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122868,
            "PositionLon": 121.679385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3940",
        "StopID": "3940",
        "StopName": {
            "Zh_tw": "茶花園",
            "En": "Camellia Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.12174,
            "PositionLon": 121.680076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3939",
        "StopID": "3939",
        "StopName": {
            "Zh_tw": "長潭(焦炭窯)",
            "En": "Zhang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.117541,
            "PositionLon": 121.680651
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3938",
        "StopID": "3938",
        "StopName": {
            "Zh_tw": "向揚工業",
            "En": "Xiangyang Industry"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.113483,
            "PositionLon": 121.682431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2841",
        "StopID": "2841",
        "StopName": {
            "Zh_tw": "大華三路10號",
            "En": "No.10, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.112074,
            "PositionLon": 121.684832
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3075",
        "StopID": "3075",
        "StopName": {
            "Zh_tw": "翠谷橋",
            "En": "Cuigu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.110868,
            "PositionLon": 121.686821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2501",
        "StopID": "2501",
        "StopName": {
            "Zh_tw": "青嵐橋(金明昌鹿園)",
            "En": "Qinglan Bridge ( Jin Ming Chang Deer Garden )"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.1115,
            "PositionLon": 121.687984
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3936",
        "StopID": "3936",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.110978,
            "PositionLon": 121.688985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3078",
        "StopID": "3078",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.108925,
            "PositionLon": 121.691851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3935",
        "StopID": "3935",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.10605,
            "PositionLon": 121.692325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3080",
        "StopID": "3080",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.105,
            "PositionLon": 121.693758
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3081",
        "StopID": "3081",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.104866,
            "PositionLon": 121.696178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3082",
        "StopID": "3082",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.101715,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3083",
        "StopID": "3083",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.100883,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3084",
        "StopID": "3084",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.096228,
            "PositionLon": 121.705573
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2613",
        "StopID": "2613",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2673",
        "StopID": "2673",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.100863,
            "PositionLon": 121.710858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3085",
        "StopID": "3085",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.101456,
            "PositionLon": 121.712241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3934",
        "StopID": "3934",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.099272,
            "PositionLon": 121.713646
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3978",
        "StopID": "3978",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.120533,
            "PositionLon": 121.743256
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7012",
    "RouteID": "7012",
    "RouteName": {
        "Zh_tw": "701 瑪陵-經苓蘭農場",
        "En": "701 Maling - Via Linglan Farm"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7012",
    "SubRouteID": "7012",
    "SubRouteName": {
        "Zh_tw": "701 瑪陵-經苓蘭農場",
        "En": "701 Maling - Via Linglan Farm"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3977",
        "StopID": "3977",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098262,
            "PositionLon": 121.714067
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3951",
        "StopID": "3951",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09922,
            "PositionLon": 121.713697
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3042",
        "StopID": "3042",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.10139,
            "PositionLon": 121.712358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2663",
        "StopID": "2663",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.100837,
            "PositionLon": 121.710543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2612",
        "StopID": "2612",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3043",
        "StopID": "3043",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096205,
            "PositionLon": 121.705586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3044",
        "StopID": "3044",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.100953,
            "PositionLon": 121.698801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3045",
        "StopID": "3045",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.101625,
            "PositionLon": 121.695973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3046",
        "StopID": "3046",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.104831,
            "PositionLon": 121.69623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3047",
        "StopID": "3047",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.105075,
            "PositionLon": 121.69367
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3950",
        "StopID": "3950",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.105966,
            "PositionLon": 121.692338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3049",
        "StopID": "3049",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.109,
            "PositionLon": 121.691813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3949",
        "StopID": "3949",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.11094,
            "PositionLon": 121.688963
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2614",
        "StopID": "2614",
        "StopName": {
            "Zh_tw": "青嵐橋(金明昌鹿園)",
            "En": "Qinglan Bridge ( Jin Ming Chang Deer Garden )"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.1115,
            "PositionLon": 121.687984
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3052",
        "StopID": "3052",
        "StopName": {
            "Zh_tw": "翠谷橋",
            "En": "Cuigu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11088,
            "PositionLon": 121.686745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2831",
        "StopID": "2831",
        "StopName": {
            "Zh_tw": "大華三路10號",
            "En": "No.10, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.112397,
            "PositionLon": 121.684411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3947",
        "StopID": "3947",
        "StopName": {
            "Zh_tw": "向揚工業",
            "En": "Xiangyang Industry"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.112131,
            "PositionLon": 121.68471
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3946",
        "StopID": "3946",
        "StopName": {
            "Zh_tw": "長潭(焦炭窯)",
            "En": "Zhang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.113411,
            "PositionLon": 121.682431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3945",
        "StopID": "3945",
        "StopName": {
            "Zh_tw": "茶花園",
            "En": "Camellia Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.117528,
            "PositionLon": 121.680665
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3057",
        "StopID": "3057",
        "StopName": {
            "Zh_tw": "鯉魚潭",
            "En": "Liyu Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.121175,
            "PositionLon": 121.681176
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3058",
        "StopID": "3058",
        "StopName": {
            "Zh_tw": "仙洞湖",
            "En": "Xiandong Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.122871,
            "PositionLon": 121.679448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3059",
        "StopID": "3059",
        "StopName": {
            "Zh_tw": "福德宮(遊客服務中心)",
            "En": "Fude Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.124965,
            "PositionLon": 121.679486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3944",
        "StopID": "3944",
        "StopName": {
            "Zh_tw": "武玄宮",
            "En": "Wuxuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.127131,
            "PositionLon": 121.678181
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3061",
        "StopID": "3061",
        "StopName": {
            "Zh_tw": "瑪西里民活動中心",
            "En": "Maxi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.128571,
            "PositionLon": 121.677541
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3943",
        "StopID": "3943",
        "StopName": {
            "Zh_tw": "大華三路95號",
            "En": "No.95, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.130193,
            "PositionLon": 121.675416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3063",
        "StopID": "3063",
        "StopName": {
            "Zh_tw": "瑪陵",
            "En": "Maling"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.130835,
            "PositionLon": 121.673893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3120",
        "StopID": "3120",
        "StopName": {
            "Zh_tw": "大華三路100號(親水公園)",
            "En": "No.100, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.133215,
            "PositionLon": 121.67369
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3124",
        "StopID": "3124",
        "StopName": {
            "Zh_tw": "面桶寮",
            "En": "Miantongliao"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.133958,
            "PositionLon": 121.673726
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3121",
        "StopID": "3121",
        "StopName": {
            "Zh_tw": "苓蘭休閒農場",
            "En": "Linglan Recreational Farm"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.141475,
            "PositionLon": 121.667698
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7012",
    "RouteID": "7012",
    "RouteName": {
        "Zh_tw": "701 瑪陵-經苓蘭農場",
        "En": "701 Maling - Via Linglan Farm"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7012",
    "SubRouteID": "7012",
    "SubRouteName": {
        "Zh_tw": "701 瑪陵-經苓蘭農場",
        "En": "701 Maling - Via Linglan Farm"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3122",
        "StopID": "3122",
        "StopName": {
            "Zh_tw": "苓蘭休閒農場",
            "En": "Linglan Recreational Farm"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.141475,
            "PositionLon": 121.667698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3119",
        "StopID": "3119",
        "StopName": {
            "Zh_tw": "面桶寮",
            "En": "Miantongliao"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.133966,
            "PositionLon": 121.673586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3123",
        "StopID": "3123",
        "StopName": {
            "Zh_tw": "大華三路100號(親水公園)",
            "En": "No.100, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.133215,
            "PositionLon": 121.67369
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3064",
        "StopID": "3064",
        "StopName": {
            "Zh_tw": "瑪陵",
            "En": "Maling"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.130825,
            "PositionLon": 121.674046
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3942",
        "StopID": "3942",
        "StopName": {
            "Zh_tw": "大華三路95號",
            "En": "No.95, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.13026,
            "PositionLon": 121.675403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3066",
        "StopID": "3066",
        "StopName": {
            "Zh_tw": "瑪西里民活動中心",
            "En": "Maxi Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128665,
            "PositionLon": 121.677593
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3941",
        "StopID": "3941",
        "StopName": {
            "Zh_tw": "武玄宮",
            "En": "Wuxuan Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127191,
            "PositionLon": 121.678233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3068",
        "StopID": "3068",
        "StopName": {
            "Zh_tw": "福德宮(遊客服務中心)",
            "En": "Fude Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124978,
            "PositionLon": 121.679436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3069",
        "StopID": "3069",
        "StopName": {
            "Zh_tw": "仙洞湖",
            "En": "Xiandong Lake"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.124471,
            "PositionLon": 121.67959
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3070",
        "StopID": "3070",
        "StopName": {
            "Zh_tw": "鯉魚潭",
            "En": "Liyu Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.122868,
            "PositionLon": 121.679385
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3940",
        "StopID": "3940",
        "StopName": {
            "Zh_tw": "茶花園",
            "En": "Camellia Garden"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.12174,
            "PositionLon": 121.680076
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3939",
        "StopID": "3939",
        "StopName": {
            "Zh_tw": "長潭(焦炭窯)",
            "En": "Zhang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.117541,
            "PositionLon": 121.680651
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3938",
        "StopID": "3938",
        "StopName": {
            "Zh_tw": "向揚工業",
            "En": "Xiangyang Industry"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.113483,
            "PositionLon": 121.682431
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2841",
        "StopID": "2841",
        "StopName": {
            "Zh_tw": "大華三路10號",
            "En": "No.10, Dahua 3rd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.112074,
            "PositionLon": 121.684832
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3075",
        "StopID": "3075",
        "StopName": {
            "Zh_tw": "翠谷橋",
            "En": "Cuigu Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.110868,
            "PositionLon": 121.686821
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2501",
        "StopID": "2501",
        "StopName": {
            "Zh_tw": "青嵐橋(金明昌鹿園)",
            "En": "Qinglan Bridge ( Jin Ming Chang Deer Garden )"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.1115,
            "PositionLon": 121.687984
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3936",
        "StopID": "3936",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.110978,
            "PositionLon": 121.688985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3078",
        "StopID": "3078",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.108925,
            "PositionLon": 121.691851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3935",
        "StopID": "3935",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.10605,
            "PositionLon": 121.692325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3080",
        "StopID": "3080",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.105,
            "PositionLon": 121.693758
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3081",
        "StopID": "3081",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.104866,
            "PositionLon": 121.696178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3082",
        "StopID": "3082",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.101715,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3083",
        "StopID": "3083",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.100883,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3084",
        "StopID": "3084",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.096228,
            "PositionLon": 121.705573
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2613",
        "StopID": "2613",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2673",
        "StopID": "2673",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.100863,
            "PositionLon": 121.710858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3085",
        "StopID": "3085",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.101456,
            "PositionLon": 121.712241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3934",
        "StopID": "3934",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.099272,
            "PositionLon": 121.713646
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3978",
        "StopID": "3978",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.120533,
            "PositionLon": 121.743256
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7021",
    "RouteID": "7021",
    "RouteName": {
        "Zh_tw": "702 七堵-友蚋",
        "En": "702 Qidu - Yourui"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7021",
    "SubRouteID": "7021",
    "SubRouteName": {
        "Zh_tw": "702 七堵-友蚋",
        "En": "702 Qidu - Yourui"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3212",
        "StopID": "3212",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094341,
            "PositionLon": 121.701388
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3917",
        "StopID": "3917",
        "StopName": {
            "Zh_tw": "消防隊",
            "En": "Fire Department"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.085483,
            "PositionLon": 121.69724
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3160",
        "StopID": "3160",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.085233,
            "PositionLon": 121.695781
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1846",
        "StopID": "1846",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.0845,
            "PositionLon": 121.691966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1847",
        "StopID": "1847",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.084336,
            "PositionLon": 121.690853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1848",
        "StopID": "1848",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.082961,
            "PositionLon": 121.6886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3764",
        "StopID": "3764",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.08239,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3165",
        "StopID": "3165",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.084488,
            "PositionLon": 121.683353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3166",
        "StopID": "3166",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.08669,
            "PositionLon": 121.676491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3168",
        "StopID": "3168",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.086223,
            "PositionLon": 121.672421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5123",
        "StopID": "5123",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.087992,
            "PositionLon": 121.66823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1765",
        "StopID": "1765",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.155726,
            "PositionLon": 121.730383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3929",
        "StopID": "3929",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.090446,
            "PositionLon": 121.667845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5082",
        "StopID": "5082",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3172",
        "StopID": "3172",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09386,
            "PositionLon": 121.669246
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3173",
        "StopID": "3173",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09583,
            "PositionLon": 121.666661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3174",
        "StopID": "3174",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.098248,
            "PositionLon": 121.666341
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3176",
        "StopID": "3176",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.103059,
            "PositionLon": 121.66542
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3177",
        "StopID": "3177",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.105171,
            "PositionLon": 121.664523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3931",
        "StopID": "3931",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.106882,
            "PositionLon": 121.665401
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5080",
        "StopID": "5080",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3180",
        "StopID": "3180",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.111711,
            "PositionLon": 121.664383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3181",
        "StopID": "3181",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.11316,
            "PositionLon": 121.664485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3182",
        "StopID": "3182",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.116479,
            "PositionLon": 121.659759
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5084",
        "StopID": "5084",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3184",
        "StopID": "3184",
        "StopName": {
            "Zh_tw": "內十四坑",
            "En": "Neishisikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.114049,
            "PositionLon": 121.653953
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7021",
    "RouteID": "7021",
    "RouteName": {
        "Zh_tw": "702 七堵-友蚋",
        "En": "702 Qidu - Yourui"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7021",
    "SubRouteID": "7021",
    "SubRouteName": {
        "Zh_tw": "702 七堵-友蚋",
        "En": "702 Qidu - Yourui"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5085",
        "StopID": "5085",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3187",
        "StopID": "3187",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.11643,
            "PositionLon": 121.659698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3188",
        "StopID": "3188",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.113276,
            "PositionLon": 121.66432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3189",
        "StopID": "3189",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.112041,
            "PositionLon": 121.664153
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5081",
        "StopID": "5081",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3923",
        "StopID": "3923",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.107022,
            "PositionLon": 121.665378
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3192",
        "StopID": "3192",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10516,
            "PositionLon": 121.66437
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3193",
        "StopID": "3193",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10296,
            "PositionLon": 121.665237
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3195",
        "StopID": "3195",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096613,
            "PositionLon": 121.665688
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3196",
        "StopID": "3196",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0957,
            "PositionLon": 121.666585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3197",
        "StopID": "3197",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.092968,
            "PositionLon": 121.669221
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5083",
        "StopID": "5083",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3924",
        "StopID": "3924",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.090567,
            "PositionLon": 121.667835
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5079",
        "StopID": "5079",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.155915,
            "PositionLon": 121.730344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5133",
        "StopID": "5133",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.087933,
            "PositionLon": 121.668112
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3201",
        "StopID": "3201",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.086196,
            "PositionLon": 121.67228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3203",
        "StopID": "3203",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.086496,
            "PositionLon": 121.676478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3204",
        "StopID": "3204",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.084455,
            "PositionLon": 121.683198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3209",
        "StopID": "3209",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.085123,
            "PositionLon": 121.695756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3926",
        "StopID": "3926",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.094143,
            "PositionLon": 121.701413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3213",
        "StopID": "3213",
        "StopName": {
            "Zh_tw": "六堵水廠",
            "En": "Liudu Waterworks"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.094875,
            "PositionLon": 121.702745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7022",
    "RouteID": "7022",
    "RouteName": {
        "Zh_tw": "702 友蚋-經百三街",
        "En": "702 Yourui - Via Bai 3rd St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7022",
    "SubRouteID": "7022",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-經百三街",
        "En": "702 Yourui - Via Bai 3rd St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3212",
        "StopID": "3212",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094341,
            "PositionLon": 121.701388
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1845",
        "StopID": "1845",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.086439,
            "PositionLon": 121.697929
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4503",
        "StopID": "4503",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.081858,
            "PositionLon": 121.698238
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4531",
        "StopID": "4531",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0819,
            "PositionLon": 121.696588
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1843",
        "StopID": "1843",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.081935,
            "PositionLon": 121.695628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3915",
        "StopID": "3915",
        "StopName": {
            "Zh_tw": "百福火車站(大德路)",
            "En": "Baifu Railway Station (Dade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.078429,
            "PositionLon": 121.692393
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3764",
        "StopID": "3764",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.08239,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3165",
        "StopID": "3165",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.084488,
            "PositionLon": 121.683353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3166",
        "StopID": "3166",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.08669,
            "PositionLon": 121.676491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3168",
        "StopID": "3168",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.086223,
            "PositionLon": 121.672421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5123",
        "StopID": "5123",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.087992,
            "PositionLon": 121.66823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1765",
        "StopID": "1765",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.155726,
            "PositionLon": 121.730383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3929",
        "StopID": "3929",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.090446,
            "PositionLon": 121.667845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5082",
        "StopID": "5082",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3172",
        "StopID": "3172",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09386,
            "PositionLon": 121.669246
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3173",
        "StopID": "3173",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09583,
            "PositionLon": 121.666661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3174",
        "StopID": "3174",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098248,
            "PositionLon": 121.666341
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3176",
        "StopID": "3176",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.103059,
            "PositionLon": 121.66542
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3177",
        "StopID": "3177",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.105171,
            "PositionLon": 121.664523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3931",
        "StopID": "3931",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.106882,
            "PositionLon": 121.665401
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5080",
        "StopID": "5080",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3180",
        "StopID": "3180",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.111711,
            "PositionLon": 121.664383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3181",
        "StopID": "3181",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.11316,
            "PositionLon": 121.664485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3182",
        "StopID": "3182",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.116479,
            "PositionLon": 121.659759
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5084",
        "StopID": "5084",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3184",
        "StopID": "3184",
        "StopName": {
            "Zh_tw": "內十四坑",
            "En": "Neishisikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.114049,
            "PositionLon": 121.653953
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7022",
    "RouteID": "7022",
    "RouteName": {
        "Zh_tw": "702 友蚋-經百三街",
        "En": "702 Yourui - Via Bai 3rd St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7022",
    "SubRouteID": "7022",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-經百三街",
        "En": "702 Yourui - Via Bai 3rd St."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5085",
        "StopID": "5085",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3187",
        "StopID": "3187",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.11643,
            "PositionLon": 121.659698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3188",
        "StopID": "3188",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.113276,
            "PositionLon": 121.66432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3189",
        "StopID": "3189",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.112041,
            "PositionLon": 121.664153
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5081",
        "StopID": "5081",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3923",
        "StopID": "3923",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.107022,
            "PositionLon": 121.665378
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3192",
        "StopID": "3192",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10516,
            "PositionLon": 121.66437
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3193",
        "StopID": "3193",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10296,
            "PositionLon": 121.665237
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3195",
        "StopID": "3195",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096613,
            "PositionLon": 121.665688
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3196",
        "StopID": "3196",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0957,
            "PositionLon": 121.666585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3197",
        "StopID": "3197",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.092968,
            "PositionLon": 121.669221
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5083",
        "StopID": "5083",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3924",
        "StopID": "3924",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.090567,
            "PositionLon": 121.667835
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5079",
        "StopID": "5079",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.155915,
            "PositionLon": 121.730344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5133",
        "StopID": "5133",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.087933,
            "PositionLon": 121.668112
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3201",
        "StopID": "3201",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.086196,
            "PositionLon": 121.67228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3203",
        "StopID": "3203",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.086496,
            "PositionLon": 121.676478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3204",
        "StopID": "3204",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.084455,
            "PositionLon": 121.683198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3209",
        "StopID": "3209",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.085123,
            "PositionLon": 121.695756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3926",
        "StopID": "3926",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.094143,
            "PositionLon": 121.701413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3213",
        "StopID": "3213",
        "StopName": {
            "Zh_tw": "六堵水廠",
            "En": "Liudu Waterworks"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.094875,
            "PositionLon": 121.702745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7023",
    "RouteID": "7023",
    "RouteName": {
        "Zh_tw": "702 友蚋-回經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7023",
    "SubRouteID": "7023",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-回經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3212",
        "StopID": "3212",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094341,
            "PositionLon": 121.701388
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3917",
        "StopID": "3917",
        "StopName": {
            "Zh_tw": "消防隊",
            "En": "Fire Department"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.085483,
            "PositionLon": 121.69724
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3160",
        "StopID": "3160",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.085233,
            "PositionLon": 121.695781
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1846",
        "StopID": "1846",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.0845,
            "PositionLon": 121.691966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1847",
        "StopID": "1847",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.084336,
            "PositionLon": 121.690853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1848",
        "StopID": "1848",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.082961,
            "PositionLon": 121.6886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3764",
        "StopID": "3764",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.08239,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3165",
        "StopID": "3165",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.084488,
            "PositionLon": 121.683353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3166",
        "StopID": "3166",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.08669,
            "PositionLon": 121.676491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3168",
        "StopID": "3168",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.086223,
            "PositionLon": 121.672421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5123",
        "StopID": "5123",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.087992,
            "PositionLon": 121.66823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1765",
        "StopID": "1765",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.155726,
            "PositionLon": 121.730383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3929",
        "StopID": "3929",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.090446,
            "PositionLon": 121.667845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5082",
        "StopID": "5082",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3172",
        "StopID": "3172",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09386,
            "PositionLon": 121.669246
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3173",
        "StopID": "3173",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.09583,
            "PositionLon": 121.666661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3174",
        "StopID": "3174",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.098248,
            "PositionLon": 121.666341
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3176",
        "StopID": "3176",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.103059,
            "PositionLon": 121.66542
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3177",
        "StopID": "3177",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.105171,
            "PositionLon": 121.664523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3931",
        "StopID": "3931",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.106882,
            "PositionLon": 121.665401
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5080",
        "StopID": "5080",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3180",
        "StopID": "3180",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.111711,
            "PositionLon": 121.664383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3181",
        "StopID": "3181",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.11316,
            "PositionLon": 121.664485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3182",
        "StopID": "3182",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.116479,
            "PositionLon": 121.659759
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5084",
        "StopID": "5084",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3184",
        "StopID": "3184",
        "StopName": {
            "Zh_tw": "內十四坑",
            "En": "Neishisikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.114049,
            "PositionLon": 121.653953
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7023",
    "RouteID": "7023",
    "RouteName": {
        "Zh_tw": "702 友蚋-回經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7023",
    "SubRouteID": "7023",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-回經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5085",
        "StopID": "5085",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3187",
        "StopID": "3187",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.11643,
            "PositionLon": 121.659698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3188",
        "StopID": "3188",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.113276,
            "PositionLon": 121.66432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3189",
        "StopID": "3189",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.112041,
            "PositionLon": 121.664153
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5081",
        "StopID": "5081",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3923",
        "StopID": "3923",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.107022,
            "PositionLon": 121.665378
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3192",
        "StopID": "3192",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10516,
            "PositionLon": 121.66437
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3193",
        "StopID": "3193",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10296,
            "PositionLon": 121.665237
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3195",
        "StopID": "3195",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096613,
            "PositionLon": 121.665688
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3196",
        "StopID": "3196",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0957,
            "PositionLon": 121.666585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3930",
        "StopID": "3930",
        "StopName": {
            "Zh_tw": "三合路",
            "En": "Sanhe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.093851,
            "PositionLon": 121.669068
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3197",
        "StopID": "3197",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.092968,
            "PositionLon": 121.669221
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5083",
        "StopID": "5083",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3924",
        "StopID": "3924",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.090567,
            "PositionLon": 121.667835
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5079",
        "StopID": "5079",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.155915,
            "PositionLon": 121.730344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5133",
        "StopID": "5133",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.087933,
            "PositionLon": 121.668112
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3201",
        "StopID": "3201",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.086196,
            "PositionLon": 121.67228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3203",
        "StopID": "3203",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.086496,
            "PositionLon": 121.676478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3204",
        "StopID": "3204",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.084455,
            "PositionLon": 121.683198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1772",
        "StopID": "1772",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.082891,
            "PositionLon": 121.688755
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1773",
        "StopID": "1773",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.084191,
            "PositionLon": 121.690956
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1774",
        "StopID": "1774",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.0844,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3209",
        "StopID": "3209",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.085123,
            "PositionLon": 121.695756
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3926",
        "StopID": "3926",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.094143,
            "PositionLon": 121.701413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3213",
        "StopID": "3213",
        "StopName": {
            "Zh_tw": "六堵水廠",
            "En": "Liudu Waterworks"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.094875,
            "PositionLon": 121.702745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7024",
    "RouteID": "7024",
    "RouteName": {
        "Zh_tw": "702 友蚋-去經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7024",
    "SubRouteID": "7024",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-去經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3212",
        "StopID": "3212",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.094341,
            "PositionLon": 121.701388
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1838",
        "StopID": "1838",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.087486,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3917",
        "StopID": "3917",
        "StopName": {
            "Zh_tw": "消防隊",
            "En": "Fire Department"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.085483,
            "PositionLon": 121.69724
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3160",
        "StopID": "3160",
        "StopName": {
            "Zh_tw": "百六福二街口",
            "En": "Bai 6th St. & Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.085233,
            "PositionLon": 121.695781
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1846",
        "StopID": "1846",
        "StopName": {
            "Zh_tw": "堵南國小",
            "En": "Keelung City Dunan Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.0845,
            "PositionLon": 121.691966
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1847",
        "StopID": "1847",
        "StopName": {
            "Zh_tw": "大德路",
            "En": "Dade Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.084336,
            "PositionLon": 121.690853
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1848",
        "StopID": "1848",
        "StopName": {
            "Zh_tw": "溪頭街口",
            "En": "Xitou St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.082961,
            "PositionLon": 121.6886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4509",
        "StopID": "4509",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.082633,
            "PositionLon": 121.687475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3764",
        "StopID": "3764",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.08239,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3165",
        "StopID": "3165",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.084488,
            "PositionLon": 121.683353
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3166",
        "StopID": "3166",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.08669,
            "PositionLon": 121.676491
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2132",
        "StopID": "2132",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3168",
        "StopID": "3168",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.086223,
            "PositionLon": 121.672421
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5123",
        "StopID": "5123",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.087992,
            "PositionLon": 121.66823
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1765",
        "StopID": "1765",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.155726,
            "PositionLon": 121.730383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3929",
        "StopID": "3929",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.090446,
            "PositionLon": 121.667845
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5082",
        "StopID": "5082",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3172",
        "StopID": "3172",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.09386,
            "PositionLon": 121.669246
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3922",
        "StopID": "3922",
        "StopName": {
            "Zh_tw": "三合路",
            "En": "Sanhe Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.097126,
            "PositionLon": 121.670846
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3173",
        "StopID": "3173",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.09583,
            "PositionLon": 121.666661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3174",
        "StopID": "3174",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.098248,
            "PositionLon": 121.666341
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3176",
        "StopID": "3176",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.103059,
            "PositionLon": 121.66542
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3177",
        "StopID": "3177",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.105171,
            "PositionLon": 121.664523
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3931",
        "StopID": "3931",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.106882,
            "PositionLon": 121.665401
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5080",
        "StopID": "5080",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3180",
        "StopID": "3180",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.111711,
            "PositionLon": 121.664383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3181",
        "StopID": "3181",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.11316,
            "PositionLon": 121.664485
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3182",
        "StopID": "3182",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.116479,
            "PositionLon": 121.659759
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5084",
        "StopID": "5084",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3184",
        "StopID": "3184",
        "StopName": {
            "Zh_tw": "內十四坑",
            "En": "Neishisikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.114049,
            "PositionLon": 121.653953
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7024",
    "RouteID": "7024",
    "RouteName": {
        "Zh_tw": "702 友蚋-去經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7024",
    "SubRouteID": "7024",
    "SubRouteName": {
        "Zh_tw": "702 友蚋-去經三和路",
        "En": "702 Yourui - Via Sanhe Rd."
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5085",
        "StopID": "5085",
        "StopName": {
            "Zh_tw": "靜修寺",
            "En": "Jingshiou Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.114683,
            "PositionLon": 121.65503
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3187",
        "StopID": "3187",
        "StopName": {
            "Zh_tw": "石公潭",
            "En": "Shigong Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.11643,
            "PositionLon": 121.659698
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3188",
        "StopID": "3188",
        "StopName": {
            "Zh_tw": "鹿寮",
            "En": "Luliao"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.113276,
            "PositionLon": 121.66432
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3189",
        "StopID": "3189",
        "StopName": {
            "Zh_tw": "華新二路",
            "En": "Huaxin 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.112041,
            "PositionLon": 121.664153
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5081",
        "StopID": "5081",
        "StopName": {
            "Zh_tw": "友二里民大會堂",
            "En": "Youer Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.10853,
            "PositionLon": 121.665692
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3923",
        "StopID": "3923",
        "StopName": {
            "Zh_tw": "復興國小",
            "En": "Fuxhing Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.107022,
            "PositionLon": 121.665378
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3192",
        "StopID": "3192",
        "StopName": {
            "Zh_tw": "一坑",
            "En": "Yikeng"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.10516,
            "PositionLon": 121.66437
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3193",
        "StopID": "3193",
        "StopName": {
            "Zh_tw": "友益橋",
            "En": "Youi Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.10296,
            "PositionLon": 121.665237
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3195",
        "StopID": "3195",
        "StopName": {
            "Zh_tw": "鴛鴦潭",
            "En": "Yuanyang Pond"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096613,
            "PositionLon": 121.665688
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3196",
        "StopID": "3196",
        "StopName": {
            "Zh_tw": "友愛橋",
            "En": "Youai Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0957,
            "PositionLon": 121.666585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3197",
        "StopID": "3197",
        "StopName": {
            "Zh_tw": "友諒橋",
            "En": "Youliang Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.092968,
            "PositionLon": 121.669221
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5083",
        "StopID": "5083",
        "StopName": {
            "Zh_tw": "友一里民大會堂",
            "En": "Youyi Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.09208,
            "PositionLon": 121.669059
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3924",
        "StopID": "3924",
        "StopName": {
            "Zh_tw": "綠葉山莊",
            "En": "Luyeshanzhuang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.090567,
            "PositionLon": 121.667835
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5079",
        "StopID": "5079",
        "StopName": {
            "Zh_tw": "土地廟",
            "En": "Tudi Gong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.155915,
            "PositionLon": 121.730344
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5133",
        "StopID": "5133",
        "StopName": {
            "Zh_tw": "友一社區發展協會",
            "En": "Youyi Community Development Association"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.087933,
            "PositionLon": 121.668112
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3201",
        "StopID": "3201",
        "StopName": {
            "Zh_tw": "友一里",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.086196,
            "PositionLon": 121.67228
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2121",
        "StopID": "2121",
        "StopName": {
            "Zh_tw": "藍天麗地(麗景天下)",
            "En": "Lantianlidi Community (Lijingtianxia)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.154507,
            "PositionLon": 121.696701
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3203",
        "StopID": "3203",
        "StopName": {
            "Zh_tw": "天使宮",
            "En": "Tianshi Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.086496,
            "PositionLon": 121.676478
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3204",
        "StopID": "3204",
        "StopName": {
            "Zh_tw": "真聖堂",
            "En": "Zhensheng Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.084455,
            "PositionLon": 121.683198
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3761",
        "StopID": "3761",
        "StopName": {
            "Zh_tw": "堵南加油站",
            "En": "Dunan Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.082275,
            "PositionLon": 121.685555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3762",
        "StopID": "3762",
        "StopName": {
            "Zh_tw": "特殊教育學校",
            "En": "National Keelung Special Education School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.082438,
            "PositionLon": 121.687243
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3925",
        "StopID": "3925",
        "StopName": {
            "Zh_tw": "百福火車站(大德路)",
            "En": "Baifu Railway Station (Dade Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.078325,
            "PositionLon": 121.692299
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1777",
        "StopID": "1777",
        "StopName": {
            "Zh_tw": "百三街口",
            "En": "Bai 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.08179,
            "PositionLon": 121.69637
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3920",
        "StopID": "3920",
        "StopName": {
            "Zh_tw": "福二街口",
            "En": "Fu 2nd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.081981,
            "PositionLon": 121.695678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1780",
        "StopID": "1780",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.082906,
            "PositionLon": 121.699148
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4504",
        "StopID": "4504",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.085406,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1782",
        "StopID": "1782",
        "StopName": {
            "Zh_tw": "監理站",
            "En": "Keelung Motor Vehicles Supervision Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.088155,
            "PositionLon": 121.697625
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3926",
        "StopID": "3926",
        "StopName": {
            "Zh_tw": "工建西路22號",
            "En": "No.22, Gongjian W. Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.094143,
            "PositionLon": 121.701413
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3213",
        "StopID": "3213",
        "StopName": {
            "Zh_tw": "六堵水廠",
            "En": "Liudu Waterworks"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.094875,
            "PositionLon": 121.702745
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7031",
    "RouteID": "7031",
    "RouteName": {
        "Zh_tw": "703 七堵-瑪東里",
        "En": "703 Qidu - Madong Village"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7031",
    "SubRouteID": "7031",
    "SubRouteName": {
        "Zh_tw": "703 七堵-瑪東里",
        "En": "703 Qidu - Madong Village"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2130",
        "StopID": "2130",
        "StopName": {
            "Zh_tw": "七堵分站",
            "En": "Qidu Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.097375,
            "PositionLon": 121.710168
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1792",
        "StopID": "1792",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.09662,
            "PositionLon": 121.711475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1793",
        "StopID": "1793",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.097156,
            "PositionLon": 121.712703
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3977",
        "StopID": "3977",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.098262,
            "PositionLon": 121.714067
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3951",
        "StopID": "3951",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.09922,
            "PositionLon": 121.713697
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3042",
        "StopID": "3042",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.10139,
            "PositionLon": 121.712358
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2663",
        "StopID": "2663",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.100837,
            "PositionLon": 121.710543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2612",
        "StopID": "2612",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3043",
        "StopID": "3043",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.096205,
            "PositionLon": 121.705586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3156",
        "StopID": "3156",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.09525,
            "PositionLon": 121.705868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3044",
        "StopID": "3044",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.100953,
            "PositionLon": 121.698801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3045",
        "StopID": "3045",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.101625,
            "PositionLon": 121.695973
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3046",
        "StopID": "3046",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.104831,
            "PositionLon": 121.69623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3047",
        "StopID": "3047",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.105075,
            "PositionLon": 121.69367
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3950",
        "StopID": "3950",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.105966,
            "PositionLon": 121.692338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3049",
        "StopID": "3049",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.109,
            "PositionLon": 121.691813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3949",
        "StopID": "3949",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.11094,
            "PositionLon": 121.688963
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3233",
        "StopID": "3233",
        "StopName": {
            "Zh_tw": "瑪東里",
            "En": "Madong Village"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.115476,
            "PositionLon": 121.692682
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3234",
        "StopID": "3234",
        "StopName": {
            "Zh_tw": "大同街",
            "En": "Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.11678,
            "PositionLon": 121.695513
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3235",
        "StopID": "3235",
        "StopName": {
            "Zh_tw": "自強路口",
            "En": "Ziqiang Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.116691,
            "PositionLon": 121.6987
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3171",
        "StopID": "3171",
        "StopName": {
            "Zh_tw": "舊里民大會堂",
            "En": "Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.108699,
            "PositionLon": 121.665626
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3237",
        "StopID": "3237",
        "StopName": {
            "Zh_tw": "盧厝",
            "En": "Lucuo"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.12167,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3238",
        "StopID": "3238",
        "StopName": {
            "Zh_tw": "摩天嶺",
            "En": "Motianling"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.124303,
            "PositionLon": 121.699646
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3239",
        "StopID": "3239",
        "StopName": {
            "Zh_tw": "瑪東農村社區公園",
            "En": "Madong Village Community Park"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.125536,
            "PositionLon": 121.69788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3240",
        "StopID": "3240",
        "StopName": {
            "Zh_tw": "瑪新橋",
            "En": "Maxin Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.127681,
            "PositionLon": 121.696856
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3241",
        "StopID": "3241",
        "StopName": {
            "Zh_tw": "大同街52號",
            "En": "No. 52 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.13074,
            "PositionLon": 121.693605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3242",
        "StopID": "3242",
        "StopName": {
            "Zh_tw": "大同街47號",
            "En": "No. 47 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.132576,
            "PositionLon": 121.689381
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3243",
        "StopID": "3243",
        "StopName": {
            "Zh_tw": "陳厝",
            "En": "Chencuo"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.13325,
            "PositionLon": 121.6866
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3244",
        "StopID": "3244",
        "StopName": {
            "Zh_tw": "大同街59-1號",
            "En": "No. 59-1 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.134412,
            "PositionLon": 121.686604
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3245",
        "StopID": "3245",
        "StopName": {
            "Zh_tw": "大同街63號",
            "En": "No. 63 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.681266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3246",
        "StopID": "3246",
        "StopName": {
            "Zh_tw": "大同街60號",
            "En": "No. 60 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.139316,
            "PositionLon": 121.681316
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7031",
    "RouteID": "7031",
    "RouteName": {
        "Zh_tw": "703 七堵-瑪東里",
        "En": "703 Qidu - Madong Village"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7031",
    "SubRouteID": "7031",
    "SubRouteName": {
        "Zh_tw": "703 七堵-瑪東里",
        "En": "703 Qidu - Madong Village"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3247",
        "StopID": "3247",
        "StopName": {
            "Zh_tw": "大同街60號",
            "En": "No. 60 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.139316,
            "PositionLon": 121.681316
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3248",
        "StopID": "3248",
        "StopName": {
            "Zh_tw": "大同街63號",
            "En": "No. 63 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.136008,
            "PositionLon": 121.68124
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3249",
        "StopID": "3249",
        "StopName": {
            "Zh_tw": "大同街59-1號",
            "En": "No. 59-1 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.134376,
            "PositionLon": 121.686486
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3250",
        "StopID": "3250",
        "StopName": {
            "Zh_tw": "陳厝",
            "En": "Chencuo"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.133216,
            "PositionLon": 121.687416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3251",
        "StopID": "3251",
        "StopName": {
            "Zh_tw": "大同街47號",
            "En": "No. 47 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.132576,
            "PositionLon": 121.688998
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3252",
        "StopID": "3252",
        "StopName": {
            "Zh_tw": "大同街52號",
            "En": "No. 52 Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.130736,
            "PositionLon": 121.693681
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3253",
        "StopID": "3253",
        "StopName": {
            "Zh_tw": "瑪新橋",
            "En": "Maxin Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.1277,
            "PositionLon": 121.696741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3254",
        "StopID": "3254",
        "StopName": {
            "Zh_tw": "瑪東農村社區公園",
            "En": "Madong Village Community Park"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.125616,
            "PositionLon": 121.697753
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3255",
        "StopID": "3255",
        "StopName": {
            "Zh_tw": "摩天嶺",
            "En": "Motianling"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.124158,
            "PositionLon": 121.699621
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3256",
        "StopID": "3256",
        "StopName": {
            "Zh_tw": "盧厝",
            "En": "Lucuo"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.121723,
            "PositionLon": 121.698495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3179",
        "StopID": "3179",
        "StopName": {
            "Zh_tw": "舊里民大會堂",
            "En": "Villagers Meeting Hall"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.108699,
            "PositionLon": 121.665626
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3258",
        "StopID": "3258",
        "StopName": {
            "Zh_tw": "自強路口",
            "En": "Ziqiang Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.116716,
            "PositionLon": 121.698801
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3259",
        "StopID": "3259",
        "StopName": {
            "Zh_tw": "大同街",
            "En": "Datong St."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.116838,
            "PositionLon": 121.695525
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3260",
        "StopID": "3260",
        "StopName": {
            "Zh_tw": "瑪東里",
            "En": "Madong Village"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.11554,
            "PositionLon": 121.69262
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3936",
        "StopID": "3936",
        "StopName": {
            "Zh_tw": "瑪陵國小",
            "En": "Maling Elementary school"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.110978,
            "PositionLon": 121.688985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3078",
        "StopID": "3078",
        "StopName": {
            "Zh_tw": "瑪南里",
            "En": "Manan Village"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.108925,
            "PositionLon": 121.691851
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3935",
        "StopID": "3935",
        "StopName": {
            "Zh_tw": "旭騰",
            "En": "Xuteng"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.10605,
            "PositionLon": 121.692325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3080",
        "StopID": "3080",
        "StopName": {
            "Zh_tw": "中埔",
            "En": "Zhongpu"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.105,
            "PositionLon": 121.693758
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3081",
        "StopID": "3081",
        "StopName": {
            "Zh_tw": "慶國橋",
            "En": "Qingguo Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.104866,
            "PositionLon": 121.696178
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3082",
        "StopID": "3082",
        "StopName": {
            "Zh_tw": "港口",
            "En": "Gangkou"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.101715,
            "PositionLon": 121.69596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3083",
        "StopID": "3083",
        "StopName": {
            "Zh_tw": "火炭坑",
            "En": "Huotankeng"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.100883,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3214",
        "StopID": "3214",
        "StopName": {
            "Zh_tw": "俊賢路",
            "En": "Junxian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.095411,
            "PositionLon": 121.707813
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3084",
        "StopID": "3084",
        "StopName": {
            "Zh_tw": "連柑宅",
            "En": "Lianganzhai"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.096228,
            "PositionLon": 121.705573
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2613",
        "StopID": "2613",
        "StopName": {
            "Zh_tw": "大華一路68之1號",
            "En": "No.68-1, Dahua 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.099129,
            "PositionLon": 121.706952
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2673",
        "StopID": "2673",
        "StopName": {
            "Zh_tw": "美河新都",
            "En": "Meihexindou Community"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.100863,
            "PositionLon": 121.710858
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3085",
        "StopID": "3085",
        "StopName": {
            "Zh_tw": "石厝坑",
            "En": "Shicuokeng"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.101456,
            "PositionLon": 121.712241
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3934",
        "StopID": "3934",
        "StopName": {
            "Zh_tw": "崇智公園",
            "En": "Chongzhi Park"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.099272,
            "PositionLon": 121.713646
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3978",
        "StopID": "3978",
        "StopName": {
            "Zh_tw": "七堵國小(崇智街)",
            "En": "Qidu Elementary School (Chongzhi St.)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.120533,
            "PositionLon": 121.743256
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1827",
        "StopID": "1827",
        "StopName": {
            "Zh_tw": "七堵郵局",
            "En": "Keelung Qidu Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.0973,
            "PositionLon": 121.712833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1828",
        "StopID": "1828",
        "StopName": {
            "Zh_tw": "南七堵",
            "En": "Nanqidu"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.096918,
            "PositionLon": 121.711628
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7051",
    "RouteID": "7051",
    "RouteName": {
        "Zh_tw": "705 百福車站-接駁公車",
        "En": "705 Baifu Station - Shuttle Bus"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7051",
    "SubRouteID": "7051",
    "SubRouteName": {
        "Zh_tw": "705 百福車站-接駁公車",
        "En": "705 Baifu Station - Shuttle Bus"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE3921",
        "StopID": "3921",
        "StopName": {
            "Zh_tw": "百福火車站",
            "En": "Baifu Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.078498,
            "PositionLon": 121.692261
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3919",
        "StopID": "3919",
        "StopName": {
            "Zh_tw": "福三街口",
            "En": "Fu 3rd St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.08186,
            "PositionLon": 121.698239
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1840",
        "StopID": "1840",
        "StopName": {
            "Zh_tw": "百福國中",
            "En": "Baifu Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.08311,
            "PositionLon": 121.69893
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3918",
        "StopID": "3918",
        "StopName": {
            "Zh_tw": "百六街口",
            "En": "Bai 6th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.085499,
            "PositionLon": 121.698355
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3917",
        "StopID": "3917",
        "StopName": {
            "Zh_tw": "消防隊",
            "En": "Fire Department"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.085483,
            "PositionLon": 121.69724
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3916",
        "StopID": "3916",
        "StopName": {
            "Zh_tw": "百七街口",
            "En": "Bai 7th St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.086335,
            "PositionLon": 121.694476
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1776",
        "StopID": "1776",
        "StopName": {
            "Zh_tw": "福一街口",
            "En": "Fu 1st St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.08303,
            "PositionLon": 121.69504
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE4502",
        "StopID": "4502",
        "StopName": {
            "Zh_tw": "百福宮",
            "En": "Baifu Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.081841,
            "PositionLon": 121.695475
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7061",
    "RouteID": "7061",
    "RouteName": {
        "Zh_tw": "706 自治街",
        "En": "706 Taian Rd. - Zizhi St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7061",
    "SubRouteID": "7061",
    "SubRouteName": {
        "Zh_tw": "706 自治街",
        "En": "706 Taian Rd. - Zizhi St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE5110",
        "StopID": "5110",
        "StopName": {
            "Zh_tw": "泰安路186之1號",
            "En": "No.186-1 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.07913,
            "PositionLon": 121.710819
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5111",
        "StopID": "5111",
        "StopName": {
            "Zh_tw": "泰安路130號",
            "En": "No.130 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.0853,
            "PositionLon": 121.708788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5112",
        "StopID": "5112",
        "StopName": {
            "Zh_tw": "泰安路77號",
            "En": "No.77, Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.085286,
            "PositionLon": 121.708798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5121",
        "StopID": "5121",
        "StopName": {
            "Zh_tw": "泰安里民活動中心(臨時站)",
            "En": "Taian Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.086454,
            "PositionLon": 121.711234
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5113",
        "StopID": "5113",
        "StopName": {
            "Zh_tw": "泰安公園",
            "En": "Taian Park"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.088051,
            "PositionLon": 121.709332
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5114",
        "StopID": "5114",
        "StopName": {
            "Zh_tw": "泰安路23之12號",
            "En": "No.23-12 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.089085,
            "PositionLon": 121.708603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1855",
        "StopID": "1855",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.09573,
            "PositionLon": 121.713305
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE7062",
    "RouteID": "7062",
    "RouteName": {
        "Zh_tw": "706 自治街",
        "En": "706 Taian Rd. - Zizhi St."
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE7062",
    "SubRouteID": "7062",
    "SubRouteName": {
        "Zh_tw": "706 自治街",
        "En": "706 Taian Rd. - Zizhi St."
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE1891",
        "StopID": "1891",
        "StopName": {
            "Zh_tw": "自治街",
            "En": "Zizhi St."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.096005,
            "PositionLon": 121.713113
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5115",
        "StopID": "5115",
        "StopName": {
            "Zh_tw": "泰安路23之12號",
            "En": "No.23-12 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.089085,
            "PositionLon": 121.708603
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5116",
        "StopID": "5116",
        "StopName": {
            "Zh_tw": "泰安公園",
            "En": "Taian Park"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.088051,
            "PositionLon": 121.709332
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5122",
        "StopID": "5122",
        "StopName": {
            "Zh_tw": "泰安里民活動中心(臨時站)",
            "En": "Taian Village Activity Center"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.086454,
            "PositionLon": 121.711234
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5117",
        "StopID": "5117",
        "StopName": {
            "Zh_tw": "泰安路77號",
            "En": "No.77, Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.085286,
            "PositionLon": 121.708798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5118",
        "StopID": "5118",
        "StopName": {
            "Zh_tw": "泰安路130號",
            "En": "No.130 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.0853,
            "PositionLon": 121.708788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5119",
        "StopID": "5119",
        "StopName": {
            "Zh_tw": "泰安路186之1號",
            "En": "No.186-1 Taian Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.07913,
            "PositionLon": 121.710819
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8011",
    "RouteID": "8011",
    "RouteName": {
        "Zh_tw": "801 仁愛之家-信義國中(經長庚醫院)",
        "En": "801 Renai House - Xinyi Junior High School(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8011",
    "SubRouteID": "8011",
    "SubRouteName": {
        "Zh_tw": "801 仁愛之家-信義國中(經長庚醫院)",
        "En": "801 Renai House - Xinyi Junior High School(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE401",
        "StopID": "401",
        "StopName": {
            "Zh_tw": "孝二路",
            "En": "Xiao 2nd Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.129851,
            "PositionLon": 121.740275
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1472",
        "StopID": "1472",
        "StopName": {
            "Zh_tw": "四分局",
            "En": "Fourth Police Substation"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.13233,
            "PositionLon": 121.735461
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5033",
        "StopID": "5033",
        "StopName": {
            "Zh_tw": "安樂市場",
            "En": "Anle Market"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.132045,
            "PositionLon": 121.733771
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2154",
        "StopID": "2154",
        "StopName": {
            "Zh_tw": "安樂國小",
            "En": "Anle Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132426,
            "PositionLon": 121.732518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2256",
        "StopID": "2256",
        "StopName": {
            "Zh_tw": "慈雲寺",
            "En": "Ciyun Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.132676,
            "PositionLon": 121.731083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2156",
        "StopID": "2156",
        "StopName": {
            "Zh_tw": "干城新村",
            "En": "Ganchengxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.132346,
            "PositionLon": 121.728396
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5022",
        "StopID": "5022",
        "StopName": {
            "Zh_tw": "安樂高中",
            "En": "Anle Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.133928,
            "PositionLon": 121.729475
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2158",
        "StopID": "2158",
        "StopName": {
            "Zh_tw": "仁愛之家",
            "En": "Senior Citizens Home of Compassion"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.13431,
            "PositionLon": 121.728446
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2270",
        "StopID": "2270",
        "StopName": {
            "Zh_tw": "安一路387號",
            "En": "No. 387 Anyi Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.13378,
            "PositionLon": 121.726923
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2160",
        "StopID": "2160",
        "StopName": {
            "Zh_tw": "君茂食品",
            "En": "Junmao Foodstuff"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.134966,
            "PositionLon": 121.725233
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE481",
        "StopID": "481",
        "StopName": {
            "Zh_tw": "鶯歌里(安一路口)",
            "En": "Yingge Village (An 1st Rd.)"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.135741,
            "PositionLon": 121.724203
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2198",
        "StopID": "2198",
        "StopName": {
            "Zh_tw": "新山淨水場",
            "En": "Hsinshan Water Purification Station"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.132995,
            "PositionLon": 121.72028
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3348",
        "StopID": "3348",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.127638,
            "PositionLon": 121.762725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8012",
    "RouteID": "8012",
    "RouteName": {
        "Zh_tw": "801 信義國中-經長庚醫院",
        "En": "801 Xinyi Junior High School - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8012",
    "SubRouteID": "8012",
    "SubRouteName": {
        "Zh_tw": "801 信義國中-經長庚醫院",
        "En": "801 Xinyi Junior High School - Via Changgung Memorial Hospital"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8012",
    "RouteID": "8012",
    "RouteName": {
        "Zh_tw": "801 信義國中-經長庚醫院",
        "En": "801 Xinyi Junior High School - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8012",
    "SubRouteID": "8012",
    "SubRouteName": {
        "Zh_tw": "801 信義國中-經長庚醫院",
        "En": "801 Xinyi Junior High School - Via Changgung Memorial Hospital"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1541",
        "StopID": "1541",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3907",
        "StopID": "3907",
        "StopName": {
            "Zh_tw": "仁愛區行政中心",
            "En": "Renai District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.124965,
            "PositionLon": 121.73653
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3348",
        "StopID": "3348",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127638,
            "PositionLon": 121.762725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8013",
    "RouteID": "8013",
    "RouteName": {
        "Zh_tw": "801 信義國中-基隆車站(經長庚醫院)",
        "En": "801 Xinyi Junior High School - Keelung Station(Changgung Memorial Hospital)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8013",
    "SubRouteID": "8013",
    "SubRouteName": {
        "Zh_tw": "801 信義國中-基隆車站(經長庚醫院)",
        "En": "801 Xinyi Junior High School - Keelung Station(Changgung Memorial Hospital)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE42",
        "StopID": "42",
        "StopName": {
            "Zh_tw": "公車總站(返)",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8021",
    "RouteID": "8021",
    "RouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8021",
    "SubRouteID": "8021",
    "SubRouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE469",
        "StopID": "469",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.142303,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 57,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 58,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 59,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 60,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 61,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 62,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 63,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 64,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 65,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE389",
        "StopID": "389",
        "StopName": {
            "Zh_tw": "正榮街",
            "En": "Zhengrong St."
        },
        "StopBoarding": 0,
        "StopSequence": 66,
        "StopPosition": {
            "PositionLat": 25.14632,
            "PositionLon": 121.762495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE390",
        "StopID": "390",
        "StopName": {
            "Zh_tw": "正濱國中",
            "En": "Zhengbin Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 67,
        "StopPosition": {
            "PositionLat": 25.145766,
            "PositionLon": 121.762833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE391",
        "StopID": "391",
        "StopName": {
            "Zh_tw": "三軍總醫院基隆分院",
            "En": "Tri-Service General Hospital of Keelung"
        },
        "StopBoarding": 0,
        "StopSequence": 68,
        "StopPosition": {
            "PositionLat": 25.144528,
            "PositionLon": 121.762738
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE392",
        "StopID": "392",
        "StopName": {
            "Zh_tw": "建心新城",
            "En": "Jianxinxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 69,
        "StopPosition": {
            "PositionLat": 25.142248,
            "PositionLon": 121.763673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 70,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 71,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 72,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 73,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 74,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 75,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 76,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 77,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 78,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 79,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 80,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 81,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 82,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 83,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 84,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 85,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 86,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 87,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 88,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 89,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8021",
    "RouteID": "8021",
    "RouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8021",
    "SubRouteID": "8021",
    "SubRouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1541",
        "StopID": "1541",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3907",
        "StopID": "3907",
        "StopName": {
            "Zh_tw": "仁愛區行政中心",
            "En": "Renai District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.124965,
            "PositionLon": 121.73653
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE39",
        "StopID": "39",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.14076,
            "PositionLon": 121.760331
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE187",
        "StopID": "187",
        "StopName": {
            "Zh_tw": "八斗子車站(返)",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8022",
    "RouteID": "8022",
    "RouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8022",
    "SubRouteID": "8022",
    "SubRouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE469",
        "StopID": "469",
        "StopName": {
            "Zh_tw": "潮境公園",
            "En": "Chaojing Park"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.142303,
            "PositionLon": 121.802175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE114",
        "StopID": "114",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.139725,
            "PositionLon": 121.796351
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5056",
        "StopID": "5056",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.09979,
            "PositionLon": 121.73661
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5058",
        "StopID": "5058",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.104538,
            "PositionLon": 121.738585
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE117",
        "StopID": "117",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.144581,
            "PositionLon": 121.785765
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE118",
        "StopID": "118",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.14629,
            "PositionLon": 121.783666
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3473",
        "StopID": "3473",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.148309,
            "PositionLon": 121.783012
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE120",
        "StopID": "120",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.1506,
            "PositionLon": 121.77996
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE121",
        "StopID": "121",
        "StopName": {
            "Zh_tw": "海大濱海校門(一)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.15097,
            "PositionLon": 121.77555
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE122",
        "StopID": "122",
        "StopName": {
            "Zh_tw": "海大祥豐校門(二)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.151159,
            "PositionLon": 121.773208
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE65",
        "StopID": "65",
        "StopName": {
            "Zh_tw": "海大中正路口",
            "En": "National Taiwan Ocean University (Zhongzheng Rd. Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.15118,
            "PositionLon": 121.771957
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE64",
        "StopID": "64",
        "StopName": {
            "Zh_tw": "中正路正濱路口",
            "En": "Zhongzheng & Zhengbin Rd.Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.151616,
            "PositionLon": 121.7708
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE47",
        "StopID": "47",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.152033,
            "PositionLon": 121.770283
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE62",
        "StopID": "62",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.153018,
            "PositionLon": 121.769586
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE54",
        "StopID": "54",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3518",
        "StopID": "3518",
        "StopName": {
            "Zh_tw": "和平國小(佛祖廟)",
            "En": "Heping Elementary School (Buddha Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.155279,
            "PositionLon": 121.7658
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3519",
        "StopID": "3519",
        "StopName": {
            "Zh_tw": "和平島公園",
            "En": "Heping Island Park"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.15635,
            "PositionLon": 121.764786
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE6",
        "StopID": "6",
        "StopName": {
            "Zh_tw": "和平島",
            "En": "Heping Island"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.15495,
            "PositionLon": 121.764883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE7",
        "StopID": "7",
        "StopName": {
            "Zh_tw": "協同造船廠",
            "En": "Xietong Shipyard"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.154903,
            "PositionLon": 121.765886
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE8",
        "StopID": "8",
        "StopName": {
            "Zh_tw": "社寮里(天顯宮)",
            "En": "Sheliao Village (Tianxian Temple)"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.15484,
            "PositionLon": 121.767346
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE48",
        "StopID": "48",
        "StopName": {
            "Zh_tw": "和平橋頭(原民會館)",
            "En": "Heping Bridge (Keelung City Indigenous Cultural Hall)"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.152938,
            "PositionLon": 121.769868
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE10",
        "StopID": "10",
        "StopName": {
            "Zh_tw": "正濱路口",
            "En": "Zhengbin Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.152413,
            "PositionLon": 121.770265
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE11",
        "StopID": "11",
        "StopName": {
            "Zh_tw": "正濱派出所",
            "En": "Zhengbin Police Office"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.1521,
            "PositionLon": 121.767916
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE12",
        "StopID": "12",
        "StopName": {
            "Zh_tw": "二信分社",
            "En": "The Second Credit Cooperative of Keelung Branch"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.151173,
            "PositionLon": 121.76709
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE13",
        "StopID": "13",
        "StopName": {
            "Zh_tw": "漁市場",
            "En": "Seafood Markets"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.150685,
            "PositionLon": 121.76576
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE14",
        "StopID": "14",
        "StopName": {
            "Zh_tw": "中濱里",
            "En": "Zhongbin Village"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.149376,
            "PositionLon": 121.763711
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3474",
        "StopID": "3474",
        "StopName": {
            "Zh_tw": "海調處",
            "En": "Marine Affairs Field Office"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.147451,
            "PositionLon": 121.761597
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3475",
        "StopID": "3475",
        "StopName": {
            "Zh_tw": "公教國宅",
            "En": "Government Employees Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.145497,
            "PositionLon": 121.761499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE389",
        "StopID": "389",
        "StopName": {
            "Zh_tw": "正榮街",
            "En": "Zhengrong St."
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.14632,
            "PositionLon": 121.762495
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE390",
        "StopID": "390",
        "StopName": {
            "Zh_tw": "正濱國中",
            "En": "Zhengbin Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.145766,
            "PositionLon": 121.762833
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE391",
        "StopID": "391",
        "StopName": {
            "Zh_tw": "三軍總醫院基隆分院",
            "En": "Tri-Service General Hospital of Keelung"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.144528,
            "PositionLon": 121.762738
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE392",
        "StopID": "392",
        "StopName": {
            "Zh_tw": "建心新城",
            "En": "Jianxinxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.142248,
            "PositionLon": 121.763673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE72",
        "StopID": "72",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.141283,
            "PositionLon": 121.761715
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE18",
        "StopID": "18",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.141083,
            "PositionLon": 121.758988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE19",
        "StopID": "19",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.140876,
            "PositionLon": 121.7563
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE20",
        "StopID": "20",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.13935,
            "PositionLon": 121.75401599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE22",
        "StopID": "22",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.137598,
            "PositionLon": 121.75072
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE23",
        "StopID": "23",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.1365,
            "PositionLon": 121.74798
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE24",
        "StopID": "24",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.135031,
            "PositionLon": 121.746968
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE25",
        "StopID": "25",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.132476,
            "PositionLon": 121.745278
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 45,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 46,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 47,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 48,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 49,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 50,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 51,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 52,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 53,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 54,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 55,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 56,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8022",
    "RouteID": "8022",
    "RouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8022",
    "SubRouteID": "8022",
    "SubRouteName": {
        "Zh_tw": "802 八斗子-經長庚醫院",
        "En": "802 Badouzi - Via Changgung Memorial Hospital"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1540",
        "StopID": "1540",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE30",
        "StopID": "30",
        "StopName": {
            "Zh_tw": "市政府(柯達飯店)",
            "En": "Keelung City Government (K Hotel)"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.132,
            "PositionLon": 121.744985
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE31",
        "StopID": "31",
        "StopName": {
            "Zh_tw": "信五路口",
            "En": "Xin 5th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.134185,
            "PositionLon": 121.746636
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE32",
        "StopID": "32",
        "StopName": {
            "Zh_tw": "信七路口",
            "En": "Xin 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.135875,
            "PositionLon": 121.747736
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE33",
        "StopID": "33",
        "StopName": {
            "Zh_tw": "就業中心",
            "En": "Keelung Employment Service Station"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.137223,
            "PositionLon": 121.74894
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE34",
        "StopID": "34",
        "StopName": {
            "Zh_tw": "中船路",
            "En": "Zhongchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.137353,
            "PositionLon": 121.75095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE35",
        "StopID": "35",
        "StopName": {
            "Zh_tw": "北屋新城",
            "En": "Beiwuxincheng"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.139078,
            "PositionLon": 121.752025
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE36",
        "StopID": "36",
        "StopName": {
            "Zh_tw": "復興館",
            "En": "Fuxingguan"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.13937,
            "PositionLon": 121.754073
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE37",
        "StopID": "37",
        "StopName": {
            "Zh_tw": "海門天險",
            "En": "Haimentiansian"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.140736,
            "PositionLon": 121.756108
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE38",
        "StopID": "38",
        "StopName": {
            "Zh_tw": "中正區行政大樓(公車處)",
            "En": "Administration Building of Zhongzheng District (KLCBA)"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.140603,
            "PositionLon": 121.758783
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE39",
        "StopID": "39",
        "StopName": {
            "Zh_tw": "安瀾橋",
            "En": "Anlan Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.14076,
            "PositionLon": 121.760331
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE95",
        "StopID": "95",
        "StopName": {
            "Zh_tw": "天主堂",
            "En": "Church"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.141141,
            "PositionLon": 121.761548
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE96",
        "StopID": "96",
        "StopName": {
            "Zh_tw": "祥豐市場",
            "En": "Xiangfeng Market"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.141946,
            "PositionLon": 121.764081
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE97",
        "StopID": "97",
        "StopName": {
            "Zh_tw": "祥豐加油站",
            "En": "Xiangfeng Gas Station"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.14327,
            "PositionLon": 121.765487
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE98",
        "StopID": "98",
        "StopName": {
            "Zh_tw": "二信中學",
            "En": "Erxin High School"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.14476,
            "PositionLon": 121.767806
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE99",
        "StopID": "99",
        "StopName": {
            "Zh_tw": "正濱國小",
            "En": "Zhengbin Elementary School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.146438,
            "PositionLon": 121.770213
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE100",
        "StopID": "100",
        "StopName": {
            "Zh_tw": "市府宿舍",
            "En": "Keelung City Dormitory"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.147943,
            "PositionLon": 121.771071
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE101",
        "StopID": "101",
        "StopName": {
            "Zh_tw": "基隆海事",
            "En": "National Keelung Maritime Vocational School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.14923,
            "PositionLon": 121.771608
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE163",
        "StopID": "163",
        "StopName": {
            "Zh_tw": "海大祥豐校門(一)",
            "En": "National Taiwan Ocean University (Xiangfeng School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.151029,
            "PositionLon": 121.772842
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE164",
        "StopID": "164",
        "StopName": {
            "Zh_tw": "海大濱海校門(二)",
            "En": "National Taiwan Ocean University (Binha School Intersection)"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.150829,
            "PositionLon": 121.77565
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE165",
        "StopID": "165",
        "StopName": {
            "Zh_tw": "海大體育館",
            "En": "National Taiwan Ocean University (The Gymnasium)"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.150539,
            "PositionLon": 121.779602
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3479",
        "StopID": "3479",
        "StopName": {
            "Zh_tw": "北寧路(九八八餐廳)",
            "En": "Beining Rd. (988 Restaurant)"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.1483,
            "PositionLon": 121.78289
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE167",
        "StopID": "167",
        "StopName": {
            "Zh_tw": "藍投溝",
            "En": "Lantougou"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.146516,
            "PositionLon": 121.783448
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE168",
        "StopID": "168",
        "StopName": {
            "Zh_tw": "漁貨直銷中心(碧砂漁港)",
            "En": "Taiwan Tourist Seafood Markets (Bisha Fish Harbor)"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.144315,
            "PositionLon": 121.785803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5059",
        "StopID": "5059",
        "StopName": {
            "Zh_tw": "義胞新村",
            "En": "Yibaoxincun"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.104368,
            "PositionLon": 121.738623
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5057",
        "StopID": "5057",
        "StopName": {
            "Zh_tw": "嶺林巷",
            "En": "Linglinxiang"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.099279,
            "PositionLon": 121.737052
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE187",
        "StopID": "187",
        "StopName": {
            "Zh_tw": "八斗子車站(返)",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8031",
    "RouteID": "8031",
    "RouteName": {
        "Zh_tw": "803 八斗子-經長庚醫院(經信義國中)",
        "En": "803 Badouzi - Via Changgung Memorial Hospital(Xinyi Junior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8031",
    "SubRouteID": "8031",
    "SubRouteName": {
        "Zh_tw": "803 八斗子-經長庚醫院(經信義國中)",
        "En": "803 Badouzi - Via Changgung Memorial Hospital(Xinyi Junior High School)"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE177",
        "StopID": "177",
        "StopName": {
            "Zh_tw": "八斗子車站",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE112",
        "StopID": "112",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.137086,
            "PositionLon": 121.800553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE113",
        "StopID": "113",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.140251,
            "PositionLon": 121.799948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE405",
        "StopID": "405",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.139198,
            "PositionLon": 121.796171
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE406",
        "StopID": "406",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.137366,
            "PositionLon": 121.796325
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE407",
        "StopID": "407",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.136028,
            "PositionLon": 121.795673
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE408",
        "StopID": "408",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.137938,
            "PositionLon": 121.78972
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE241",
        "StopID": "241",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.13618,
            "PositionLon": 121.78746
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE301",
        "StopID": "301",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.13537,
            "PositionLon": 121.785499
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE302",
        "StopID": "302",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.135259,
            "PositionLon": 121.784439
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE801",
        "StopID": "801",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.133053,
            "PositionLon": 121.782411
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE416",
        "StopID": "416",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.131799,
            "PositionLon": 121.78202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE417",
        "StopID": "417",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.77948
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE418",
        "StopID": "418",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.128353,
            "PositionLon": 121.776126
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE419",
        "StopID": "419",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.128743,
            "PositionLon": 121.773311
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE420",
        "StopID": "420",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.127936,
            "PositionLon": 121.768063
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE421",
        "StopID": "421",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.127421,
            "PositionLon": 121.766195
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE422",
        "StopID": "422",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.128196,
            "PositionLon": 121.764376
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE423",
        "StopID": "423",
        "StopName": {
            "Zh_tw": "東明市場",
            "En": "Dongming Market"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128146,
            "PositionLon": 121.763211
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE424",
        "StopID": "424",
        "StopName": {
            "Zh_tw": "市立醫院",
            "En": "Keelung City Municipal Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.761036
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE28",
        "StopID": "28",
        "StopName": {
            "Zh_tw": "公車總站",
            "En": "Keelung City Bus Station"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.132406,
            "PositionLon": 121.740307
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1811",
        "StopID": "1811",
        "StopName": {
            "Zh_tw": "城隍廟",
            "En": "Chenghuang Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.131096,
            "PositionLon": 121.740415
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2351",
        "StopID": "2351",
        "StopName": {
            "Zh_tw": "忠四路",
            "En": "Zhong 4th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.128031,
            "PositionLon": 121.739596
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2081",
        "StopID": "2081",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.12885,
            "PositionLon": 121.736416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3958",
        "StopID": "3958",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.129291,
            "PositionLon": 121.735095
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2077",
        "StopID": "2077",
        "StopName": {
            "Zh_tw": "老大公廟",
            "En": "Laodagong Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.128869,
            "PositionLon": 121.733406
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2083",
        "StopID": "2083",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2084",
        "StopID": "2084",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.122336,
            "PositionLon": 121.725131
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3960",
        "StopID": "3960",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.121549,
            "PositionLon": 121.724202
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2086",
        "StopID": "2086",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.120786,
            "PositionLon": 121.723518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2087",
        "StopID": "2087",
        "StopName": {
            "Zh_tw": "長庚醫院",
            "En": "Keelung City Zhanggeng Memorial Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.12109,
            "PositionLon": 121.721803
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2088",
        "StopID": "2088",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.125108,
            "PositionLon": 121.719718
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5011",
        "StopID": "5011",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.12742,
            "PositionLon": 121.719436
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2094",
        "StopID": "2094",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.129138,
            "PositionLon": 121.720216
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3717",
        "StopID": "3717",
        "StopName": {
            "Zh_tw": "涵悅社區",
            "En": "Hanyue Community"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.130288,
            "PositionLon": 121.722356
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5000",
        "StopID": "5000",
        "StopName": {
            "Zh_tw": "大潤發",
            "En": "RT-Mart"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.130657,
            "PositionLon": 121.723232
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3716",
        "StopID": "3716",
        "StopName": {
            "Zh_tw": "涵悅社區",
            "En": "Hanyue Community"
        },
        "StopBoarding": 0,
        "StopSequence": 44,
        "StopPosition": {
            "PositionLat": 25.130288,
            "PositionLon": 121.722356
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE8031",
    "RouteID": "8031",
    "RouteName": {
        "Zh_tw": "803 八斗子-經長庚醫院(經信義國中)",
        "En": "803 Badouzi - Via Changgung Memorial Hospital(Xinyi Junior High School)"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE8031",
    "SubRouteID": "8031",
    "SubRouteName": {
        "Zh_tw": "803 八斗子-經長庚醫院(經信義國中)",
        "En": "803 Badouzi - Via Changgung Memorial Hospital(Xinyi Junior High School)"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE2060",
        "StopID": "2060",
        "StopName": {
            "Zh_tw": "安和二街",
            "En": "Anhe 2nd St."
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.12925,
            "PositionLon": 121.720033
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE5003",
        "StopID": "5003",
        "StopName": {
            "Zh_tw": "麥金路樂利三街口",
            "En": "Maijin & Leli 3rd St. Intetsection"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.127529,
            "PositionLon": 121.719543
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2066",
        "StopID": "2066",
        "StopName": {
            "Zh_tw": "婦幼福利中心",
            "En": "Women and Children Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.124969,
            "PositionLon": 121.719741
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2067",
        "StopID": "2067",
        "StopName": {
            "Zh_tw": "長庚醫院(橘郡社區)",
            "En": "Keelung City Zhanggeng Memorial Hospital (Jujun Community)"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.121013,
            "PositionLon": 121.721816
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2048",
        "StopID": "2048",
        "StopName": {
            "Zh_tw": "安樂區行政大樓",
            "En": "Administration Building of Anle District"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12093,
            "PositionLon": 121.723583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3604",
        "StopID": "3604",
        "StopName": {
            "Zh_tw": "安樂郵局",
            "En": "Anle Post Office"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.122163,
            "PositionLon": 121.724844
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2050",
        "StopID": "2050",
        "StopName": {
            "Zh_tw": "電信大樓",
            "En": "Telecommunication Building"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.122753,
            "PositionLon": 121.725656
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE2051",
        "StopID": "2051",
        "StopName": {
            "Zh_tw": "自強隧道口",
            "En": "Ziqiang Tunnel"
        },
        "StopBoarding": 0,
        "StopSequence": 8,
        "StopPosition": {
            "PositionLat": 25.127712,
            "PositionLon": 121.73255
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3605",
        "StopID": "3605",
        "StopName": {
            "Zh_tw": "國軍福利中心",
            "En": "Military Welfare Center"
        },
        "StopBoarding": 0,
        "StopSequence": 9,
        "StopPosition": {
            "PositionLat": 25.129248,
            "PositionLon": 121.734988
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1539",
        "StopID": "1539",
        "StopName": {
            "Zh_tw": "光華國宅",
            "En": "Guanghua Public Housing"
        },
        "StopBoarding": 0,
        "StopSequence": 10,
        "StopPosition": {
            "PositionLat": 25.128476,
            "PositionLon": 121.736678
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE1541",
        "StopID": "1541",
        "StopName": {
            "Zh_tw": "成功市場",
            "En": "Chenggong Market"
        },
        "StopBoarding": 0,
        "StopSequence": 11,
        "StopPosition": {
            "PositionLat": 25.127383,
            "PositionLon": 121.73740599999999
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE868",
        "StopID": "868",
        "StopName": {
            "Zh_tw": "仁五路(東和大樓)",
            "En": "Ren 5th Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 12,
        "StopPosition": {
            "PositionLat": 25.127423,
            "PositionLon": 121.740671
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE27",
        "StopID": "27",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)(返)",
            "En": "Ren 2nd Rd.(Erxin Loop Station)"
        },
        "StopBoarding": 0,
        "StopSequence": 13,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE41",
        "StopID": "41",
        "StopName": {
            "Zh_tw": "基隆市政府",
            "En": "Keelung City Government"
        },
        "StopBoarding": 0,
        "StopSequence": 14,
        "StopPosition": {
            "PositionLat": 25.131453,
            "PositionLon": 121.745104
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE939",
        "StopID": "939",
        "StopName": {
            "Zh_tw": "衛生福利部基隆醫院",
            "En": "Ministry of Health and Welfare - Keelung Hospital"
        },
        "StopBoarding": 0,
        "StopSequence": 15,
        "StopPosition": {
            "PositionLat": 25.130225,
            "PositionLon": 121.747775
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE940",
        "StopID": "940",
        "StopName": {
            "Zh_tw": "信義區公所",
            "En": "Sinyi District Office"
        },
        "StopBoarding": 0,
        "StopSequence": 16,
        "StopPosition": {
            "PositionLat": 25.129626,
            "PositionLon": 121.750885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE941",
        "StopID": "941",
        "StopName": {
            "Zh_tw": "崇右影藝科技大學",
            "En": "Chungyu University of Film and Arts"
        },
        "StopBoarding": 0,
        "StopSequence": 17,
        "StopPosition": {
            "PositionLat": 25.129345,
            "PositionLon": 121.75333
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE942",
        "StopID": "942",
        "StopName": {
            "Zh_tw": "市立體育館",
            "En": "Keelung City Gymnasium"
        },
        "StopBoarding": 0,
        "StopSequence": 18,
        "StopPosition": {
            "PositionLat": 25.129126,
            "PositionLon": 121.755403
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE874",
        "StopID": "874",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 19,
        "StopPosition": {
            "PositionLat": 25.128483,
            "PositionLon": 121.7595
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE441",
        "StopID": "441",
        "StopName": {
            "Zh_tw": "光華巷口",
            "En": "Guanghua Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 20,
        "StopPosition": {
            "PositionLat": 25.127781,
            "PositionLon": 121.760408
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3348",
        "StopID": "3348",
        "StopName": {
            "Zh_tw": "東橋",
            "En": "Dong Bridge"
        },
        "StopBoarding": 0,
        "StopSequence": 21,
        "StopPosition": {
            "PositionLat": 25.127638,
            "PositionLon": 121.762725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE443",
        "StopID": "443",
        "StopName": {
            "Zh_tw": "地方法院",
            "En": "Taiwan Keelung District Court"
        },
        "StopBoarding": 0,
        "StopSequence": 22,
        "StopPosition": {
            "PositionLat": 25.128088,
            "PositionLon": 121.76416
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE444",
        "StopID": "444",
        "StopName": {
            "Zh_tw": "東光市場",
            "En": "Dongguang Market"
        },
        "StopBoarding": 0,
        "StopSequence": 23,
        "StopPosition": {
            "PositionLat": 25.127508,
            "PositionLon": 121.765605
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE445",
        "StopID": "445",
        "StopName": {
            "Zh_tw": "信義國中",
            "En": "Sinyi Junior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 24,
        "StopPosition": {
            "PositionLat": 25.127838,
            "PositionLon": 121.76805
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE446",
        "StopID": "446",
        "StopName": {
            "Zh_tw": "韋昌嶺",
            "En": "Weichang Mountain"
        },
        "StopBoarding": 0,
        "StopSequence": 25,
        "StopPosition": {
            "PositionLat": 25.129366,
            "PositionLon": 121.77185
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE447",
        "StopID": "447",
        "StopName": {
            "Zh_tw": "培德工家",
            "En": "Peide Industrial and Commercial High School"
        },
        "StopBoarding": 0,
        "StopSequence": 26,
        "StopPosition": {
            "PositionLat": 25.128978,
            "PositionLon": 121.772838
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE448",
        "StopID": "448",
        "StopName": {
            "Zh_tw": "太陽宮廟",
            "En": "The Sun Palace Temple"
        },
        "StopBoarding": 0,
        "StopSequence": 27,
        "StopPosition": {
            "PositionLat": 25.127933,
            "PositionLon": 121.774733
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE449",
        "StopID": "449",
        "StopName": {
            "Zh_tw": "住安城堡社區",
            "En": "Zhuan Castle Community"
        },
        "StopBoarding": 0,
        "StopSequence": 28,
        "StopPosition": {
            "PositionLat": 25.127966,
            "PositionLon": 121.777083
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE450",
        "StopID": "450",
        "StopName": {
            "Zh_tw": "孝東路",
            "En": "Xiaodong Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 29,
        "StopPosition": {
            "PositionLat": 25.128333,
            "PositionLon": 121.780018
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE451",
        "StopID": "451",
        "StopName": {
            "Zh_tw": "麗景江山社區",
            "En": "Lijingjiangshan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 30,
        "StopPosition": {
            "PositionLat": 25.13149,
            "PositionLon": 121.78186
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE838",
        "StopID": "838",
        "StopName": {
            "Zh_tw": "第一特獎社區",
            "En": "Diyitejiang Community"
        },
        "StopBoarding": 0,
        "StopSequence": 31,
        "StopPosition": {
            "PositionLat": 25.132913,
            "PositionLon": 121.782348
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3493",
        "StopID": "3493",
        "StopName": {
            "Zh_tw": "又一村",
            "En": "Youyi Village"
        },
        "StopBoarding": 0,
        "StopSequence": 32,
        "StopPosition": {
            "PositionLat": 25.134318,
            "PositionLon": 121.782584
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE239",
        "StopID": "239",
        "StopName": {
            "Zh_tw": "海中天社區",
            "En": "Haizhongtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 33,
        "StopPosition": {
            "PositionLat": 25.13516,
            "PositionLon": 121.784553
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE240",
        "StopID": "240",
        "StopName": {
            "Zh_tw": "巴賽隆納社區",
            "En": "Baselongna Community"
        },
        "StopBoarding": 0,
        "StopSequence": 34,
        "StopPosition": {
            "PositionLat": 25.13536,
            "PositionLon": 121.785827
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE300",
        "StopID": "300",
        "StopName": {
            "Zh_tw": "碧海擎天社區",
            "En": "Bihaiqingtian Community"
        },
        "StopBoarding": 0,
        "StopSequence": 35,
        "StopPosition": {
            "PositionLat": 25.136209,
            "PositionLon": 121.787757
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE460",
        "StopID": "460",
        "StopName": {
            "Zh_tw": "和豐新豐街口",
            "En": "Hefong St. & Xinfong St. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 36,
        "StopPosition": {
            "PositionLat": 25.137713,
            "PositionLon": 121.78848
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE461",
        "StopID": "461",
        "StopName": {
            "Zh_tw": "山海觀社區",
            "En": "Shanhaiguan Community"
        },
        "StopBoarding": 0,
        "StopSequence": 37,
        "StopPosition": {
            "PositionLat": 25.136563,
            "PositionLon": 121.794725
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE462",
        "StopID": "462",
        "StopName": {
            "Zh_tw": "調和街",
            "En": "Diaohe St."
        },
        "StopBoarding": 0,
        "StopSequence": 38,
        "StopPosition": {
            "PositionLat": 25.136998,
            "PositionLon": 121.796518
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE463",
        "StopID": "463",
        "StopName": {
            "Zh_tw": "調和市場",
            "En": "Diaohe Market"
        },
        "StopBoarding": 0,
        "StopSequence": 39,
        "StopPosition": {
            "PositionLat": 25.138661,
            "PositionLon": 121.796338
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE171",
        "StopID": "171",
        "StopName": {
            "Zh_tw": "八斗子",
            "En": "Badouzi"
        },
        "StopBoarding": 0,
        "StopSequence": 40,
        "StopPosition": {
            "PositionLat": 25.139535,
            "PositionLon": 121.795761
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE172",
        "StopID": "172",
        "StopName": {
            "Zh_tw": "海科館(碧水巷)",
            "En": "National Museum Of Marine Science & Technology (Bishuixiang)"
        },
        "StopBoarding": 0,
        "StopSequence": 41,
        "StopPosition": {
            "PositionLat": 25.140145,
            "PositionLon": 121.80005
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE173",
        "StopID": "173",
        "StopName": {
            "Zh_tw": "望海巷",
            "En": "Wanghaixiang"
        },
        "StopBoarding": 0,
        "StopSequence": 42,
        "StopPosition": {
            "PositionLat": 25.137508,
            "PositionLon": 121.801906
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE187",
        "StopID": "187",
        "StopName": {
            "Zh_tw": "八斗子車站(返)",
            "En": "Badouzi Railway Station"
        },
        "StopBoarding": 0,
        "StopSequence": 43,
        "StopPosition": {
            "PositionLat": 25.136582,
            "PositionLon": 121.801954
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE9661",
    "RouteID": "9661",
    "RouteName": {
        "Zh_tw": "966 田寮河接駁車",
        "En": "966 Tianliao River Shuttle Bus"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE9661",
    "SubRouteID": "9661",
    "SubRouteName": {
        "Zh_tw": "966 田寮河接駁車",
        "En": "966 Tianliao River Shuttle Bus"
    },
    "Direction": 0,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE414",
        "StopID": "414",
        "StopName": {
            "Zh_tw": "六合停車場",
            "En": "Liuhe parking lot"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.127857,
            "PositionLon": 121.758479
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE425",
        "StopID": "425",
        "StopName": {
            "Zh_tw": "基隆女中",
            "En": "National Keelung Girls` Senior High School"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.128583,
            "PositionLon": 121.758885
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE426",
        "StopID": "426",
        "StopName": {
            "Zh_tw": "義九路口",
            "En": "Yi 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128506,
            "PositionLon": 121.755788
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE872",
        "StopID": "872",
        "StopName": {
            "Zh_tw": "義七路口",
            "En": "Yi 7th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.129381,
            "PositionLon": 121.753266
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3489",
        "StopID": "3489",
        "StopName": {
            "Zh_tw": "義六路口",
            "En": "Yi 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.128586,
            "PositionLon": 121.750706
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE429",
        "StopID": "429",
        "StopName": {
            "Zh_tw": "義四路口",
            "En": "Yi 4th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.128961,
            "PositionLon": 121.747723
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE430",
        "StopID": "430",
        "StopName": {
            "Zh_tw": "義二路口",
            "En": "Yi 2nd Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.129801,
            "PositionLon": 121.746175
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}, {
    "RouteUID": "KEE9661",
    "RouteID": "9661",
    "RouteName": {
        "Zh_tw": "966 田寮河接駁車",
        "En": "966 Tianliao River Shuttle Bus"
    },
    "Operators": [{
        "OperatorID": "1000",
        "OperatorName": {
            "Zh_tw": "基隆公車",
            "En": "Keelung City Bus Management Office"
        },
        "OperatorCode": "KeelungBusOffice",
        "OperatorNo": "1107"
    }],
    "SubRouteUID": "KEE9661",
    "SubRouteID": "9661",
    "SubRouteName": {
        "Zh_tw": "966 田寮河接駁車",
        "En": "966 Tianliao River Shuttle Bus"
    },
    "Direction": 1,
    "City": "Keelung",
    "CityCode": "KEE",
    "Stops": [{
        "StopUID": "KEE26",
        "StopID": "26",
        "StopName": {
            "Zh_tw": "仁二路(二信循環站)",
            "En": "Ren 2nd Rd. (Erxin Loop Station )"
        },
        "StopBoarding": 0,
        "StopSequence": 1,
        "StopPosition": {
            "PositionLat": 25.129771,
            "PositionLon": 121.743128
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3490",
        "StopID": "3490",
        "StopName": {
            "Zh_tw": "電力公司",
            "En": "Taiwan Power Company of Keelung City"
        },
        "StopBoarding": 0,
        "StopSequence": 2,
        "StopPosition": {
            "PositionLat": 25.129606,
            "PositionLon": 121.74556
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE3491",
        "StopID": "3491",
        "StopName": {
            "Zh_tw": "愛六路口",
            "En": "Ai 6th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 3,
        "StopPosition": {
            "PositionLat": 25.128675,
            "PositionLon": 121.747583
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE437",
        "StopID": "437",
        "StopName": {
            "Zh_tw": "劉銘傳路口",
            "En": "Liumingchuan Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 4,
        "StopPosition": {
            "PositionLat": 25.128033,
            "PositionLon": 121.751383
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE438",
        "StopID": "438",
        "StopName": {
            "Zh_tw": "愛九路口",
            "En": "Ai 9th Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 5,
        "StopPosition": {
            "PositionLat": 25.12785,
            "PositionLon": 121.753133
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE439",
        "StopID": "439",
        "StopName": {
            "Zh_tw": "仁一路27號",
            "En": "No.27, Ren 1st Rd."
        },
        "StopBoarding": 0,
        "StopSequence": 6,
        "StopPosition": {
            "PositionLat": 25.127983,
            "PositionLon": 121.755883
        },
        "LocationCityCode": "KEE"
    }, {
        "StopUID": "KEE440",
        "StopID": "440",
        "StopName": {
            "Zh_tw": "月眉路口",
            "En": "Yuemei Rd. Intersection"
        },
        "StopBoarding": 0,
        "StopSequence": 7,
        "StopPosition": {
            "PositionLat": 25.12795,
            "PositionLon": 121.75755
        },
        "LocationCityCode": "KEE"
    }],
    "UpdateTime": "2019-05-15T08:07:55+08:00",
    "VersionID": 714
}]

export default {
    keelungBus
}


// WEBPACK FOOTER //
// ./src/data/keelungBus.js